/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout.route'
import { Route as DeactivatedRouteImport } from './routes/deactivated.route'
import { Route as AppRouteImport } from './routes/app.route'
import { Route as IndexRouteImport } from './routes/index.route'
import { Route as AppIndexRouteImport } from './routes/app/index.route'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as AppTabletImport } from './routes/app/tablet'
import { Route as AppRegulatoryRouteImport } from './routes/app/regulatory.route'
import { Route as AppOrdersRouteImport } from './routes/app/orders.route'
import { Route as AppCompanyRouteImport } from './routes/app/company.route'
import { Route as AppWarehouseReceivingIndexImport } from './routes/app/warehouse-receiving/index'
import { Route as AppProductsIndexImport } from './routes/app/products/index'
import { Route as AppProcurementIndexImport } from './routes/app/procurement/index'
import { Route as AppPricingIndexImport } from './routes/app/pricing/index'
import { Route as AppInventoryIndexImport } from './routes/app/inventory/index'
import { Route as AppDashboardIndexImport } from './routes/app/dashboard/index'
import { Route as AppCompaniesIndexImport } from './routes/app/companies/index'
import { Route as AppAdminIndexImport } from './routes/app/admin/index'
import { Route as AppAccountingIndexImport } from './routes/app/accounting/index'
import { Route as AppTabletIndexRouteImport } from './routes/app/tablet/index.route'
import { Route as AppSalesIndexRouteImport } from './routes/app/sales/index.route'
import { Route as AppOrdersIndexRouteImport } from './routes/app/orders/index.route'
import { Route as AppWarehouseReceivingLayoutImport } from './routes/app/warehouse-receiving/_layout'
import { Route as AppProcurementLayoutImport } from './routes/app/procurement/_layout'
import { Route as AppPricingLayoutImport } from './routes/app/pricing/_layout'
import { Route as AppInventoryLayoutImport } from './routes/app/inventory/_layout'
import { Route as AppDashboardLayoutImport } from './routes/app/dashboard/_layout'
import { Route as AppAccountingLayoutImport } from './routes/app/accounting/_layout'
import { Route as AppSalesSalesOrdersRouteImport } from './routes/app/sales/sales-orders.route'
import { Route as AppSalesCustomersRouteImport } from './routes/app/sales/customers.route'
import { Route as AppTabletWarehouseReceivingIndexImport } from './routes/app/tablet/warehouse-receiving/index'
import { Route as AppAdminWarehousesIndexImport } from './routes/app/admin/warehouses/index'
import { Route as AppAdminSystemAdminIndexImport } from './routes/app/admin/system-admin/index'
import { Route as AppAdminManageProductsIndexImport } from './routes/app/admin/manage-products/index'
import { Route as AppAdminChangeLogIndexImport } from './routes/app/admin/change-log/index'
import { Route as AppAdminAccountingIndexImport } from './routes/app/admin/accounting/index'
import { Route as AppTabletSalesIndexRouteImport } from './routes/app/tablet/sales/index.route'
import { Route as AppWarehouseReceivingLayoutStoredImport } from './routes/app/warehouse-receiving/_layout/stored'
import { Route as AppWarehouseReceivingLayoutSoftReceivedImport } from './routes/app/warehouse-receiving/_layout/soft-received'
import { Route as AppWarehouseReceivingLayoutIncomingImport } from './routes/app/warehouse-receiving/_layout/incoming'
import { Route as AppWarehouseReceivingLayoutCheckedInImport } from './routes/app/warehouse-receiving/_layout/checked-in'
import { Route as AppTabletWarehouseReceivingLayoutImport } from './routes/app/tablet/warehouse-receiving/_layout'
import { Route as AppProcurementLayoutSupplierReportImport } from './routes/app/procurement/_layout.supplier-report'
import { Route as AppProcurementLayoutPurchaseOrdersImport } from './routes/app/procurement/_layout.purchase-orders'
import { Route as AppProcurementLayoutCostBreakdownImport } from './routes/app/procurement/_layout.cost-breakdown'
import { Route as AppPricingLayoutPriceChangeImport } from './routes/app/pricing/_layout/price-change'
import { Route as AppPricingPriceChangeIdReviewImport } from './routes/app/pricing/$priceChangeId/review'
import { Route as AppInventoryTransfersNewImport } from './routes/app/inventory/transfers/new'
import { Route as AppInventoryLayoutTransfersImport } from './routes/app/inventory/_layout/transfers'
import { Route as AppInventoryLayoutProductsImport } from './routes/app/inventory/_layout/products'
import { Route as AppInventoryLayoutAdjustmentHistoryImport } from './routes/app/inventory/_layout/adjustment-history'
import { Route as AppDashboardLayoutMyRequestsImport } from './routes/app/dashboard/_layout/my-requests'
import { Route as AppAdminSystemAdminLayoutImport } from './routes/app/admin/system-admin/_layout'
import { Route as AppAdminManageProductsLayoutImport } from './routes/app/admin/manage-products/_layout'
import { Route as AppAdminAccountingCreatePaymentTermImport } from './routes/app/admin/accounting/create-payment-term'
import { Route as AppAdminAccountingLayoutImport } from './routes/app/admin/accounting/_layout'
import { Route as AppAccountingLayoutPayableApprovalsImport } from './routes/app/accounting/_layout.payable-approvals'
import { Route as AppAccountingLayoutHuntingtonPayFilesImport } from './routes/app/accounting/_layout.huntington-pay-files'
import { Route as AppAccountingLayoutGlTransactionsImport } from './routes/app/accounting/_layout.gl-transactions'
import { Route as AppAccountingLayoutAccountsPayableImport } from './routes/app/accounting/_layout.accounts-payable'
import { Route as AppProductProductIdPreferenceIndexImport } from './routes/app/product/$productId/preference/index'
import { Route as AppProductProductIdEditIndexImport } from './routes/app/product/$productId/edit/index'
import { Route as AppDashboardLayoutPendingApprovalsIndexImport } from './routes/app/dashboard/_layout/pending-approvals/index'
import { Route as AppCompaniesCompanyIdEditIndexImport } from './routes/app/companies/$companyId/edit/index'
import { Route as AppAdminWarehousesWarehouseIdIndexImport } from './routes/app/admin/warehouses/$warehouseId/index'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
import { Route as AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport } from './routes/app/warehouse-receiving/incoming/$goodsReceiptId/_layout'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
import { Route as AppTabletWarehouseReceivingLayoutStoredImport } from './routes/app/tablet/warehouse-receiving/_layout/stored'
import { Route as AppTabletWarehouseReceivingLayoutSoftReceivedImport } from './routes/app/tablet/warehouse-receiving/_layout/soft-received'
import { Route as AppTabletWarehouseReceivingLayoutIncomingImport } from './routes/app/tablet/warehouse-receiving/_layout/incoming'
import { Route as AppTabletWarehouseReceivingLayoutCheckedInImport } from './routes/app/tablet/warehouse-receiving/_layout/checked-in'
import { Route as AppProductProductIdEditLayoutImport } from './routes/app/product/$productId/edit/_layout'
import { Route as AppProcurementLayoutPurchaseOrdersPurchaseOrderIdImport } from './routes/app/procurement/_layout_.purchase-orders.$purchaseOrderId'
import { Route as AppPricingLayoutHistoryPurchaseCostImport } from './routes/app/pricing/_layout/history/purchase-cost'
import { Route as AppPricingLayoutHistoryPriceChangeImport } from './routes/app/pricing/_layout/history/price-change'
import { Route as AppOrdersCompanyIdShipToLocationIdLayoutImport } from './routes/app/orders/$companyId/$shipToLocationId/_layout'
import { Route as AppInventoryTransfersTransferIdEditImport } from './routes/app/inventory/transfers/$transferId/edit'
import { Route as AppInventoryProductsProductIdLayoutImport } from './routes/app/inventory/products/$productId/_layout'
import { Route as AppDashboardLayoutPendingApprovalsLayoutImport } from './routes/app/dashboard/_layout/pending-approvals/_layout'
import { Route as AppCompaniesCompanyIdEditLayoutImport } from './routes/app/companies/$companyId/edit/_layout'
import { Route as AppAdminWarehousesWarehouseIdLayoutImport } from './routes/app/admin/warehouses/$warehouseId/_layout'
import { Route as AppAdminSystemAdminUsersUserIdImport } from './routes/app/admin/system-admin/users/$userId'
import { Route as AppAdminSystemAdminLayoutUsersImport } from './routes/app/admin/system-admin/_layout.users'
import { Route as AppAdminSystemAdminLayoutRolesImport } from './routes/app/admin/system-admin/_layout.roles'
import { Route as AppAdminManageProductsLayoutTestTemplatesImport } from './routes/app/admin/manage-products/_layout.test-templates'
import { Route as AppAdminManageProductsLayoutInstructionsImport } from './routes/app/admin/manage-products/_layout.instructions'
import { Route as AppAdminManageProductsLayoutEquivalentsImport } from './routes/app/admin/manage-products/_layout.equivalents'
import { Route as AppAdminManageProductsLayoutCompetitorProductsImport } from './routes/app/admin/manage-products/_layout.competitor-products'
import { Route as AppAdminManageProductsLayoutClassesImport } from './routes/app/admin/manage-products/_layout.classes'
import { Route as AppAdminManageProductsLayoutCategoriesImport } from './routes/app/admin/manage-products/_layout.categories'
import { Route as AppAdminAccountingPaymentTermPaymentTermIdImport } from './routes/app/admin/accounting/payment-term/$paymentTermId'
import { Route as AppAdminAccountingLayoutSettingsImport } from './routes/app/admin/accounting/_layout.settings'
import { Route as AppAdminAccountingLayoutPaymentTermsImport } from './routes/app/admin/accounting/_layout.payment-terms'
import { Route as AppAdminAccountingLayoutAccountsChartImport } from './routes/app/admin/accounting/_layout.accounts-chart'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout/index'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/index'
import { Route as AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport } from './routes/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/index'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/index'
import { Route as AppInventoryProductsProductIdLayoutIndexImport } from './routes/app/inventory/products/$productId/_layout/index'
import { Route as AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteImport } from './routes/app/orders/$companyId/$shipToLocationId/_layout/index.route'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments'
import { Route as AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsImport } from './routes/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport } from './routes/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
import { Route as AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsImport } from './routes/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads'
import { Route as AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport } from './routes/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
import { Route as AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport } from './routes/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
import { Route as AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport } from './routes/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
import { Route as AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport } from './routes/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
import { Route as AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport } from './routes/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout'
import { Route as AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport } from './routes/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
import { Route as AppInventoryProductsProductIdLayoutTransactionsImport } from './routes/app/inventory/products/$productId/_layout/transactions'
import { Route as AppInventoryProductsProductIdLayoutPalletsImport } from './routes/app/inventory/products/$productId/_layout/pallets'
import { Route as AppInventoryProductsProductIdLayoutLotsImport } from './routes/app/inventory/products/$productId/_layout/lots'
import { Route as AppDashboardLayoutPendingApprovalsLayoutSourceChangeImport } from './routes/app/dashboard/_layout/pending-approvals/_layout/source-change'
import { Route as AppDashboardLayoutPendingApprovalsLayoutSampleImport } from './routes/app/dashboard/_layout/pending-approvals/_layout/sample'
import { Route as AppDashboardLayoutPendingApprovalsLayoutQualityImport } from './routes/app/dashboard/_layout/pending-approvals/_layout/quality'
import { Route as AppDashboardLayoutPendingApprovalsLayoutPriceImport } from './routes/app/dashboard/_layout/pending-approvals/_layout/price'
import { Route as AppAdminWarehousesWarehouseIdLayoutShelvingImport } from './routes/app/admin/warehouses/$warehouseId/_layout.shelving'
import { Route as AppAdminWarehousesWarehouseIdLayoutInfoImport } from './routes/app/admin/warehouses/$warehouseId/_layout.info'
import { Route as AppProductProductIdEditLayoutStorageRouteImport } from './routes/app/product/$productId/edit/_layout/storage.route'
import { Route as AppProductProductIdEditLayoutRegulatoryRouteImport } from './routes/app/product/$productId/edit/_layout/regulatory.route'
import { Route as AppProductProductIdEditLayoutInstructionsRouteImport } from './routes/app/product/$productId/edit/_layout/instructions.route'
import { Route as AppProductProductIdEditLayoutInformationRouteImport } from './routes/app/product/$productId/edit/_layout/information.route'
import { Route as AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteImport } from './routes/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders.route'
import { Route as AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteImport } from './routes/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders.route'
import { Route as AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteImport } from './routes/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders.route'
import { Route as AppCompaniesCompanyIdEditLayoutRegistrationRouteImport } from './routes/app/companies/$companyId/edit/_layout.registration.route'
import { Route as AppCompaniesCompanyIdEditLayoutProductsRouteImport } from './routes/app/companies/$companyId/edit/_layout.products.route'
import { Route as AppCompaniesCompanyIdEditLayoutPreferencesRouteImport } from './routes/app/companies/$companyId/edit/_layout.preferences.route'
import { Route as AppCompaniesCompanyIdEditLayoutLocationsRouteImport } from './routes/app/companies/$companyId/edit/_layout.locations.route'
import { Route as AppCompaniesCompanyIdEditLayoutInfoRouteImport } from './routes/app/companies/$companyId/edit/_layout.info.route'
import { Route as AppCompaniesCompanyIdEditLayoutEvaluationRouteImport } from './routes/app/companies/$companyId/edit/_layout.evaluation.route'
import { Route as AppCompaniesCompanyIdEditLayoutContactsRouteImport } from './routes/app/companies/$companyId/edit/_layout.contacts.route'
import { Route as AppCompaniesCompanyIdEditLayoutCertificationRouteImport } from './routes/app/companies/$companyId/edit/_layout.certification.route'
import { Route as AppCompaniesCompanyIdEditLayoutAccountingRouteImport } from './routes/app/companies/$companyId/edit/_layout.accounting.route'
import { Route as AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport } from './routes/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/index'
import { Route as AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport } from './routes/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/index'
import { Route as AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport } from './routes/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/index'
import { Route as AppProductProductIdEditLayoutQualityIndexImport } from './routes/app/product/$productId/edit/_layout/quality/index'
import { Route as AppProductProductIdEditLayoutCostsIndexImport } from './routes/app/product/$productId/edit/_layout/costs/index'
import { Route as AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport } from './routes/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
import { Route as AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport } from './routes/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
import { Route as AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport } from './routes/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
import { Route as AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport } from './routes/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
import { Route as AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport } from './routes/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
import { Route as AppProductProductIdEditLayoutQualityLayoutImport } from './routes/app/product/$productId/edit/_layout/quality/_layout'
import { Route as AppProductProductIdEditLayoutCostsLayoutImport } from './routes/app/product/$productId/edit/_layout/costs/_layout'
import { Route as AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteImport } from './routes/app/companies/$companyId/edit/_layout.locations.$locationId.route'
import { Route as AppProductProductIdEditLayoutQualityLayoutTemplatesRouteImport } from './routes/app/product/$productId/edit/_layout/quality/_layout/templates.route'
import { Route as AppProductProductIdEditLayoutQualityLayoutResultsRouteImport } from './routes/app/product/$productId/edit/_layout/quality/_layout/results.route'
import { Route as AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteImport } from './routes/app/product/$productId/edit/_layout/costs/_layout/purchase-costs.route'
import { Route as AppProductProductIdEditLayoutCostsLayoutLaidDownRouteImport } from './routes/app/product/$productId/edit/_layout/costs/_layout/laid-down.route'

// Create Virtual Routes

const AppWarehouseReceivingImport = createFileRoute(
  '/app/warehouse-receiving',
)()
const AppProcurementImport = createFileRoute('/app/procurement')()
const AppPricingImport = createFileRoute('/app/pricing')()
const AppInventoryImport = createFileRoute('/app/inventory')()
const AppDashboardImport = createFileRoute('/app/dashboard')()
const AppAccountingImport = createFileRoute('/app/accounting')()
const AppTabletWarehouseReceivingImport = createFileRoute(
  '/app/tablet/warehouse-receiving',
)()
const AppAdminSystemAdminImport = createFileRoute('/app/admin/system-admin')()
const AppAdminManageProductsImport = createFileRoute(
  '/app/admin/manage-products',
)()
const AppAdminAccountingImport = createFileRoute('/app/admin/accounting')()
const AppWarehouseReceivingStoredGoodsReceiptIdImport = createFileRoute(
  '/app/warehouse-receiving/stored/$goodsReceiptId',
)()
const AppWarehouseReceivingSoftReceivedGoodsReceiptIdImport = createFileRoute(
  '/app/warehouse-receiving/soft-received/$goodsReceiptId',
)()
const AppWarehouseReceivingIncomingGoodsReceiptIdImport = createFileRoute(
  '/app/warehouse-receiving/incoming/$goodsReceiptId',
)()
const AppWarehouseReceivingCheckedInGoodsReceiptIdImport = createFileRoute(
  '/app/warehouse-receiving/checked-in/$goodsReceiptId',
)()
const AppProductProductIdEditImport = createFileRoute(
  '/app/product/$productId/edit',
)()
const AppOrdersCompanyIdShipToLocationIdImport = createFileRoute(
  '/app/orders/$companyId/$shipToLocationId',
)()
const AppInventoryProductsProductIdImport = createFileRoute(
  '/app/inventory/products/$productId',
)()
const AppDashboardLayoutPendingApprovalsImport = createFileRoute(
  '/app/dashboard/_layout/pending-approvals',
)()
const AppCompaniesCompanyIdEditImport = createFileRoute(
  '/app/companies/$companyId/edit',
)()
const AppAdminWarehousesWarehouseIdImport = createFileRoute(
  '/app/admin/warehouses/$warehouseId',
)()
const AppContactContactIdIndexLazyImport = createFileRoute(
  '/app/contact/$contactId/',
)()
const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdImport =
  createFileRoute(
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId',
  )()
const AppTabletWarehouseReceivingIncomingGoodsReceiptIdImport = createFileRoute(
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId',
)()
const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdImport =
  createFileRoute(
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId',
  )()
const AppProcurementLayoutSupplierReportNewSupplierLazyImport = createFileRoute(
  '/app/procurement/_layout/supplier-report/new-supplier',
)()
const AppProductProductIdEditLayoutQualityImport = createFileRoute(
  '/app/product/$productId/edit/_layout/quality',
)()
const AppProductProductIdEditLayoutCostsImport = createFileRoute(
  '/app/product/$productId/edit/_layout/costs',
)()

// Create/Update Routes

const LogoutRouteRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const DeactivatedRouteRoute = DeactivatedRouteImport.update({
  id: '/deactivated',
  path: '/deactivated',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRouteRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppWarehouseReceivingRoute = AppWarehouseReceivingImport.update({
  id: '/warehouse-receiving',
  path: '/warehouse-receiving',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProcurementRoute = AppProcurementImport.update({
  id: '/procurement',
  path: '/procurement',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPricingRoute = AppPricingImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryRoute = AppInventoryImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountingRoute = AppAccountingImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppIndexRouteRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AppTabletRoute = AppTabletImport.update({
  id: '/tablet',
  path: '/tablet',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppRegulatoryRouteRoute = AppRegulatoryRouteImport.update({
  id: '/regulatory',
  path: '/regulatory',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOrdersRouteRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCompanyRouteRoute = AppCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppTabletWarehouseReceivingRoute =
  AppTabletWarehouseReceivingImport.update({
    id: '/warehouse-receiving',
    path: '/warehouse-receiving',
    getParentRoute: () => AppTabletRoute,
  } as any)

const AppAdminSystemAdminRoute = AppAdminSystemAdminImport.update({
  id: '/admin/system-admin',
  path: '/admin/system-admin',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminManageProductsRoute = AppAdminManageProductsImport.update({
  id: '/admin/manage-products',
  path: '/admin/manage-products',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminAccountingRoute = AppAdminAccountingImport.update({
  id: '/admin/accounting',
  path: '/admin/accounting',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppWarehouseReceivingIndexRoute = AppWarehouseReceivingIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any,
)

const AppProductsIndexRoute = AppProductsIndexImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProcurementIndexRoute = AppProcurementIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProcurementRoute,
} as any)

const AppPricingIndexRoute = AppPricingIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPricingRoute,
} as any)

const AppInventoryIndexRoute = AppInventoryIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRoute,
} as any)

const AppDashboardIndexRoute = AppDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppCompaniesIndexRoute = AppCompaniesIndexImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminIndexRoute = AppAdminIndexImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountingIndexRoute = AppAccountingIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountingRoute,
} as any)

const AppTabletIndexRouteRoute = AppTabletIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTabletRoute,
} as any)

const AppSalesIndexRouteRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOrdersIndexRouteRoute = AppOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrdersRouteRoute,
} as any)

const AppWarehouseReceivingLayoutRoute =
  AppWarehouseReceivingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any)

const AppProcurementLayoutRoute = AppProcurementLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppProcurementRoute,
} as any)

const AppPricingLayoutRoute = AppPricingLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppPricingRoute,
} as any)

const AppInventoryLayoutRoute = AppInventoryLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppInventoryRoute,
} as any)

const AppDashboardLayoutRoute = AppDashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppAccountingLayoutRoute = AppAccountingLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAccountingRoute,
} as any)

const AppSalesSalesOrdersRouteRoute = AppSalesSalesOrdersRouteImport.update({
  id: '/sales/sales-orders',
  path: '/sales/sales-orders',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSalesCustomersRouteRoute = AppSalesCustomersRouteImport.update({
  id: '/sales/customers',
  path: '/sales/customers',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppWarehouseReceivingStoredGoodsReceiptIdRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdImport.update({
    id: '/stored/$goodsReceiptId',
    path: '/stored/$goodsReceiptId',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdImport.update({
    id: '/soft-received/$goodsReceiptId',
    path: '/soft-received/$goodsReceiptId',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdImport.update({
    id: '/incoming/$goodsReceiptId',
    path: '/incoming/$goodsReceiptId',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdImport.update({
    id: '/checked-in/$goodsReceiptId',
    path: '/checked-in/$goodsReceiptId',
    getParentRoute: () => AppWarehouseReceivingRoute,
  } as any)

const AppProductProductIdEditRoute = AppProductProductIdEditImport.update({
  id: '/product/$productId/edit',
  path: '/product/$productId/edit',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOrdersCompanyIdShipToLocationIdRoute =
  AppOrdersCompanyIdShipToLocationIdImport.update({
    id: '/$companyId/$shipToLocationId',
    path: '/$companyId/$shipToLocationId',
    getParentRoute: () => AppOrdersRouteRoute,
  } as any)

const AppInventoryProductsProductIdRoute =
  AppInventoryProductsProductIdImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AppInventoryRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsRoute =
  AppDashboardLayoutPendingApprovalsImport.update({
    id: '/pending-approvals',
    path: '/pending-approvals',
    getParentRoute: () => AppDashboardLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditRoute = AppCompaniesCompanyIdEditImport.update({
  id: '/companies/$companyId/edit',
  path: '/companies/$companyId/edit',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminWarehousesWarehouseIdRoute =
  AppAdminWarehousesWarehouseIdImport.update({
    id: '/admin/warehouses/$warehouseId',
    path: '/admin/warehouses/$warehouseId',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppContactContactIdIndexLazyRoute =
  AppContactContactIdIndexLazyImport.update({
    id: '/contact/$contactId/',
    path: '/contact/$contactId/',
    getParentRoute: () => AppRouteRoute,
  } as any).lazy(() =>
    import('./routes/app/contact/$contactId/index.lazy').then((d) => d.Route),
  )

const AppTabletWarehouseReceivingIndexRoute =
  AppTabletWarehouseReceivingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppTabletWarehouseReceivingRoute,
  } as any)

const AppAdminWarehousesIndexRoute = AppAdminWarehousesIndexImport.update({
  id: '/admin/warehouses/',
  path: '/admin/warehouses/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminSystemAdminIndexRoute = AppAdminSystemAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSystemAdminRoute,
} as any)

const AppAdminManageProductsIndexRoute =
  AppAdminManageProductsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminManageProductsRoute,
  } as any)

const AppAdminChangeLogIndexRoute = AppAdminChangeLogIndexImport.update({
  id: '/admin/change-log/',
  path: '/admin/change-log/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAdminAccountingIndexRoute = AppAdminAccountingIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAccountingRoute,
} as any)

const AppTabletSalesIndexRouteRoute = AppTabletSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppTabletRoute,
} as any)

const AppWarehouseReceivingLayoutStoredRoute =
  AppWarehouseReceivingLayoutStoredImport.update({
    id: '/stored',
    path: '/stored',
    getParentRoute: () => AppWarehouseReceivingLayoutRoute,
  } as any)

const AppWarehouseReceivingLayoutSoftReceivedRoute =
  AppWarehouseReceivingLayoutSoftReceivedImport.update({
    id: '/soft-received',
    path: '/soft-received',
    getParentRoute: () => AppWarehouseReceivingLayoutRoute,
  } as any)

const AppWarehouseReceivingLayoutIncomingRoute =
  AppWarehouseReceivingLayoutIncomingImport.update({
    id: '/incoming',
    path: '/incoming',
    getParentRoute: () => AppWarehouseReceivingLayoutRoute,
  } as any)

const AppWarehouseReceivingLayoutCheckedInRoute =
  AppWarehouseReceivingLayoutCheckedInImport.update({
    id: '/checked-in',
    path: '/checked-in',
    getParentRoute: () => AppWarehouseReceivingLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingLayoutRoute =
  AppTabletWarehouseReceivingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppTabletWarehouseReceivingRoute,
  } as any)

const AppProcurementLayoutSupplierReportRoute =
  AppProcurementLayoutSupplierReportImport.update({
    id: '/supplier-report',
    path: '/supplier-report',
    getParentRoute: () => AppProcurementLayoutRoute,
  } as any)

const AppProcurementLayoutPurchaseOrdersRoute =
  AppProcurementLayoutPurchaseOrdersImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AppProcurementLayoutRoute,
  } as any)

const AppProcurementLayoutCostBreakdownRoute =
  AppProcurementLayoutCostBreakdownImport.update({
    id: '/cost-breakdown',
    path: '/cost-breakdown',
    getParentRoute: () => AppProcurementLayoutRoute,
  } as any)

const AppPricingLayoutPriceChangeRoute =
  AppPricingLayoutPriceChangeImport.update({
    id: '/price-change',
    path: '/price-change',
    getParentRoute: () => AppPricingLayoutRoute,
  } as any)

const AppPricingPriceChangeIdReviewRoute =
  AppPricingPriceChangeIdReviewImport.update({
    id: '/$priceChangeId/review',
    path: '/$priceChangeId/review',
    getParentRoute: () => AppPricingRoute,
  } as any)

const AppInventoryTransfersNewRoute = AppInventoryTransfersNewImport.update({
  id: '/transfers/new',
  path: '/transfers/new',
  getParentRoute: () => AppInventoryRoute,
} as any)

const AppInventoryLayoutTransfersRoute =
  AppInventoryLayoutTransfersImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AppInventoryLayoutRoute,
  } as any)

const AppInventoryLayoutProductsRoute = AppInventoryLayoutProductsImport.update(
  {
    id: '/products',
    path: '/products',
    getParentRoute: () => AppInventoryLayoutRoute,
  } as any,
)

const AppInventoryLayoutAdjustmentHistoryRoute =
  AppInventoryLayoutAdjustmentHistoryImport.update({
    id: '/adjustment-history',
    path: '/adjustment-history',
    getParentRoute: () => AppInventoryLayoutRoute,
  } as any)

const AppDashboardLayoutMyRequestsRoute =
  AppDashboardLayoutMyRequestsImport.update({
    id: '/my-requests',
    path: '/my-requests',
    getParentRoute: () => AppDashboardLayoutRoute,
  } as any)

const AppAdminSystemAdminLayoutRoute = AppAdminSystemAdminLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAdminSystemAdminRoute,
} as any)

const AppAdminManageProductsLayoutRoute =
  AppAdminManageProductsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppAdminManageProductsRoute,
  } as any)

const AppAdminAccountingCreatePaymentTermRoute =
  AppAdminAccountingCreatePaymentTermImport.update({
    id: '/create-payment-term',
    path: '/create-payment-term',
    getParentRoute: () => AppAdminAccountingRoute,
  } as any)

const AppAdminAccountingLayoutRoute = AppAdminAccountingLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAdminAccountingRoute,
} as any)

const AppAccountingLayoutPayableApprovalsRoute =
  AppAccountingLayoutPayableApprovalsImport.update({
    id: '/payable-approvals',
    path: '/payable-approvals',
    getParentRoute: () => AppAccountingLayoutRoute,
  } as any)

const AppAccountingLayoutHuntingtonPayFilesRoute =
  AppAccountingLayoutHuntingtonPayFilesImport.update({
    id: '/huntington-pay-files',
    path: '/huntington-pay-files',
    getParentRoute: () => AppAccountingLayoutRoute,
  } as any)

const AppAccountingLayoutGlTransactionsRoute =
  AppAccountingLayoutGlTransactionsImport.update({
    id: '/gl-transactions',
    path: '/gl-transactions',
    getParentRoute: () => AppAccountingLayoutRoute,
  } as any)

const AppAccountingLayoutAccountsPayableRoute =
  AppAccountingLayoutAccountsPayableImport.update({
    id: '/accounts-payable',
    path: '/accounts-payable',
    getParentRoute: () => AppAccountingLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdImport.update({
    id: '/soft-received/$goodsReceiptId',
    path: '/soft-received/$goodsReceiptId',
    getParentRoute: () => AppTabletWarehouseReceivingRoute,
  } as any)

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdImport.update({
    id: '/incoming/$goodsReceiptId',
    path: '/incoming/$goodsReceiptId',
    getParentRoute: () => AppTabletWarehouseReceivingRoute,
  } as any)

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdImport.update({
    id: '/checked-in/$goodsReceiptId',
    path: '/checked-in/$goodsReceiptId',
    getParentRoute: () => AppTabletWarehouseReceivingRoute,
  } as any)

const AppProductProductIdPreferenceIndexRoute =
  AppProductProductIdPreferenceIndexImport.update({
    id: '/product/$productId/preference/',
    path: '/product/$productId/preference/',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppProductProductIdEditIndexRoute =
  AppProductProductIdEditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductProductIdEditRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsIndexRoute =
  AppDashboardLayoutPendingApprovalsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsRoute,
  } as any)

const AppCompaniesCompanyIdEditIndexRoute =
  AppCompaniesCompanyIdEditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCompaniesCompanyIdEditRoute,
  } as any)

const AppAdminWarehousesWarehouseIdIndexRoute =
  AppAdminWarehousesWarehouseIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminWarehousesWarehouseIdRoute,
  } as any)

const AppProcurementLayoutSupplierReportNewSupplierLazyRoute =
  AppProcurementLayoutSupplierReportNewSupplierLazyImport.update({
    id: '/new-supplier',
    path: '/new-supplier',
    getParentRoute: () => AppProcurementLayoutSupplierReportRoute,
  } as any).lazy(() =>
    import(
      './routes/app/procurement/_layout.supplier-report.new-supplier.lazy'
    ).then((d) => d.Route),
  )

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport.update({
    id: '/finalize-check-in',
    path: '/finalize-check-in',
    getParentRoute: () => AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppWarehouseReceivingIncomingGoodsReceiptIdRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppWarehouseReceivingCheckedInGoodsReceiptIdRoute,
  } as any)

const AppTabletWarehouseReceivingLayoutStoredRoute =
  AppTabletWarehouseReceivingLayoutStoredImport.update({
    id: '/stored',
    path: '/stored',
    getParentRoute: () => AppTabletWarehouseReceivingLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingLayoutSoftReceivedRoute =
  AppTabletWarehouseReceivingLayoutSoftReceivedImport.update({
    id: '/soft-received',
    path: '/soft-received',
    getParentRoute: () => AppTabletWarehouseReceivingLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingLayoutIncomingRoute =
  AppTabletWarehouseReceivingLayoutIncomingImport.update({
    id: '/incoming',
    path: '/incoming',
    getParentRoute: () => AppTabletWarehouseReceivingLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingLayoutCheckedInRoute =
  AppTabletWarehouseReceivingLayoutCheckedInImport.update({
    id: '/checked-in',
    path: '/checked-in',
    getParentRoute: () => AppTabletWarehouseReceivingLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutRoute =
  AppProductProductIdEditLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppProductProductIdEditRoute,
  } as any)

const AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute =
  AppProcurementLayoutPurchaseOrdersPurchaseOrderIdImport.update({
    id: '/_layout_/purchase-orders/$purchaseOrderId',
    path: '/purchase-orders/$purchaseOrderId',
    getParentRoute: () => AppProcurementRoute,
  } as any)

const AppPricingLayoutHistoryPurchaseCostRoute =
  AppPricingLayoutHistoryPurchaseCostImport.update({
    id: '/history/purchase-cost',
    path: '/history/purchase-cost',
    getParentRoute: () => AppPricingLayoutRoute,
  } as any)

const AppPricingLayoutHistoryPriceChangeRoute =
  AppPricingLayoutHistoryPriceChangeImport.update({
    id: '/history/price-change',
    path: '/history/price-change',
    getParentRoute: () => AppPricingLayoutRoute,
  } as any)

const AppOrdersCompanyIdShipToLocationIdLayoutRoute =
  AppOrdersCompanyIdShipToLocationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppOrdersCompanyIdShipToLocationIdRoute,
  } as any)

const AppInventoryTransfersTransferIdEditRoute =
  AppInventoryTransfersTransferIdEditImport.update({
    id: '/transfers/$transferId/edit',
    path: '/transfers/$transferId/edit',
    getParentRoute: () => AppInventoryRoute,
  } as any)

const AppInventoryProductsProductIdLayoutRoute =
  AppInventoryProductsProductIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppInventoryProductsProductIdRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsLayoutRoute =
  AppDashboardLayoutPendingApprovalsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutRoute =
  AppCompaniesCompanyIdEditLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppCompaniesCompanyIdEditRoute,
  } as any)

const AppAdminWarehousesWarehouseIdLayoutRoute =
  AppAdminWarehousesWarehouseIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppAdminWarehousesWarehouseIdRoute,
  } as any)

const AppAdminSystemAdminUsersUserIdRoute =
  AppAdminSystemAdminUsersUserIdImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AppAdminSystemAdminRoute,
  } as any)

const AppAdminSystemAdminLayoutUsersRoute =
  AppAdminSystemAdminLayoutUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AppAdminSystemAdminLayoutRoute,
  } as any)

const AppAdminSystemAdminLayoutRolesRoute =
  AppAdminSystemAdminLayoutRolesImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AppAdminSystemAdminLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutTestTemplatesRoute =
  AppAdminManageProductsLayoutTestTemplatesImport.update({
    id: '/test-templates',
    path: '/test-templates',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutInstructionsRoute =
  AppAdminManageProductsLayoutInstructionsImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutEquivalentsRoute =
  AppAdminManageProductsLayoutEquivalentsImport.update({
    id: '/equivalents',
    path: '/equivalents',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutCompetitorProductsRoute =
  AppAdminManageProductsLayoutCompetitorProductsImport.update({
    id: '/competitor-products',
    path: '/competitor-products',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutClassesRoute =
  AppAdminManageProductsLayoutClassesImport.update({
    id: '/classes',
    path: '/classes',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminManageProductsLayoutCategoriesRoute =
  AppAdminManageProductsLayoutCategoriesImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AppAdminManageProductsLayoutRoute,
  } as any)

const AppAdminAccountingPaymentTermPaymentTermIdRoute =
  AppAdminAccountingPaymentTermPaymentTermIdImport.update({
    id: '/payment-term/$paymentTermId',
    path: '/payment-term/$paymentTermId',
    getParentRoute: () => AppAdminAccountingRoute,
  } as any)

const AppAdminAccountingLayoutSettingsRoute =
  AppAdminAccountingLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAdminAccountingLayoutRoute,
  } as any)

const AppAdminAccountingLayoutPaymentTermsRoute =
  AppAdminAccountingLayoutPaymentTermsImport.update({
    id: '/payment-terms',
    path: '/payment-terms',
    getParentRoute: () => AppAdminAccountingLayoutRoute,
  } as any)

const AppAdminAccountingLayoutAccountsChartRoute =
  AppAdminAccountingLayoutAccountsChartImport.update({
    id: '/accounts-chart',
    path: '/accounts-chart',
    getParentRoute: () => AppAdminAccountingLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutQualityRoute =
  AppProductProductIdEditLayoutQualityImport.update({
    id: '/quality',
    path: '/quality',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutCostsRoute =
  AppProductProductIdEditLayoutCostsImport.update({
    id: '/costs',
    path: '/costs',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
  } as any)

const AppInventoryProductsProductIdLayoutIndexRoute =
  AppInventoryProductsProductIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryProductsProductIdLayoutRoute,
  } as any)

const AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute =
  AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrdersCompanyIdShipToLocationIdLayoutRoute,
  } as any)

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsImport.update({
    id: '/built-pallets',
    path: '/built-pallets',
    getParentRoute: () => AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () =>
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () =>
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () =>
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () =>
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () =>
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () =>
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () =>
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
  } as any)

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport.update({
    id: '/built-pallets',
    path: '/built-pallets',
    getParentRoute: () =>
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport.update(
    {
      id: '/finalize-check-in',
      path: '/finalize-check-in',
      getParentRoute: () =>
        AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute,
    } as any,
  )

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute,
  } as any)

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute,
  } as any)

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute,
  } as any)

const AppInventoryProductsProductIdLayoutTransactionsRoute =
  AppInventoryProductsProductIdLayoutTransactionsImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AppInventoryProductsProductIdLayoutRoute,
  } as any)

const AppInventoryProductsProductIdLayoutPalletsRoute =
  AppInventoryProductsProductIdLayoutPalletsImport.update({
    id: '/pallets',
    path: '/pallets',
    getParentRoute: () => AppInventoryProductsProductIdLayoutRoute,
  } as any)

const AppInventoryProductsProductIdLayoutLotsRoute =
  AppInventoryProductsProductIdLayoutLotsImport.update({
    id: '/lots',
    path: '/lots',
    getParentRoute: () => AppInventoryProductsProductIdLayoutRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute =
  AppDashboardLayoutPendingApprovalsLayoutSourceChangeImport.update({
    id: '/source-change',
    path: '/source-change',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsLayoutRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsLayoutSampleRoute =
  AppDashboardLayoutPendingApprovalsLayoutSampleImport.update({
    id: '/sample',
    path: '/sample',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsLayoutRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsLayoutQualityRoute =
  AppDashboardLayoutPendingApprovalsLayoutQualityImport.update({
    id: '/quality',
    path: '/quality',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsLayoutRoute,
  } as any)

const AppDashboardLayoutPendingApprovalsLayoutPriceRoute =
  AppDashboardLayoutPendingApprovalsLayoutPriceImport.update({
    id: '/price',
    path: '/price',
    getParentRoute: () => AppDashboardLayoutPendingApprovalsLayoutRoute,
  } as any)

const AppAdminWarehousesWarehouseIdLayoutShelvingRoute =
  AppAdminWarehousesWarehouseIdLayoutShelvingImport.update({
    id: '/shelving',
    path: '/shelving',
    getParentRoute: () => AppAdminWarehousesWarehouseIdLayoutRoute,
  } as any)

const AppAdminWarehousesWarehouseIdLayoutInfoRoute =
  AppAdminWarehousesWarehouseIdLayoutInfoImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AppAdminWarehousesWarehouseIdLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutStorageRouteRoute =
  AppProductProductIdEditLayoutStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutRegulatoryRouteRoute =
  AppProductProductIdEditLayoutRegulatoryRouteImport.update({
    id: '/regulatory',
    path: '/regulatory',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutInstructionsRouteRoute =
  AppProductProductIdEditLayoutInstructionsRouteImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutInformationRouteRoute =
  AppProductProductIdEditLayoutInformationRouteImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => AppProductProductIdEditLayoutRoute,
  } as any)

const AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute =
  AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteImport.update({
    id: '/open-sales-orders',
    path: '/open-sales-orders',
    getParentRoute: () => AppOrdersCompanyIdShipToLocationIdLayoutRoute,
  } as any)

const AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute =
  AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteImport.update(
    {
      id: '/customer-purchase-orders',
      path: '/customer-purchase-orders',
      getParentRoute: () => AppOrdersCompanyIdShipToLocationIdLayoutRoute,
    } as any,
  )

const AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute =
  AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteImport.update({
    id: '/closed-sales-orders',
    path: '/closed-sales-orders',
    getParentRoute: () => AppOrdersCompanyIdShipToLocationIdLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute =
  AppCompaniesCompanyIdEditLayoutRegistrationRouteImport.update({
    id: '/registration',
    path: '/registration',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutProductsRouteRoute =
  AppCompaniesCompanyIdEditLayoutProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute =
  AppCompaniesCompanyIdEditLayoutPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutLocationsRouteRoute =
  AppCompaniesCompanyIdEditLayoutLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutInfoRouteRoute =
  AppCompaniesCompanyIdEditLayoutInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute =
  AppCompaniesCompanyIdEditLayoutEvaluationRouteImport.update({
    id: '/evaluation',
    path: '/evaluation',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutContactsRouteRoute =
  AppCompaniesCompanyIdEditLayoutContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutCertificationRouteRoute =
  AppCompaniesCompanyIdEditLayoutCertificationRouteImport.update({
    id: '/certification',
    path: '/certification',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutAccountingRouteRoute =
  AppCompaniesCompanyIdEditLayoutAccountingRouteImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutQualityIndexRoute =
  AppProductProductIdEditLayoutQualityIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductProductIdEditLayoutQualityRoute,
  } as any)

const AppProductProductIdEditLayoutCostsIndexRoute =
  AppProductProductIdEditLayoutCostsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductProductIdEditLayoutCostsRoute,
  } as any)

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport.update(
    {
      id: '/comments',
      path: '/comments',
      getParentRoute: () =>
        AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () =>
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute,
  } as any)

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport.update(
    {
      id: '/comments',
      path: '/comments',
      getParentRoute: () =>
        AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport.update(
    {
      id: '/built-pallets',
      path: '/built-pallets',
      getParentRoute: () =>
        AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute,
    } as any,
  )

const AppProductProductIdEditLayoutQualityLayoutRoute =
  AppProductProductIdEditLayoutQualityLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppProductProductIdEditLayoutQualityRoute,
  } as any)

const AppProductProductIdEditLayoutCostsLayoutRoute =
  AppProductProductIdEditLayoutCostsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppProductProductIdEditLayoutCostsRoute,
  } as any)

const AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute =
  AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteImport.update({
    id: '/$locationId',
    path: '/$locationId',
    getParentRoute: () => AppCompaniesCompanyIdEditLayoutLocationsRouteRoute,
  } as any)

const AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute =
  AppProductProductIdEditLayoutQualityLayoutTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AppProductProductIdEditLayoutQualityLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute =
  AppProductProductIdEditLayoutQualityLayoutResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AppProductProductIdEditLayoutQualityLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute =
  AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteImport.update({
    id: '/purchase-costs',
    path: '/purchase-costs',
    getParentRoute: () => AppProductProductIdEditLayoutCostsLayoutRoute,
  } as any)

const AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute =
  AppProductProductIdEditLayoutCostsLayoutLaidDownRouteImport.update({
    id: '/laid-down',
    path: '/laid-down',
    getParentRoute: () => AppProductProductIdEditLayoutCostsLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/deactivated': {
      id: '/deactivated'
      path: '/deactivated'
      fullPath: '/deactivated'
      preLoaderRoute: typeof DeactivatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/app/company': {
      id: '/app/company'
      path: '/company'
      fullPath: '/app/company'
      preLoaderRoute: typeof AppCompanyRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/orders': {
      id: '/app/orders'
      path: '/orders'
      fullPath: '/app/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/regulatory': {
      id: '/app/regulatory'
      path: '/regulatory'
      fullPath: '/app/regulatory'
      preLoaderRoute: typeof AppRegulatoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tablet': {
      id: '/app/tablet'
      path: '/tablet'
      fullPath: '/app/tablet'
      preLoaderRoute: typeof AppTabletImport
      parentRoute: typeof AppRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/sales/customers': {
      id: '/app/sales/customers'
      path: '/sales/customers'
      fullPath: '/app/sales/customers'
      preLoaderRoute: typeof AppSalesCustomersRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/sales/sales-orders': {
      id: '/app/sales/sales-orders'
      path: '/sales/sales-orders'
      fullPath: '/app/sales/sales-orders'
      preLoaderRoute: typeof AppSalesSalesOrdersRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/accounting': {
      id: '/app/accounting'
      path: '/accounting'
      fullPath: '/app/accounting'
      preLoaderRoute: typeof AppAccountingImport
      parentRoute: typeof AppRouteImport
    }
    '/app/accounting/_layout': {
      id: '/app/accounting/_layout'
      path: '/accounting'
      fullPath: '/app/accounting'
      preLoaderRoute: typeof AppAccountingLayoutImport
      parentRoute: typeof AppAccountingRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/_layout': {
      id: '/app/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardLayoutImport
      parentRoute: typeof AppDashboardRoute
    }
    '/app/inventory': {
      id: '/app/inventory'
      path: '/inventory'
      fullPath: '/app/inventory'
      preLoaderRoute: typeof AppInventoryImport
      parentRoute: typeof AppRouteImport
    }
    '/app/inventory/_layout': {
      id: '/app/inventory/_layout'
      path: '/inventory'
      fullPath: '/app/inventory'
      preLoaderRoute: typeof AppInventoryLayoutImport
      parentRoute: typeof AppInventoryRoute
    }
    '/app/pricing': {
      id: '/app/pricing'
      path: '/pricing'
      fullPath: '/app/pricing'
      preLoaderRoute: typeof AppPricingImport
      parentRoute: typeof AppRouteImport
    }
    '/app/pricing/_layout': {
      id: '/app/pricing/_layout'
      path: '/pricing'
      fullPath: '/app/pricing'
      preLoaderRoute: typeof AppPricingLayoutImport
      parentRoute: typeof AppPricingRoute
    }
    '/app/procurement': {
      id: '/app/procurement'
      path: '/procurement'
      fullPath: '/app/procurement'
      preLoaderRoute: typeof AppProcurementImport
      parentRoute: typeof AppRouteImport
    }
    '/app/procurement/_layout': {
      id: '/app/procurement/_layout'
      path: '/procurement'
      fullPath: '/app/procurement'
      preLoaderRoute: typeof AppProcurementLayoutImport
      parentRoute: typeof AppProcurementRoute
    }
    '/app/warehouse-receiving': {
      id: '/app/warehouse-receiving'
      path: '/warehouse-receiving'
      fullPath: '/app/warehouse-receiving'
      preLoaderRoute: typeof AppWarehouseReceivingImport
      parentRoute: typeof AppRouteImport
    }
    '/app/warehouse-receiving/_layout': {
      id: '/app/warehouse-receiving/_layout'
      path: '/warehouse-receiving'
      fullPath: '/app/warehouse-receiving'
      preLoaderRoute: typeof AppWarehouseReceivingLayoutImport
      parentRoute: typeof AppWarehouseReceivingRoute
    }
    '/app/orders/': {
      id: '/app/orders/'
      path: '/'
      fullPath: '/app/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppOrdersRouteImport
    }
    '/app/sales/': {
      id: '/app/sales/'
      path: '/sales'
      fullPath: '/app/sales'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tablet/': {
      id: '/app/tablet/'
      path: '/'
      fullPath: '/app/tablet/'
      preLoaderRoute: typeof AppTabletIndexRouteImport
      parentRoute: typeof AppTabletImport
    }
    '/app/accounting/': {
      id: '/app/accounting/'
      path: '/'
      fullPath: '/app/accounting/'
      preLoaderRoute: typeof AppAccountingIndexImport
      parentRoute: typeof AppAccountingImport
    }
    '/app/admin/': {
      id: '/app/admin/'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/companies/': {
      id: '/app/companies/'
      path: '/companies'
      fullPath: '/app/companies'
      preLoaderRoute: typeof AppCompaniesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/': {
      id: '/app/dashboard/'
      path: '/'
      fullPath: '/app/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexImport
      parentRoute: typeof AppDashboardImport
    }
    '/app/inventory/': {
      id: '/app/inventory/'
      path: '/'
      fullPath: '/app/inventory/'
      preLoaderRoute: typeof AppInventoryIndexImport
      parentRoute: typeof AppInventoryImport
    }
    '/app/pricing/': {
      id: '/app/pricing/'
      path: '/'
      fullPath: '/app/pricing/'
      preLoaderRoute: typeof AppPricingIndexImport
      parentRoute: typeof AppPricingImport
    }
    '/app/procurement/': {
      id: '/app/procurement/'
      path: '/'
      fullPath: '/app/procurement/'
      preLoaderRoute: typeof AppProcurementIndexImport
      parentRoute: typeof AppProcurementImport
    }
    '/app/products/': {
      id: '/app/products/'
      path: '/products'
      fullPath: '/app/products'
      preLoaderRoute: typeof AppProductsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/warehouse-receiving/': {
      id: '/app/warehouse-receiving/'
      path: '/'
      fullPath: '/app/warehouse-receiving/'
      preLoaderRoute: typeof AppWarehouseReceivingIndexImport
      parentRoute: typeof AppWarehouseReceivingImport
    }
    '/app/accounting/_layout/accounts-payable': {
      id: '/app/accounting/_layout/accounts-payable'
      path: '/accounts-payable'
      fullPath: '/app/accounting/accounts-payable'
      preLoaderRoute: typeof AppAccountingLayoutAccountsPayableImport
      parentRoute: typeof AppAccountingLayoutImport
    }
    '/app/accounting/_layout/gl-transactions': {
      id: '/app/accounting/_layout/gl-transactions'
      path: '/gl-transactions'
      fullPath: '/app/accounting/gl-transactions'
      preLoaderRoute: typeof AppAccountingLayoutGlTransactionsImport
      parentRoute: typeof AppAccountingLayoutImport
    }
    '/app/accounting/_layout/huntington-pay-files': {
      id: '/app/accounting/_layout/huntington-pay-files'
      path: '/huntington-pay-files'
      fullPath: '/app/accounting/huntington-pay-files'
      preLoaderRoute: typeof AppAccountingLayoutHuntingtonPayFilesImport
      parentRoute: typeof AppAccountingLayoutImport
    }
    '/app/accounting/_layout/payable-approvals': {
      id: '/app/accounting/_layout/payable-approvals'
      path: '/payable-approvals'
      fullPath: '/app/accounting/payable-approvals'
      preLoaderRoute: typeof AppAccountingLayoutPayableApprovalsImport
      parentRoute: typeof AppAccountingLayoutImport
    }
    '/app/admin/accounting': {
      id: '/app/admin/accounting'
      path: '/admin/accounting'
      fullPath: '/app/admin/accounting'
      preLoaderRoute: typeof AppAdminAccountingImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/accounting/_layout': {
      id: '/app/admin/accounting/_layout'
      path: '/admin/accounting'
      fullPath: '/app/admin/accounting'
      preLoaderRoute: typeof AppAdminAccountingLayoutImport
      parentRoute: typeof AppAdminAccountingRoute
    }
    '/app/admin/accounting/create-payment-term': {
      id: '/app/admin/accounting/create-payment-term'
      path: '/create-payment-term'
      fullPath: '/app/admin/accounting/create-payment-term'
      preLoaderRoute: typeof AppAdminAccountingCreatePaymentTermImport
      parentRoute: typeof AppAdminAccountingImport
    }
    '/app/admin/manage-products': {
      id: '/app/admin/manage-products'
      path: '/admin/manage-products'
      fullPath: '/app/admin/manage-products'
      preLoaderRoute: typeof AppAdminManageProductsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/manage-products/_layout': {
      id: '/app/admin/manage-products/_layout'
      path: '/admin/manage-products'
      fullPath: '/app/admin/manage-products'
      preLoaderRoute: typeof AppAdminManageProductsLayoutImport
      parentRoute: typeof AppAdminManageProductsRoute
    }
    '/app/admin/system-admin': {
      id: '/app/admin/system-admin'
      path: '/admin/system-admin'
      fullPath: '/app/admin/system-admin'
      preLoaderRoute: typeof AppAdminSystemAdminImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/system-admin/_layout': {
      id: '/app/admin/system-admin/_layout'
      path: '/admin/system-admin'
      fullPath: '/app/admin/system-admin'
      preLoaderRoute: typeof AppAdminSystemAdminLayoutImport
      parentRoute: typeof AppAdminSystemAdminRoute
    }
    '/app/dashboard/_layout/my-requests': {
      id: '/app/dashboard/_layout/my-requests'
      path: '/my-requests'
      fullPath: '/app/dashboard/my-requests'
      preLoaderRoute: typeof AppDashboardLayoutMyRequestsImport
      parentRoute: typeof AppDashboardLayoutImport
    }
    '/app/inventory/_layout/adjustment-history': {
      id: '/app/inventory/_layout/adjustment-history'
      path: '/adjustment-history'
      fullPath: '/app/inventory/adjustment-history'
      preLoaderRoute: typeof AppInventoryLayoutAdjustmentHistoryImport
      parentRoute: typeof AppInventoryLayoutImport
    }
    '/app/inventory/_layout/products': {
      id: '/app/inventory/_layout/products'
      path: '/products'
      fullPath: '/app/inventory/products'
      preLoaderRoute: typeof AppInventoryLayoutProductsImport
      parentRoute: typeof AppInventoryLayoutImport
    }
    '/app/inventory/_layout/transfers': {
      id: '/app/inventory/_layout/transfers'
      path: '/transfers'
      fullPath: '/app/inventory/transfers'
      preLoaderRoute: typeof AppInventoryLayoutTransfersImport
      parentRoute: typeof AppInventoryLayoutImport
    }
    '/app/inventory/transfers/new': {
      id: '/app/inventory/transfers/new'
      path: '/transfers/new'
      fullPath: '/app/inventory/transfers/new'
      preLoaderRoute: typeof AppInventoryTransfersNewImport
      parentRoute: typeof AppInventoryImport
    }
    '/app/pricing/$priceChangeId/review': {
      id: '/app/pricing/$priceChangeId/review'
      path: '/$priceChangeId/review'
      fullPath: '/app/pricing/$priceChangeId/review'
      preLoaderRoute: typeof AppPricingPriceChangeIdReviewImport
      parentRoute: typeof AppPricingImport
    }
    '/app/pricing/_layout/price-change': {
      id: '/app/pricing/_layout/price-change'
      path: '/price-change'
      fullPath: '/app/pricing/price-change'
      preLoaderRoute: typeof AppPricingLayoutPriceChangeImport
      parentRoute: typeof AppPricingLayoutImport
    }
    '/app/procurement/_layout/cost-breakdown': {
      id: '/app/procurement/_layout/cost-breakdown'
      path: '/cost-breakdown'
      fullPath: '/app/procurement/cost-breakdown'
      preLoaderRoute: typeof AppProcurementLayoutCostBreakdownImport
      parentRoute: typeof AppProcurementLayoutImport
    }
    '/app/procurement/_layout/purchase-orders': {
      id: '/app/procurement/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/procurement/purchase-orders'
      preLoaderRoute: typeof AppProcurementLayoutPurchaseOrdersImport
      parentRoute: typeof AppProcurementLayoutImport
    }
    '/app/procurement/_layout/supplier-report': {
      id: '/app/procurement/_layout/supplier-report'
      path: '/supplier-report'
      fullPath: '/app/procurement/supplier-report'
      preLoaderRoute: typeof AppProcurementLayoutSupplierReportImport
      parentRoute: typeof AppProcurementLayoutImport
    }
    '/app/tablet/warehouse-receiving': {
      id: '/app/tablet/warehouse-receiving'
      path: '/warehouse-receiving'
      fullPath: '/app/tablet/warehouse-receiving'
      preLoaderRoute: typeof AppTabletWarehouseReceivingImport
      parentRoute: typeof AppTabletImport
    }
    '/app/tablet/warehouse-receiving/_layout': {
      id: '/app/tablet/warehouse-receiving/_layout'
      path: '/warehouse-receiving'
      fullPath: '/app/tablet/warehouse-receiving'
      preLoaderRoute: typeof AppTabletWarehouseReceivingLayoutImport
      parentRoute: typeof AppTabletWarehouseReceivingRoute
    }
    '/app/warehouse-receiving/_layout/checked-in': {
      id: '/app/warehouse-receiving/_layout/checked-in'
      path: '/checked-in'
      fullPath: '/app/warehouse-receiving/checked-in'
      preLoaderRoute: typeof AppWarehouseReceivingLayoutCheckedInImport
      parentRoute: typeof AppWarehouseReceivingLayoutImport
    }
    '/app/warehouse-receiving/_layout/incoming': {
      id: '/app/warehouse-receiving/_layout/incoming'
      path: '/incoming'
      fullPath: '/app/warehouse-receiving/incoming'
      preLoaderRoute: typeof AppWarehouseReceivingLayoutIncomingImport
      parentRoute: typeof AppWarehouseReceivingLayoutImport
    }
    '/app/warehouse-receiving/_layout/soft-received': {
      id: '/app/warehouse-receiving/_layout/soft-received'
      path: '/soft-received'
      fullPath: '/app/warehouse-receiving/soft-received'
      preLoaderRoute: typeof AppWarehouseReceivingLayoutSoftReceivedImport
      parentRoute: typeof AppWarehouseReceivingLayoutImport
    }
    '/app/warehouse-receiving/_layout/stored': {
      id: '/app/warehouse-receiving/_layout/stored'
      path: '/stored'
      fullPath: '/app/warehouse-receiving/stored'
      preLoaderRoute: typeof AppWarehouseReceivingLayoutStoredImport
      parentRoute: typeof AppWarehouseReceivingLayoutImport
    }
    '/app/tablet/sales/': {
      id: '/app/tablet/sales/'
      path: '/sales'
      fullPath: '/app/tablet/sales'
      preLoaderRoute: typeof AppTabletSalesIndexRouteImport
      parentRoute: typeof AppTabletImport
    }
    '/app/admin/accounting/': {
      id: '/app/admin/accounting/'
      path: '/'
      fullPath: '/app/admin/accounting/'
      preLoaderRoute: typeof AppAdminAccountingIndexImport
      parentRoute: typeof AppAdminAccountingImport
    }
    '/app/admin/change-log/': {
      id: '/app/admin/change-log/'
      path: '/admin/change-log'
      fullPath: '/app/admin/change-log'
      preLoaderRoute: typeof AppAdminChangeLogIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/manage-products/': {
      id: '/app/admin/manage-products/'
      path: '/'
      fullPath: '/app/admin/manage-products/'
      preLoaderRoute: typeof AppAdminManageProductsIndexImport
      parentRoute: typeof AppAdminManageProductsImport
    }
    '/app/admin/system-admin/': {
      id: '/app/admin/system-admin/'
      path: '/'
      fullPath: '/app/admin/system-admin/'
      preLoaderRoute: typeof AppAdminSystemAdminIndexImport
      parentRoute: typeof AppAdminSystemAdminImport
    }
    '/app/admin/warehouses/': {
      id: '/app/admin/warehouses/'
      path: '/admin/warehouses'
      fullPath: '/app/admin/warehouses'
      preLoaderRoute: typeof AppAdminWarehousesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tablet/warehouse-receiving/': {
      id: '/app/tablet/warehouse-receiving/'
      path: '/'
      fullPath: '/app/tablet/warehouse-receiving/'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIndexImport
      parentRoute: typeof AppTabletWarehouseReceivingImport
    }
    '/app/contact/$contactId/': {
      id: '/app/contact/$contactId/'
      path: '/contact/$contactId'
      fullPath: '/app/contact/$contactId'
      preLoaderRoute: typeof AppContactContactIdIndexLazyImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/accounting/_layout/accounts-chart': {
      id: '/app/admin/accounting/_layout/accounts-chart'
      path: '/accounts-chart'
      fullPath: '/app/admin/accounting/accounts-chart'
      preLoaderRoute: typeof AppAdminAccountingLayoutAccountsChartImport
      parentRoute: typeof AppAdminAccountingLayoutImport
    }
    '/app/admin/accounting/_layout/payment-terms': {
      id: '/app/admin/accounting/_layout/payment-terms'
      path: '/payment-terms'
      fullPath: '/app/admin/accounting/payment-terms'
      preLoaderRoute: typeof AppAdminAccountingLayoutPaymentTermsImport
      parentRoute: typeof AppAdminAccountingLayoutImport
    }
    '/app/admin/accounting/_layout/settings': {
      id: '/app/admin/accounting/_layout/settings'
      path: '/settings'
      fullPath: '/app/admin/accounting/settings'
      preLoaderRoute: typeof AppAdminAccountingLayoutSettingsImport
      parentRoute: typeof AppAdminAccountingLayoutImport
    }
    '/app/admin/accounting/payment-term/$paymentTermId': {
      id: '/app/admin/accounting/payment-term/$paymentTermId'
      path: '/payment-term/$paymentTermId'
      fullPath: '/app/admin/accounting/payment-term/$paymentTermId'
      preLoaderRoute: typeof AppAdminAccountingPaymentTermPaymentTermIdImport
      parentRoute: typeof AppAdminAccountingImport
    }
    '/app/admin/manage-products/_layout/categories': {
      id: '/app/admin/manage-products/_layout/categories'
      path: '/categories'
      fullPath: '/app/admin/manage-products/categories'
      preLoaderRoute: typeof AppAdminManageProductsLayoutCategoriesImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/manage-products/_layout/classes': {
      id: '/app/admin/manage-products/_layout/classes'
      path: '/classes'
      fullPath: '/app/admin/manage-products/classes'
      preLoaderRoute: typeof AppAdminManageProductsLayoutClassesImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/manage-products/_layout/competitor-products': {
      id: '/app/admin/manage-products/_layout/competitor-products'
      path: '/competitor-products'
      fullPath: '/app/admin/manage-products/competitor-products'
      preLoaderRoute: typeof AppAdminManageProductsLayoutCompetitorProductsImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/manage-products/_layout/equivalents': {
      id: '/app/admin/manage-products/_layout/equivalents'
      path: '/equivalents'
      fullPath: '/app/admin/manage-products/equivalents'
      preLoaderRoute: typeof AppAdminManageProductsLayoutEquivalentsImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/manage-products/_layout/instructions': {
      id: '/app/admin/manage-products/_layout/instructions'
      path: '/instructions'
      fullPath: '/app/admin/manage-products/instructions'
      preLoaderRoute: typeof AppAdminManageProductsLayoutInstructionsImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/manage-products/_layout/test-templates': {
      id: '/app/admin/manage-products/_layout/test-templates'
      path: '/test-templates'
      fullPath: '/app/admin/manage-products/test-templates'
      preLoaderRoute: typeof AppAdminManageProductsLayoutTestTemplatesImport
      parentRoute: typeof AppAdminManageProductsLayoutImport
    }
    '/app/admin/system-admin/_layout/roles': {
      id: '/app/admin/system-admin/_layout/roles'
      path: '/roles'
      fullPath: '/app/admin/system-admin/roles'
      preLoaderRoute: typeof AppAdminSystemAdminLayoutRolesImport
      parentRoute: typeof AppAdminSystemAdminLayoutImport
    }
    '/app/admin/system-admin/_layout/users': {
      id: '/app/admin/system-admin/_layout/users'
      path: '/users'
      fullPath: '/app/admin/system-admin/users'
      preLoaderRoute: typeof AppAdminSystemAdminLayoutUsersImport
      parentRoute: typeof AppAdminSystemAdminLayoutImport
    }
    '/app/admin/system-admin/users/$userId': {
      id: '/app/admin/system-admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/app/admin/system-admin/users/$userId'
      preLoaderRoute: typeof AppAdminSystemAdminUsersUserIdImport
      parentRoute: typeof AppAdminSystemAdminImport
    }
    '/app/admin/warehouses/$warehouseId': {
      id: '/app/admin/warehouses/$warehouseId'
      path: '/admin/warehouses/$warehouseId'
      fullPath: '/app/admin/warehouses/$warehouseId'
      preLoaderRoute: typeof AppAdminWarehousesWarehouseIdImport
      parentRoute: typeof AppRouteImport
    }
    '/app/admin/warehouses/$warehouseId/_layout': {
      id: '/app/admin/warehouses/$warehouseId/_layout'
      path: '/admin/warehouses/$warehouseId'
      fullPath: '/app/admin/warehouses/$warehouseId'
      preLoaderRoute: typeof AppAdminWarehousesWarehouseIdLayoutImport
      parentRoute: typeof AppAdminWarehousesWarehouseIdRoute
    }
    '/app/companies/$companyId/edit': {
      id: '/app/companies/$companyId/edit'
      path: '/companies/$companyId/edit'
      fullPath: '/app/companies/$companyId/edit'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditImport
      parentRoute: typeof AppRouteImport
    }
    '/app/companies/$companyId/edit/_layout': {
      id: '/app/companies/$companyId/edit/_layout'
      path: '/companies/$companyId/edit'
      fullPath: '/app/companies/$companyId/edit'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutImport
      parentRoute: typeof AppCompaniesCompanyIdEditRoute
    }
    '/app/dashboard/_layout/pending-approvals': {
      id: '/app/dashboard/_layout/pending-approvals'
      path: '/pending-approvals'
      fullPath: '/app/dashboard/pending-approvals'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsImport
      parentRoute: typeof AppDashboardLayoutImport
    }
    '/app/dashboard/_layout/pending-approvals/_layout': {
      id: '/app/dashboard/_layout/pending-approvals/_layout'
      path: '/pending-approvals'
      fullPath: '/app/dashboard/pending-approvals'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsLayoutImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsRoute
    }
    '/app/inventory/products/$productId': {
      id: '/app/inventory/products/$productId'
      path: '/products/$productId'
      fullPath: '/app/inventory/products/$productId'
      preLoaderRoute: typeof AppInventoryProductsProductIdImport
      parentRoute: typeof AppInventoryImport
    }
    '/app/inventory/products/$productId/_layout': {
      id: '/app/inventory/products/$productId/_layout'
      path: '/products/$productId'
      fullPath: '/app/inventory/products/$productId'
      preLoaderRoute: typeof AppInventoryProductsProductIdLayoutImport
      parentRoute: typeof AppInventoryProductsProductIdRoute
    }
    '/app/inventory/transfers/$transferId/edit': {
      id: '/app/inventory/transfers/$transferId/edit'
      path: '/transfers/$transferId/edit'
      fullPath: '/app/inventory/transfers/$transferId/edit'
      preLoaderRoute: typeof AppInventoryTransfersTransferIdEditImport
      parentRoute: typeof AppInventoryImport
    }
    '/app/orders/$companyId/$shipToLocationId': {
      id: '/app/orders/$companyId/$shipToLocationId'
      path: '/$companyId/$shipToLocationId'
      fullPath: '/app/orders/$companyId/$shipToLocationId'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdImport
      parentRoute: typeof AppOrdersRouteImport
    }
    '/app/orders/$companyId/$shipToLocationId/_layout': {
      id: '/app/orders/$companyId/$shipToLocationId/_layout'
      path: '/$companyId/$shipToLocationId'
      fullPath: '/app/orders/$companyId/$shipToLocationId'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutImport
      parentRoute: typeof AppOrdersCompanyIdShipToLocationIdRoute
    }
    '/app/pricing/_layout/history/price-change': {
      id: '/app/pricing/_layout/history/price-change'
      path: '/history/price-change'
      fullPath: '/app/pricing/history/price-change'
      preLoaderRoute: typeof AppPricingLayoutHistoryPriceChangeImport
      parentRoute: typeof AppPricingLayoutImport
    }
    '/app/pricing/_layout/history/purchase-cost': {
      id: '/app/pricing/_layout/history/purchase-cost'
      path: '/history/purchase-cost'
      fullPath: '/app/pricing/history/purchase-cost'
      preLoaderRoute: typeof AppPricingLayoutHistoryPurchaseCostImport
      parentRoute: typeof AppPricingLayoutImport
    }
    '/app/procurement/_layout_/purchase-orders/$purchaseOrderId': {
      id: '/app/procurement/_layout_/purchase-orders/$purchaseOrderId'
      path: '/purchase-orders/$purchaseOrderId'
      fullPath: '/app/procurement/purchase-orders/$purchaseOrderId'
      preLoaderRoute: typeof AppProcurementLayoutPurchaseOrdersPurchaseOrderIdImport
      parentRoute: typeof AppProcurementImport
    }
    '/app/product/$productId/edit': {
      id: '/app/product/$productId/edit'
      path: '/product/$productId/edit'
      fullPath: '/app/product/$productId/edit'
      preLoaderRoute: typeof AppProductProductIdEditImport
      parentRoute: typeof AppRouteImport
    }
    '/app/product/$productId/edit/_layout': {
      id: '/app/product/$productId/edit/_layout'
      path: '/product/$productId/edit'
      fullPath: '/app/product/$productId/edit'
      preLoaderRoute: typeof AppProductProductIdEditLayoutImport
      parentRoute: typeof AppProductProductIdEditRoute
    }
    '/app/tablet/warehouse-receiving/_layout/checked-in': {
      id: '/app/tablet/warehouse-receiving/_layout/checked-in'
      path: '/checked-in'
      fullPath: '/app/tablet/warehouse-receiving/checked-in'
      preLoaderRoute: typeof AppTabletWarehouseReceivingLayoutCheckedInImport
      parentRoute: typeof AppTabletWarehouseReceivingLayoutImport
    }
    '/app/tablet/warehouse-receiving/_layout/incoming': {
      id: '/app/tablet/warehouse-receiving/_layout/incoming'
      path: '/incoming'
      fullPath: '/app/tablet/warehouse-receiving/incoming'
      preLoaderRoute: typeof AppTabletWarehouseReceivingLayoutIncomingImport
      parentRoute: typeof AppTabletWarehouseReceivingLayoutImport
    }
    '/app/tablet/warehouse-receiving/_layout/soft-received': {
      id: '/app/tablet/warehouse-receiving/_layout/soft-received'
      path: '/soft-received'
      fullPath: '/app/tablet/warehouse-receiving/soft-received'
      preLoaderRoute: typeof AppTabletWarehouseReceivingLayoutSoftReceivedImport
      parentRoute: typeof AppTabletWarehouseReceivingLayoutImport
    }
    '/app/tablet/warehouse-receiving/_layout/stored': {
      id: '/app/tablet/warehouse-receiving/_layout/stored'
      path: '/stored'
      fullPath: '/app/tablet/warehouse-receiving/stored'
      preLoaderRoute: typeof AppTabletWarehouseReceivingLayoutStoredImport
      parentRoute: typeof AppTabletWarehouseReceivingLayoutImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId'
      path: '/checked-in/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdImport
      parentRoute: typeof AppWarehouseReceivingImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
      path: '/checked-in/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdRoute
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId'
      path: '/incoming/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdImport
      parentRoute: typeof AppWarehouseReceivingImport
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout'
      path: '/incoming/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
      parentRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdRoute
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId'
      path: '/soft-received/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdImport
      parentRoute: typeof AppWarehouseReceivingImport
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
      path: '/soft-received/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
      path: '/finalize-check-in'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId'
      path: '/stored/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdImport
      parentRoute: typeof AppWarehouseReceivingImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout'
      path: '/stored/$goodsReceiptId'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdRoute
    }
    '/app/procurement/_layout/supplier-report/new-supplier': {
      id: '/app/procurement/_layout/supplier-report/new-supplier'
      path: '/new-supplier'
      fullPath: '/app/procurement/supplier-report/new-supplier'
      preLoaderRoute: typeof AppProcurementLayoutSupplierReportNewSupplierLazyImport
      parentRoute: typeof AppProcurementLayoutSupplierReportImport
    }
    '/app/admin/warehouses/$warehouseId/': {
      id: '/app/admin/warehouses/$warehouseId/'
      path: '/'
      fullPath: '/app/admin/warehouses/$warehouseId/'
      preLoaderRoute: typeof AppAdminWarehousesWarehouseIdIndexImport
      parentRoute: typeof AppAdminWarehousesWarehouseIdImport
    }
    '/app/companies/$companyId/edit/': {
      id: '/app/companies/$companyId/edit/'
      path: '/'
      fullPath: '/app/companies/$companyId/edit/'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditIndexImport
      parentRoute: typeof AppCompaniesCompanyIdEditImport
    }
    '/app/dashboard/_layout/pending-approvals/': {
      id: '/app/dashboard/_layout/pending-approvals/'
      path: '/'
      fullPath: '/app/dashboard/pending-approvals/'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsIndexImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsImport
    }
    '/app/product/$productId/edit/': {
      id: '/app/product/$productId/edit/'
      path: '/'
      fullPath: '/app/product/$productId/edit/'
      preLoaderRoute: typeof AppProductProductIdEditIndexImport
      parentRoute: typeof AppProductProductIdEditImport
    }
    '/app/product/$productId/preference/': {
      id: '/app/product/$productId/preference/'
      path: '/product/$productId/preference'
      fullPath: '/app/product/$productId/preference'
      preLoaderRoute: typeof AppProductProductIdPreferenceIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/companies/$companyId/edit/_layout/accounting': {
      id: '/app/companies/$companyId/edit/_layout/accounting'
      path: '/accounting'
      fullPath: '/app/companies/$companyId/edit/accounting'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutAccountingRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/certification': {
      id: '/app/companies/$companyId/edit/_layout/certification'
      path: '/certification'
      fullPath: '/app/companies/$companyId/edit/certification'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutCertificationRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/contacts': {
      id: '/app/companies/$companyId/edit/_layout/contacts'
      path: '/contacts'
      fullPath: '/app/companies/$companyId/edit/contacts'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutContactsRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/evaluation': {
      id: '/app/companies/$companyId/edit/_layout/evaluation'
      path: '/evaluation'
      fullPath: '/app/companies/$companyId/edit/evaluation'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutEvaluationRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/info': {
      id: '/app/companies/$companyId/edit/_layout/info'
      path: '/info'
      fullPath: '/app/companies/$companyId/edit/info'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutInfoRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/locations': {
      id: '/app/companies/$companyId/edit/_layout/locations'
      path: '/locations'
      fullPath: '/app/companies/$companyId/edit/locations'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutLocationsRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/preferences': {
      id: '/app/companies/$companyId/edit/_layout/preferences'
      path: '/preferences'
      fullPath: '/app/companies/$companyId/edit/preferences'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutPreferencesRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/products': {
      id: '/app/companies/$companyId/edit/_layout/products'
      path: '/products'
      fullPath: '/app/companies/$companyId/edit/products'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutProductsRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/registration': {
      id: '/app/companies/$companyId/edit/_layout/registration'
      path: '/registration'
      fullPath: '/app/companies/$companyId/edit/registration'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutRegistrationRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutImport
    }
    '/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders': {
      id: '/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders'
      path: '/closed-sales-orders'
      fullPath: '/app/orders/$companyId/$shipToLocationId/closed-sales-orders'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteImport
      parentRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutImport
    }
    '/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders': {
      id: '/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders'
      path: '/customer-purchase-orders'
      fullPath: '/app/orders/$companyId/$shipToLocationId/customer-purchase-orders'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteImport
      parentRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutImport
    }
    '/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders': {
      id: '/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders'
      path: '/open-sales-orders'
      fullPath: '/app/orders/$companyId/$shipToLocationId/open-sales-orders'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteImport
      parentRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutImport
    }
    '/app/product/$productId/edit/_layout/information': {
      id: '/app/product/$productId/edit/_layout/information'
      path: '/information'
      fullPath: '/app/product/$productId/edit/information'
      preLoaderRoute: typeof AppProductProductIdEditLayoutInformationRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/product/$productId/edit/_layout/instructions': {
      id: '/app/product/$productId/edit/_layout/instructions'
      path: '/instructions'
      fullPath: '/app/product/$productId/edit/instructions'
      preLoaderRoute: typeof AppProductProductIdEditLayoutInstructionsRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/product/$productId/edit/_layout/regulatory': {
      id: '/app/product/$productId/edit/_layout/regulatory'
      path: '/regulatory'
      fullPath: '/app/product/$productId/edit/regulatory'
      preLoaderRoute: typeof AppProductProductIdEditLayoutRegulatoryRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/product/$productId/edit/_layout/storage': {
      id: '/app/product/$productId/edit/_layout/storage'
      path: '/storage'
      fullPath: '/app/product/$productId/edit/storage'
      preLoaderRoute: typeof AppProductProductIdEditLayoutStorageRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/admin/warehouses/$warehouseId/_layout/info': {
      id: '/app/admin/warehouses/$warehouseId/_layout/info'
      path: '/info'
      fullPath: '/app/admin/warehouses/$warehouseId/info'
      preLoaderRoute: typeof AppAdminWarehousesWarehouseIdLayoutInfoImport
      parentRoute: typeof AppAdminWarehousesWarehouseIdLayoutImport
    }
    '/app/admin/warehouses/$warehouseId/_layout/shelving': {
      id: '/app/admin/warehouses/$warehouseId/_layout/shelving'
      path: '/shelving'
      fullPath: '/app/admin/warehouses/$warehouseId/shelving'
      preLoaderRoute: typeof AppAdminWarehousesWarehouseIdLayoutShelvingImport
      parentRoute: typeof AppAdminWarehousesWarehouseIdLayoutImport
    }
    '/app/dashboard/_layout/pending-approvals/_layout/price': {
      id: '/app/dashboard/_layout/pending-approvals/_layout/price'
      path: '/price'
      fullPath: '/app/dashboard/pending-approvals/price'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsLayoutPriceImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsLayoutImport
    }
    '/app/dashboard/_layout/pending-approvals/_layout/quality': {
      id: '/app/dashboard/_layout/pending-approvals/_layout/quality'
      path: '/quality'
      fullPath: '/app/dashboard/pending-approvals/quality'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsLayoutQualityImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsLayoutImport
    }
    '/app/dashboard/_layout/pending-approvals/_layout/sample': {
      id: '/app/dashboard/_layout/pending-approvals/_layout/sample'
      path: '/sample'
      fullPath: '/app/dashboard/pending-approvals/sample'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsLayoutSampleImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsLayoutImport
    }
    '/app/dashboard/_layout/pending-approvals/_layout/source-change': {
      id: '/app/dashboard/_layout/pending-approvals/_layout/source-change'
      path: '/source-change'
      fullPath: '/app/dashboard/pending-approvals/source-change'
      preLoaderRoute: typeof AppDashboardLayoutPendingApprovalsLayoutSourceChangeImport
      parentRoute: typeof AppDashboardLayoutPendingApprovalsLayoutImport
    }
    '/app/inventory/products/$productId/_layout/lots': {
      id: '/app/inventory/products/$productId/_layout/lots'
      path: '/lots'
      fullPath: '/app/inventory/products/$productId/lots'
      preLoaderRoute: typeof AppInventoryProductsProductIdLayoutLotsImport
      parentRoute: typeof AppInventoryProductsProductIdLayoutImport
    }
    '/app/inventory/products/$productId/_layout/pallets': {
      id: '/app/inventory/products/$productId/_layout/pallets'
      path: '/pallets'
      fullPath: '/app/inventory/products/$productId/pallets'
      preLoaderRoute: typeof AppInventoryProductsProductIdLayoutPalletsImport
      parentRoute: typeof AppInventoryProductsProductIdLayoutImport
    }
    '/app/inventory/products/$productId/_layout/transactions': {
      id: '/app/inventory/products/$productId/_layout/transactions'
      path: '/transactions'
      fullPath: '/app/inventory/products/$productId/transactions'
      preLoaderRoute: typeof AppInventoryProductsProductIdLayoutTransactionsImport
      parentRoute: typeof AppInventoryProductsProductIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
      path: '/checked-in/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdImport
      parentRoute: typeof AppTabletWarehouseReceivingImport
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
      path: '/checked-in/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
      parentRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute
    }
    '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId': {
      id: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
      path: '/incoming/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdImport
      parentRoute: typeof AppTabletWarehouseReceivingImport
    }
    '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout': {
      id: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout'
      path: '/incoming/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
      parentRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
      path: '/soft-received/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdImport
      parentRoute: typeof AppTabletWarehouseReceivingImport
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
      path: '/soft-received/$goodsReceiptId'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
      parentRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
      path: '/finalize-check-in'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInImport
      parentRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
      path: '/built-pallets'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads'
      path: '/uploads'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId/uploads'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads'
      path: '/uploads'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId/uploads'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsImport
      parentRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads'
      path: '/uploads'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId/uploads'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets'
      path: '/built-pallets'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads'
      path: '/uploads'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId/uploads'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
    }
    '/app/orders/$companyId/$shipToLocationId/_layout/': {
      id: '/app/orders/$companyId/$shipToLocationId/_layout/'
      path: '/'
      fullPath: '/app/orders/$companyId/$shipToLocationId/'
      preLoaderRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteImport
      parentRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutImport
    }
    '/app/inventory/products/$productId/_layout/': {
      id: '/app/inventory/products/$productId/_layout/'
      path: '/'
      fullPath: '/app/inventory/products/$productId/'
      preLoaderRoute: typeof AppInventoryProductsProductIdLayoutIndexImport
      parentRoute: typeof AppInventoryProductsProductIdLayoutImport
    }
    '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/': {
      id: '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/warehouse-receiving/checked-in/$goodsReceiptId/'
      preLoaderRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/': {
      id: '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/warehouse-receiving/incoming/$goodsReceiptId/'
      preLoaderRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/': {
      id: '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/warehouse-receiving/soft-received/$goodsReceiptId/'
      preLoaderRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/': {
      id: '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/warehouse-receiving/stored/$goodsReceiptId/'
      preLoaderRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutImport
    }
    '/app/companies/$companyId/edit/_layout/locations/$locationId': {
      id: '/app/companies/$companyId/edit/_layout/locations/$locationId'
      path: '/$locationId'
      fullPath: '/app/companies/$companyId/edit/locations/$locationId'
      preLoaderRoute: typeof AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteImport
      parentRoute: typeof AppCompaniesCompanyIdEditLayoutLocationsRouteImport
    }
    '/app/product/$productId/edit/_layout/costs': {
      id: '/app/product/$productId/edit/_layout/costs'
      path: '/costs'
      fullPath: '/app/product/$productId/edit/costs'
      preLoaderRoute: typeof AppProductProductIdEditLayoutCostsImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/product/$productId/edit/_layout/costs/_layout': {
      id: '/app/product/$productId/edit/_layout/costs/_layout'
      path: '/costs'
      fullPath: '/app/product/$productId/edit/costs'
      preLoaderRoute: typeof AppProductProductIdEditLayoutCostsLayoutImport
      parentRoute: typeof AppProductProductIdEditLayoutCostsRoute
    }
    '/app/product/$productId/edit/_layout/quality': {
      id: '/app/product/$productId/edit/_layout/quality'
      path: '/quality'
      fullPath: '/app/product/$productId/edit/quality'
      preLoaderRoute: typeof AppProductProductIdEditLayoutQualityImport
      parentRoute: typeof AppProductProductIdEditLayoutImport
    }
    '/app/product/$productId/edit/_layout/quality/_layout': {
      id: '/app/product/$productId/edit/_layout/quality/_layout'
      path: '/quality'
      fullPath: '/app/product/$productId/edit/quality'
      preLoaderRoute: typeof AppProductProductIdEditLayoutQualityLayoutImport
      parentRoute: typeof AppProductProductIdEditLayoutQualityRoute
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
      path: '/built-pallets'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsImport
      parentRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments': {
      id: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
      path: '/comments'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/comments'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsImport
      parentRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersImport
      parentRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/product/$productId/edit/_layout/costs/': {
      id: '/app/product/$productId/edit/_layout/costs/'
      path: '/'
      fullPath: '/app/product/$productId/edit/costs/'
      preLoaderRoute: typeof AppProductProductIdEditLayoutCostsIndexImport
      parentRoute: typeof AppProductProductIdEditLayoutCostsImport
    }
    '/app/product/$productId/edit/_layout/quality/': {
      id: '/app/product/$productId/edit/_layout/quality/'
      path: '/'
      fullPath: '/app/product/$productId/edit/quality/'
      preLoaderRoute: typeof AppProductProductIdEditLayoutQualityIndexImport
      parentRoute: typeof AppProductProductIdEditLayoutQualityImport
    }
    '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/': {
      id: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/'
      preLoaderRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/': {
      id: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/'
      preLoaderRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutImport
    }
    '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/': {
      id: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/'
      path: '/'
      fullPath: '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/'
      preLoaderRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexImport
      parentRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutImport
    }
    '/app/product/$productId/edit/_layout/costs/_layout/laid-down': {
      id: '/app/product/$productId/edit/_layout/costs/_layout/laid-down'
      path: '/laid-down'
      fullPath: '/app/product/$productId/edit/costs/laid-down'
      preLoaderRoute: typeof AppProductProductIdEditLayoutCostsLayoutLaidDownRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutCostsLayoutImport
    }
    '/app/product/$productId/edit/_layout/costs/_layout/purchase-costs': {
      id: '/app/product/$productId/edit/_layout/costs/_layout/purchase-costs'
      path: '/purchase-costs'
      fullPath: '/app/product/$productId/edit/costs/purchase-costs'
      preLoaderRoute: typeof AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutCostsLayoutImport
    }
    '/app/product/$productId/edit/_layout/quality/_layout/results': {
      id: '/app/product/$productId/edit/_layout/quality/_layout/results'
      path: '/results'
      fullPath: '/app/product/$productId/edit/quality/results'
      preLoaderRoute: typeof AppProductProductIdEditLayoutQualityLayoutResultsRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutQualityLayoutImport
    }
    '/app/product/$productId/edit/_layout/quality/_layout/templates': {
      id: '/app/product/$productId/edit/_layout/quality/_layout/templates'
      path: '/templates'
      fullPath: '/app/product/$productId/edit/quality/templates'
      preLoaderRoute: typeof AppProductProductIdEditLayoutQualityLayoutTemplatesRouteImport
      parentRoute: typeof AppProductProductIdEditLayoutQualityLayoutImport
    }
  }
}

// Create and export the route tree

interface AppOrdersCompanyIdShipToLocationIdLayoutRouteChildren {
  AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute
  AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute
  AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute
  AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute
}

const AppOrdersCompanyIdShipToLocationIdLayoutRouteChildren: AppOrdersCompanyIdShipToLocationIdLayoutRouteChildren =
  {
    AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute:
      AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute,
    AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute:
      AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute,
    AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute:
      AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute,
    AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute:
      AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute,
  }

const AppOrdersCompanyIdShipToLocationIdLayoutRouteWithChildren =
  AppOrdersCompanyIdShipToLocationIdLayoutRoute._addFileChildren(
    AppOrdersCompanyIdShipToLocationIdLayoutRouteChildren,
  )

interface AppOrdersCompanyIdShipToLocationIdRouteChildren {
  AppOrdersCompanyIdShipToLocationIdLayoutRoute: typeof AppOrdersCompanyIdShipToLocationIdLayoutRouteWithChildren
}

const AppOrdersCompanyIdShipToLocationIdRouteChildren: AppOrdersCompanyIdShipToLocationIdRouteChildren =
  {
    AppOrdersCompanyIdShipToLocationIdLayoutRoute:
      AppOrdersCompanyIdShipToLocationIdLayoutRouteWithChildren,
  }

const AppOrdersCompanyIdShipToLocationIdRouteWithChildren =
  AppOrdersCompanyIdShipToLocationIdRoute._addFileChildren(
    AppOrdersCompanyIdShipToLocationIdRouteChildren,
  )

interface AppOrdersRouteRouteChildren {
  AppOrdersIndexRouteRoute: typeof AppOrdersIndexRouteRoute
  AppOrdersCompanyIdShipToLocationIdRoute: typeof AppOrdersCompanyIdShipToLocationIdRouteWithChildren
}

const AppOrdersRouteRouteChildren: AppOrdersRouteRouteChildren = {
  AppOrdersIndexRouteRoute: AppOrdersIndexRouteRoute,
  AppOrdersCompanyIdShipToLocationIdRoute:
    AppOrdersCompanyIdShipToLocationIdRouteWithChildren,
}

const AppOrdersRouteRouteWithChildren = AppOrdersRouteRoute._addFileChildren(
  AppOrdersRouteRouteChildren,
)

interface AppTabletWarehouseReceivingLayoutRouteChildren {
  AppTabletWarehouseReceivingLayoutCheckedInRoute: typeof AppTabletWarehouseReceivingLayoutCheckedInRoute
  AppTabletWarehouseReceivingLayoutIncomingRoute: typeof AppTabletWarehouseReceivingLayoutIncomingRoute
  AppTabletWarehouseReceivingLayoutSoftReceivedRoute: typeof AppTabletWarehouseReceivingLayoutSoftReceivedRoute
  AppTabletWarehouseReceivingLayoutStoredRoute: typeof AppTabletWarehouseReceivingLayoutStoredRoute
}

const AppTabletWarehouseReceivingLayoutRouteChildren: AppTabletWarehouseReceivingLayoutRouteChildren =
  {
    AppTabletWarehouseReceivingLayoutCheckedInRoute:
      AppTabletWarehouseReceivingLayoutCheckedInRoute,
    AppTabletWarehouseReceivingLayoutIncomingRoute:
      AppTabletWarehouseReceivingLayoutIncomingRoute,
    AppTabletWarehouseReceivingLayoutSoftReceivedRoute:
      AppTabletWarehouseReceivingLayoutSoftReceivedRoute,
    AppTabletWarehouseReceivingLayoutStoredRoute:
      AppTabletWarehouseReceivingLayoutStoredRoute,
  }

const AppTabletWarehouseReceivingLayoutRouteWithChildren =
  AppTabletWarehouseReceivingLayoutRoute._addFileChildren(
    AppTabletWarehouseReceivingLayoutRouteChildren,
  )

interface AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren {
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
}

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren: AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren =
  {
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute,
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute,
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute,
  }

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute._addFileChildren(
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren,
  )

interface AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren {
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
}

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren: AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren =
  {
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren,
  }

const AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren =
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute._addFileChildren(
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren,
  )

interface AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren {
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
}

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren: AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren =
  {
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute:
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute,
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute:
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute,
  }

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute._addFileChildren(
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren,
  )

interface AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteChildren {
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
}

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteChildren: AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteChildren =
  {
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute:
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren,
  }

const AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren =
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute._addFileChildren(
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteChildren,
  )

interface AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren {
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
}

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren: AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren =
  {
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute,
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute,
  }

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute._addFileChildren(
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren,
  )

interface AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren {
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
}

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren: AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren =
  {
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren,
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute,
  }

const AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren =
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute._addFileChildren(
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren,
  )

interface AppTabletWarehouseReceivingRouteChildren {
  AppTabletWarehouseReceivingLayoutRoute: typeof AppTabletWarehouseReceivingLayoutRouteWithChildren
  AppTabletWarehouseReceivingIndexRoute: typeof AppTabletWarehouseReceivingIndexRoute
  AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute: typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren
  AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute: typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren
  AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute: typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren
}

const AppTabletWarehouseReceivingRouteChildren: AppTabletWarehouseReceivingRouteChildren =
  {
    AppTabletWarehouseReceivingLayoutRoute:
      AppTabletWarehouseReceivingLayoutRouteWithChildren,
    AppTabletWarehouseReceivingIndexRoute:
      AppTabletWarehouseReceivingIndexRoute,
    AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRoute:
      AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren,
    AppTabletWarehouseReceivingIncomingGoodsReceiptIdRoute:
      AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren,
    AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRoute:
      AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren,
  }

const AppTabletWarehouseReceivingRouteWithChildren =
  AppTabletWarehouseReceivingRoute._addFileChildren(
    AppTabletWarehouseReceivingRouteChildren,
  )

interface AppTabletRouteChildren {
  AppTabletIndexRouteRoute: typeof AppTabletIndexRouteRoute
  AppTabletWarehouseReceivingRoute: typeof AppTabletWarehouseReceivingRouteWithChildren
  AppTabletSalesIndexRouteRoute: typeof AppTabletSalesIndexRouteRoute
}

const AppTabletRouteChildren: AppTabletRouteChildren = {
  AppTabletIndexRouteRoute: AppTabletIndexRouteRoute,
  AppTabletWarehouseReceivingRoute:
    AppTabletWarehouseReceivingRouteWithChildren,
  AppTabletSalesIndexRouteRoute: AppTabletSalesIndexRouteRoute,
}

const AppTabletRouteWithChildren = AppTabletRoute._addFileChildren(
  AppTabletRouteChildren,
)

interface AppAccountingLayoutRouteChildren {
  AppAccountingLayoutAccountsPayableRoute: typeof AppAccountingLayoutAccountsPayableRoute
  AppAccountingLayoutGlTransactionsRoute: typeof AppAccountingLayoutGlTransactionsRoute
  AppAccountingLayoutHuntingtonPayFilesRoute: typeof AppAccountingLayoutHuntingtonPayFilesRoute
  AppAccountingLayoutPayableApprovalsRoute: typeof AppAccountingLayoutPayableApprovalsRoute
}

const AppAccountingLayoutRouteChildren: AppAccountingLayoutRouteChildren = {
  AppAccountingLayoutAccountsPayableRoute:
    AppAccountingLayoutAccountsPayableRoute,
  AppAccountingLayoutGlTransactionsRoute:
    AppAccountingLayoutGlTransactionsRoute,
  AppAccountingLayoutHuntingtonPayFilesRoute:
    AppAccountingLayoutHuntingtonPayFilesRoute,
  AppAccountingLayoutPayableApprovalsRoute:
    AppAccountingLayoutPayableApprovalsRoute,
}

const AppAccountingLayoutRouteWithChildren =
  AppAccountingLayoutRoute._addFileChildren(AppAccountingLayoutRouteChildren)

interface AppAccountingRouteChildren {
  AppAccountingLayoutRoute: typeof AppAccountingLayoutRouteWithChildren
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
}

const AppAccountingRouteChildren: AppAccountingRouteChildren = {
  AppAccountingLayoutRoute: AppAccountingLayoutRouteWithChildren,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
}

const AppAccountingRouteWithChildren = AppAccountingRoute._addFileChildren(
  AppAccountingRouteChildren,
)

interface AppDashboardLayoutPendingApprovalsLayoutRouteChildren {
  AppDashboardLayoutPendingApprovalsLayoutPriceRoute: typeof AppDashboardLayoutPendingApprovalsLayoutPriceRoute
  AppDashboardLayoutPendingApprovalsLayoutQualityRoute: typeof AppDashboardLayoutPendingApprovalsLayoutQualityRoute
  AppDashboardLayoutPendingApprovalsLayoutSampleRoute: typeof AppDashboardLayoutPendingApprovalsLayoutSampleRoute
  AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute: typeof AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute
}

const AppDashboardLayoutPendingApprovalsLayoutRouteChildren: AppDashboardLayoutPendingApprovalsLayoutRouteChildren =
  {
    AppDashboardLayoutPendingApprovalsLayoutPriceRoute:
      AppDashboardLayoutPendingApprovalsLayoutPriceRoute,
    AppDashboardLayoutPendingApprovalsLayoutQualityRoute:
      AppDashboardLayoutPendingApprovalsLayoutQualityRoute,
    AppDashboardLayoutPendingApprovalsLayoutSampleRoute:
      AppDashboardLayoutPendingApprovalsLayoutSampleRoute,
    AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute:
      AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute,
  }

const AppDashboardLayoutPendingApprovalsLayoutRouteWithChildren =
  AppDashboardLayoutPendingApprovalsLayoutRoute._addFileChildren(
    AppDashboardLayoutPendingApprovalsLayoutRouteChildren,
  )

interface AppDashboardLayoutPendingApprovalsRouteChildren {
  AppDashboardLayoutPendingApprovalsLayoutRoute: typeof AppDashboardLayoutPendingApprovalsLayoutRouteWithChildren
  AppDashboardLayoutPendingApprovalsIndexRoute: typeof AppDashboardLayoutPendingApprovalsIndexRoute
}

const AppDashboardLayoutPendingApprovalsRouteChildren: AppDashboardLayoutPendingApprovalsRouteChildren =
  {
    AppDashboardLayoutPendingApprovalsLayoutRoute:
      AppDashboardLayoutPendingApprovalsLayoutRouteWithChildren,
    AppDashboardLayoutPendingApprovalsIndexRoute:
      AppDashboardLayoutPendingApprovalsIndexRoute,
  }

const AppDashboardLayoutPendingApprovalsRouteWithChildren =
  AppDashboardLayoutPendingApprovalsRoute._addFileChildren(
    AppDashboardLayoutPendingApprovalsRouteChildren,
  )

interface AppDashboardLayoutRouteChildren {
  AppDashboardLayoutMyRequestsRoute: typeof AppDashboardLayoutMyRequestsRoute
  AppDashboardLayoutPendingApprovalsRoute: typeof AppDashboardLayoutPendingApprovalsRouteWithChildren
}

const AppDashboardLayoutRouteChildren: AppDashboardLayoutRouteChildren = {
  AppDashboardLayoutMyRequestsRoute: AppDashboardLayoutMyRequestsRoute,
  AppDashboardLayoutPendingApprovalsRoute:
    AppDashboardLayoutPendingApprovalsRouteWithChildren,
}

const AppDashboardLayoutRouteWithChildren =
  AppDashboardLayoutRoute._addFileChildren(AppDashboardLayoutRouteChildren)

interface AppDashboardRouteChildren {
  AppDashboardLayoutRoute: typeof AppDashboardLayoutRouteWithChildren
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
}

const AppDashboardRouteChildren: AppDashboardRouteChildren = {
  AppDashboardLayoutRoute: AppDashboardLayoutRouteWithChildren,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
}

const AppDashboardRouteWithChildren = AppDashboardRoute._addFileChildren(
  AppDashboardRouteChildren,
)

interface AppInventoryLayoutRouteChildren {
  AppInventoryLayoutAdjustmentHistoryRoute: typeof AppInventoryLayoutAdjustmentHistoryRoute
  AppInventoryLayoutProductsRoute: typeof AppInventoryLayoutProductsRoute
  AppInventoryLayoutTransfersRoute: typeof AppInventoryLayoutTransfersRoute
}

const AppInventoryLayoutRouteChildren: AppInventoryLayoutRouteChildren = {
  AppInventoryLayoutAdjustmentHistoryRoute:
    AppInventoryLayoutAdjustmentHistoryRoute,
  AppInventoryLayoutProductsRoute: AppInventoryLayoutProductsRoute,
  AppInventoryLayoutTransfersRoute: AppInventoryLayoutTransfersRoute,
}

const AppInventoryLayoutRouteWithChildren =
  AppInventoryLayoutRoute._addFileChildren(AppInventoryLayoutRouteChildren)

interface AppInventoryProductsProductIdLayoutRouteChildren {
  AppInventoryProductsProductIdLayoutLotsRoute: typeof AppInventoryProductsProductIdLayoutLotsRoute
  AppInventoryProductsProductIdLayoutPalletsRoute: typeof AppInventoryProductsProductIdLayoutPalletsRoute
  AppInventoryProductsProductIdLayoutTransactionsRoute: typeof AppInventoryProductsProductIdLayoutTransactionsRoute
  AppInventoryProductsProductIdLayoutIndexRoute: typeof AppInventoryProductsProductIdLayoutIndexRoute
}

const AppInventoryProductsProductIdLayoutRouteChildren: AppInventoryProductsProductIdLayoutRouteChildren =
  {
    AppInventoryProductsProductIdLayoutLotsRoute:
      AppInventoryProductsProductIdLayoutLotsRoute,
    AppInventoryProductsProductIdLayoutPalletsRoute:
      AppInventoryProductsProductIdLayoutPalletsRoute,
    AppInventoryProductsProductIdLayoutTransactionsRoute:
      AppInventoryProductsProductIdLayoutTransactionsRoute,
    AppInventoryProductsProductIdLayoutIndexRoute:
      AppInventoryProductsProductIdLayoutIndexRoute,
  }

const AppInventoryProductsProductIdLayoutRouteWithChildren =
  AppInventoryProductsProductIdLayoutRoute._addFileChildren(
    AppInventoryProductsProductIdLayoutRouteChildren,
  )

interface AppInventoryProductsProductIdRouteChildren {
  AppInventoryProductsProductIdLayoutRoute: typeof AppInventoryProductsProductIdLayoutRouteWithChildren
}

const AppInventoryProductsProductIdRouteChildren: AppInventoryProductsProductIdRouteChildren =
  {
    AppInventoryProductsProductIdLayoutRoute:
      AppInventoryProductsProductIdLayoutRouteWithChildren,
  }

const AppInventoryProductsProductIdRouteWithChildren =
  AppInventoryProductsProductIdRoute._addFileChildren(
    AppInventoryProductsProductIdRouteChildren,
  )

interface AppInventoryRouteChildren {
  AppInventoryLayoutRoute: typeof AppInventoryLayoutRouteWithChildren
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
  AppInventoryTransfersNewRoute: typeof AppInventoryTransfersNewRoute
  AppInventoryProductsProductIdRoute: typeof AppInventoryProductsProductIdRouteWithChildren
  AppInventoryTransfersTransferIdEditRoute: typeof AppInventoryTransfersTransferIdEditRoute
}

const AppInventoryRouteChildren: AppInventoryRouteChildren = {
  AppInventoryLayoutRoute: AppInventoryLayoutRouteWithChildren,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
  AppInventoryTransfersNewRoute: AppInventoryTransfersNewRoute,
  AppInventoryProductsProductIdRoute:
    AppInventoryProductsProductIdRouteWithChildren,
  AppInventoryTransfersTransferIdEditRoute:
    AppInventoryTransfersTransferIdEditRoute,
}

const AppInventoryRouteWithChildren = AppInventoryRoute._addFileChildren(
  AppInventoryRouteChildren,
)

interface AppPricingLayoutRouteChildren {
  AppPricingLayoutPriceChangeRoute: typeof AppPricingLayoutPriceChangeRoute
  AppPricingLayoutHistoryPriceChangeRoute: typeof AppPricingLayoutHistoryPriceChangeRoute
  AppPricingLayoutHistoryPurchaseCostRoute: typeof AppPricingLayoutHistoryPurchaseCostRoute
}

const AppPricingLayoutRouteChildren: AppPricingLayoutRouteChildren = {
  AppPricingLayoutPriceChangeRoute: AppPricingLayoutPriceChangeRoute,
  AppPricingLayoutHistoryPriceChangeRoute:
    AppPricingLayoutHistoryPriceChangeRoute,
  AppPricingLayoutHistoryPurchaseCostRoute:
    AppPricingLayoutHistoryPurchaseCostRoute,
}

const AppPricingLayoutRouteWithChildren =
  AppPricingLayoutRoute._addFileChildren(AppPricingLayoutRouteChildren)

interface AppPricingRouteChildren {
  AppPricingLayoutRoute: typeof AppPricingLayoutRouteWithChildren
  AppPricingIndexRoute: typeof AppPricingIndexRoute
  AppPricingPriceChangeIdReviewRoute: typeof AppPricingPriceChangeIdReviewRoute
}

const AppPricingRouteChildren: AppPricingRouteChildren = {
  AppPricingLayoutRoute: AppPricingLayoutRouteWithChildren,
  AppPricingIndexRoute: AppPricingIndexRoute,
  AppPricingPriceChangeIdReviewRoute: AppPricingPriceChangeIdReviewRoute,
}

const AppPricingRouteWithChildren = AppPricingRoute._addFileChildren(
  AppPricingRouteChildren,
)

interface AppProcurementLayoutSupplierReportRouteChildren {
  AppProcurementLayoutSupplierReportNewSupplierLazyRoute: typeof AppProcurementLayoutSupplierReportNewSupplierLazyRoute
}

const AppProcurementLayoutSupplierReportRouteChildren: AppProcurementLayoutSupplierReportRouteChildren =
  {
    AppProcurementLayoutSupplierReportNewSupplierLazyRoute:
      AppProcurementLayoutSupplierReportNewSupplierLazyRoute,
  }

const AppProcurementLayoutSupplierReportRouteWithChildren =
  AppProcurementLayoutSupplierReportRoute._addFileChildren(
    AppProcurementLayoutSupplierReportRouteChildren,
  )

interface AppProcurementLayoutRouteChildren {
  AppProcurementLayoutCostBreakdownRoute: typeof AppProcurementLayoutCostBreakdownRoute
  AppProcurementLayoutPurchaseOrdersRoute: typeof AppProcurementLayoutPurchaseOrdersRoute
  AppProcurementLayoutSupplierReportRoute: typeof AppProcurementLayoutSupplierReportRouteWithChildren
}

const AppProcurementLayoutRouteChildren: AppProcurementLayoutRouteChildren = {
  AppProcurementLayoutCostBreakdownRoute:
    AppProcurementLayoutCostBreakdownRoute,
  AppProcurementLayoutPurchaseOrdersRoute:
    AppProcurementLayoutPurchaseOrdersRoute,
  AppProcurementLayoutSupplierReportRoute:
    AppProcurementLayoutSupplierReportRouteWithChildren,
}

const AppProcurementLayoutRouteWithChildren =
  AppProcurementLayoutRoute._addFileChildren(AppProcurementLayoutRouteChildren)

interface AppProcurementRouteChildren {
  AppProcurementLayoutRoute: typeof AppProcurementLayoutRouteWithChildren
  AppProcurementIndexRoute: typeof AppProcurementIndexRoute
  AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute: typeof AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute
}

const AppProcurementRouteChildren: AppProcurementRouteChildren = {
  AppProcurementLayoutRoute: AppProcurementLayoutRouteWithChildren,
  AppProcurementIndexRoute: AppProcurementIndexRoute,
  AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute:
    AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute,
}

const AppProcurementRouteWithChildren = AppProcurementRoute._addFileChildren(
  AppProcurementRouteChildren,
)

interface AppWarehouseReceivingLayoutRouteChildren {
  AppWarehouseReceivingLayoutCheckedInRoute: typeof AppWarehouseReceivingLayoutCheckedInRoute
  AppWarehouseReceivingLayoutIncomingRoute: typeof AppWarehouseReceivingLayoutIncomingRoute
  AppWarehouseReceivingLayoutSoftReceivedRoute: typeof AppWarehouseReceivingLayoutSoftReceivedRoute
  AppWarehouseReceivingLayoutStoredRoute: typeof AppWarehouseReceivingLayoutStoredRoute
}

const AppWarehouseReceivingLayoutRouteChildren: AppWarehouseReceivingLayoutRouteChildren =
  {
    AppWarehouseReceivingLayoutCheckedInRoute:
      AppWarehouseReceivingLayoutCheckedInRoute,
    AppWarehouseReceivingLayoutIncomingRoute:
      AppWarehouseReceivingLayoutIncomingRoute,
    AppWarehouseReceivingLayoutSoftReceivedRoute:
      AppWarehouseReceivingLayoutSoftReceivedRoute,
    AppWarehouseReceivingLayoutStoredRoute:
      AppWarehouseReceivingLayoutStoredRoute,
  }

const AppWarehouseReceivingLayoutRouteWithChildren =
  AppWarehouseReceivingLayoutRoute._addFileChildren(
    AppWarehouseReceivingLayoutRouteChildren,
  )

interface AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren {
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
}

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren: AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren =
  {
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute,
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute,
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute,
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute,
  }

const AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren =
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute._addFileChildren(
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteChildren,
  )

interface AppWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren {
  AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
}

const AppWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren: AppWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren =
  {
    AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRoute:
      AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren,
  }

const AppWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren =
  AppWarehouseReceivingCheckedInGoodsReceiptIdRoute._addFileChildren(
    AppWarehouseReceivingCheckedInGoodsReceiptIdRouteChildren,
  )

interface AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren {
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
}

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren: AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren =
  {
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute:
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute,
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute:
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute,
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute:
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute,
  }

const AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren =
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute._addFileChildren(
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteChildren,
  )

interface AppWarehouseReceivingIncomingGoodsReceiptIdRouteChildren {
  AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
}

const AppWarehouseReceivingIncomingGoodsReceiptIdRouteChildren: AppWarehouseReceivingIncomingGoodsReceiptIdRouteChildren =
  {
    AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRoute:
      AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren,
  }

const AppWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren =
  AppWarehouseReceivingIncomingGoodsReceiptIdRoute._addFileChildren(
    AppWarehouseReceivingIncomingGoodsReceiptIdRouteChildren,
  )

interface AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren {
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
}

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren: AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren =
  {
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute,
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute,
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute,
  }

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute._addFileChildren(
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteChildren,
  )

interface AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren {
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
}

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren: AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren =
  {
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren,
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute:
      AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute,
  }

const AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren =
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute._addFileChildren(
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteChildren,
  )

interface AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteChildren {
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute
}

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteChildren: AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteChildren =
  {
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute,
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute,
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute,
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute,
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute,
  }

const AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteWithChildren =
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute._addFileChildren(
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteChildren,
  )

interface AppWarehouseReceivingStoredGoodsReceiptIdRouteChildren {
  AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteWithChildren
}

const AppWarehouseReceivingStoredGoodsReceiptIdRouteChildren: AppWarehouseReceivingStoredGoodsReceiptIdRouteChildren =
  {
    AppWarehouseReceivingStoredGoodsReceiptIdLayoutRoute:
      AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteWithChildren,
  }

const AppWarehouseReceivingStoredGoodsReceiptIdRouteWithChildren =
  AppWarehouseReceivingStoredGoodsReceiptIdRoute._addFileChildren(
    AppWarehouseReceivingStoredGoodsReceiptIdRouteChildren,
  )

interface AppWarehouseReceivingRouteChildren {
  AppWarehouseReceivingLayoutRoute: typeof AppWarehouseReceivingLayoutRouteWithChildren
  AppWarehouseReceivingIndexRoute: typeof AppWarehouseReceivingIndexRoute
  AppWarehouseReceivingCheckedInGoodsReceiptIdRoute: typeof AppWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren
  AppWarehouseReceivingIncomingGoodsReceiptIdRoute: typeof AppWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute: typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren
  AppWarehouseReceivingStoredGoodsReceiptIdRoute: typeof AppWarehouseReceivingStoredGoodsReceiptIdRouteWithChildren
}

const AppWarehouseReceivingRouteChildren: AppWarehouseReceivingRouteChildren = {
  AppWarehouseReceivingLayoutRoute:
    AppWarehouseReceivingLayoutRouteWithChildren,
  AppWarehouseReceivingIndexRoute: AppWarehouseReceivingIndexRoute,
  AppWarehouseReceivingCheckedInGoodsReceiptIdRoute:
    AppWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren,
  AppWarehouseReceivingIncomingGoodsReceiptIdRoute:
    AppWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren,
  AppWarehouseReceivingSoftReceivedGoodsReceiptIdRoute:
    AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren,
  AppWarehouseReceivingStoredGoodsReceiptIdRoute:
    AppWarehouseReceivingStoredGoodsReceiptIdRouteWithChildren,
}

const AppWarehouseReceivingRouteWithChildren =
  AppWarehouseReceivingRoute._addFileChildren(
    AppWarehouseReceivingRouteChildren,
  )

interface AppAdminAccountingLayoutRouteChildren {
  AppAdminAccountingLayoutAccountsChartRoute: typeof AppAdminAccountingLayoutAccountsChartRoute
  AppAdminAccountingLayoutPaymentTermsRoute: typeof AppAdminAccountingLayoutPaymentTermsRoute
  AppAdminAccountingLayoutSettingsRoute: typeof AppAdminAccountingLayoutSettingsRoute
}

const AppAdminAccountingLayoutRouteChildren: AppAdminAccountingLayoutRouteChildren =
  {
    AppAdminAccountingLayoutAccountsChartRoute:
      AppAdminAccountingLayoutAccountsChartRoute,
    AppAdminAccountingLayoutPaymentTermsRoute:
      AppAdminAccountingLayoutPaymentTermsRoute,
    AppAdminAccountingLayoutSettingsRoute:
      AppAdminAccountingLayoutSettingsRoute,
  }

const AppAdminAccountingLayoutRouteWithChildren =
  AppAdminAccountingLayoutRoute._addFileChildren(
    AppAdminAccountingLayoutRouteChildren,
  )

interface AppAdminAccountingRouteChildren {
  AppAdminAccountingLayoutRoute: typeof AppAdminAccountingLayoutRouteWithChildren
  AppAdminAccountingCreatePaymentTermRoute: typeof AppAdminAccountingCreatePaymentTermRoute
  AppAdminAccountingIndexRoute: typeof AppAdminAccountingIndexRoute
  AppAdminAccountingPaymentTermPaymentTermIdRoute: typeof AppAdminAccountingPaymentTermPaymentTermIdRoute
}

const AppAdminAccountingRouteChildren: AppAdminAccountingRouteChildren = {
  AppAdminAccountingLayoutRoute: AppAdminAccountingLayoutRouteWithChildren,
  AppAdminAccountingCreatePaymentTermRoute:
    AppAdminAccountingCreatePaymentTermRoute,
  AppAdminAccountingIndexRoute: AppAdminAccountingIndexRoute,
  AppAdminAccountingPaymentTermPaymentTermIdRoute:
    AppAdminAccountingPaymentTermPaymentTermIdRoute,
}

const AppAdminAccountingRouteWithChildren =
  AppAdminAccountingRoute._addFileChildren(AppAdminAccountingRouteChildren)

interface AppAdminManageProductsLayoutRouteChildren {
  AppAdminManageProductsLayoutCategoriesRoute: typeof AppAdminManageProductsLayoutCategoriesRoute
  AppAdminManageProductsLayoutClassesRoute: typeof AppAdminManageProductsLayoutClassesRoute
  AppAdminManageProductsLayoutCompetitorProductsRoute: typeof AppAdminManageProductsLayoutCompetitorProductsRoute
  AppAdminManageProductsLayoutEquivalentsRoute: typeof AppAdminManageProductsLayoutEquivalentsRoute
  AppAdminManageProductsLayoutInstructionsRoute: typeof AppAdminManageProductsLayoutInstructionsRoute
  AppAdminManageProductsLayoutTestTemplatesRoute: typeof AppAdminManageProductsLayoutTestTemplatesRoute
}

const AppAdminManageProductsLayoutRouteChildren: AppAdminManageProductsLayoutRouteChildren =
  {
    AppAdminManageProductsLayoutCategoriesRoute:
      AppAdminManageProductsLayoutCategoriesRoute,
    AppAdminManageProductsLayoutClassesRoute:
      AppAdminManageProductsLayoutClassesRoute,
    AppAdminManageProductsLayoutCompetitorProductsRoute:
      AppAdminManageProductsLayoutCompetitorProductsRoute,
    AppAdminManageProductsLayoutEquivalentsRoute:
      AppAdminManageProductsLayoutEquivalentsRoute,
    AppAdminManageProductsLayoutInstructionsRoute:
      AppAdminManageProductsLayoutInstructionsRoute,
    AppAdminManageProductsLayoutTestTemplatesRoute:
      AppAdminManageProductsLayoutTestTemplatesRoute,
  }

const AppAdminManageProductsLayoutRouteWithChildren =
  AppAdminManageProductsLayoutRoute._addFileChildren(
    AppAdminManageProductsLayoutRouteChildren,
  )

interface AppAdminManageProductsRouteChildren {
  AppAdminManageProductsLayoutRoute: typeof AppAdminManageProductsLayoutRouteWithChildren
  AppAdminManageProductsIndexRoute: typeof AppAdminManageProductsIndexRoute
}

const AppAdminManageProductsRouteChildren: AppAdminManageProductsRouteChildren =
  {
    AppAdminManageProductsLayoutRoute:
      AppAdminManageProductsLayoutRouteWithChildren,
    AppAdminManageProductsIndexRoute: AppAdminManageProductsIndexRoute,
  }

const AppAdminManageProductsRouteWithChildren =
  AppAdminManageProductsRoute._addFileChildren(
    AppAdminManageProductsRouteChildren,
  )

interface AppAdminSystemAdminLayoutRouteChildren {
  AppAdminSystemAdminLayoutRolesRoute: typeof AppAdminSystemAdminLayoutRolesRoute
  AppAdminSystemAdminLayoutUsersRoute: typeof AppAdminSystemAdminLayoutUsersRoute
}

const AppAdminSystemAdminLayoutRouteChildren: AppAdminSystemAdminLayoutRouteChildren =
  {
    AppAdminSystemAdminLayoutRolesRoute: AppAdminSystemAdminLayoutRolesRoute,
    AppAdminSystemAdminLayoutUsersRoute: AppAdminSystemAdminLayoutUsersRoute,
  }

const AppAdminSystemAdminLayoutRouteWithChildren =
  AppAdminSystemAdminLayoutRoute._addFileChildren(
    AppAdminSystemAdminLayoutRouteChildren,
  )

interface AppAdminSystemAdminRouteChildren {
  AppAdminSystemAdminLayoutRoute: typeof AppAdminSystemAdminLayoutRouteWithChildren
  AppAdminSystemAdminIndexRoute: typeof AppAdminSystemAdminIndexRoute
  AppAdminSystemAdminUsersUserIdRoute: typeof AppAdminSystemAdminUsersUserIdRoute
}

const AppAdminSystemAdminRouteChildren: AppAdminSystemAdminRouteChildren = {
  AppAdminSystemAdminLayoutRoute: AppAdminSystemAdminLayoutRouteWithChildren,
  AppAdminSystemAdminIndexRoute: AppAdminSystemAdminIndexRoute,
  AppAdminSystemAdminUsersUserIdRoute: AppAdminSystemAdminUsersUserIdRoute,
}

const AppAdminSystemAdminRouteWithChildren =
  AppAdminSystemAdminRoute._addFileChildren(AppAdminSystemAdminRouteChildren)

interface AppAdminWarehousesWarehouseIdLayoutRouteChildren {
  AppAdminWarehousesWarehouseIdLayoutInfoRoute: typeof AppAdminWarehousesWarehouseIdLayoutInfoRoute
  AppAdminWarehousesWarehouseIdLayoutShelvingRoute: typeof AppAdminWarehousesWarehouseIdLayoutShelvingRoute
}

const AppAdminWarehousesWarehouseIdLayoutRouteChildren: AppAdminWarehousesWarehouseIdLayoutRouteChildren =
  {
    AppAdminWarehousesWarehouseIdLayoutInfoRoute:
      AppAdminWarehousesWarehouseIdLayoutInfoRoute,
    AppAdminWarehousesWarehouseIdLayoutShelvingRoute:
      AppAdminWarehousesWarehouseIdLayoutShelvingRoute,
  }

const AppAdminWarehousesWarehouseIdLayoutRouteWithChildren =
  AppAdminWarehousesWarehouseIdLayoutRoute._addFileChildren(
    AppAdminWarehousesWarehouseIdLayoutRouteChildren,
  )

interface AppAdminWarehousesWarehouseIdRouteChildren {
  AppAdminWarehousesWarehouseIdLayoutRoute: typeof AppAdminWarehousesWarehouseIdLayoutRouteWithChildren
  AppAdminWarehousesWarehouseIdIndexRoute: typeof AppAdminWarehousesWarehouseIdIndexRoute
}

const AppAdminWarehousesWarehouseIdRouteChildren: AppAdminWarehousesWarehouseIdRouteChildren =
  {
    AppAdminWarehousesWarehouseIdLayoutRoute:
      AppAdminWarehousesWarehouseIdLayoutRouteWithChildren,
    AppAdminWarehousesWarehouseIdIndexRoute:
      AppAdminWarehousesWarehouseIdIndexRoute,
  }

const AppAdminWarehousesWarehouseIdRouteWithChildren =
  AppAdminWarehousesWarehouseIdRoute._addFileChildren(
    AppAdminWarehousesWarehouseIdRouteChildren,
  )

interface AppCompaniesCompanyIdEditLayoutLocationsRouteRouteChildren {
  AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute: typeof AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute
}

const AppCompaniesCompanyIdEditLayoutLocationsRouteRouteChildren: AppCompaniesCompanyIdEditLayoutLocationsRouteRouteChildren =
  {
    AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute:
      AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute,
  }

const AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren =
  AppCompaniesCompanyIdEditLayoutLocationsRouteRoute._addFileChildren(
    AppCompaniesCompanyIdEditLayoutLocationsRouteRouteChildren,
  )

interface AppCompaniesCompanyIdEditLayoutRouteChildren {
  AppCompaniesCompanyIdEditLayoutAccountingRouteRoute: typeof AppCompaniesCompanyIdEditLayoutAccountingRouteRoute
  AppCompaniesCompanyIdEditLayoutCertificationRouteRoute: typeof AppCompaniesCompanyIdEditLayoutCertificationRouteRoute
  AppCompaniesCompanyIdEditLayoutContactsRouteRoute: typeof AppCompaniesCompanyIdEditLayoutContactsRouteRoute
  AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute: typeof AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute
  AppCompaniesCompanyIdEditLayoutInfoRouteRoute: typeof AppCompaniesCompanyIdEditLayoutInfoRouteRoute
  AppCompaniesCompanyIdEditLayoutLocationsRouteRoute: typeof AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren
  AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute: typeof AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute
  AppCompaniesCompanyIdEditLayoutProductsRouteRoute: typeof AppCompaniesCompanyIdEditLayoutProductsRouteRoute
  AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute: typeof AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute
}

const AppCompaniesCompanyIdEditLayoutRouteChildren: AppCompaniesCompanyIdEditLayoutRouteChildren =
  {
    AppCompaniesCompanyIdEditLayoutAccountingRouteRoute:
      AppCompaniesCompanyIdEditLayoutAccountingRouteRoute,
    AppCompaniesCompanyIdEditLayoutCertificationRouteRoute:
      AppCompaniesCompanyIdEditLayoutCertificationRouteRoute,
    AppCompaniesCompanyIdEditLayoutContactsRouteRoute:
      AppCompaniesCompanyIdEditLayoutContactsRouteRoute,
    AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute:
      AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute,
    AppCompaniesCompanyIdEditLayoutInfoRouteRoute:
      AppCompaniesCompanyIdEditLayoutInfoRouteRoute,
    AppCompaniesCompanyIdEditLayoutLocationsRouteRoute:
      AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren,
    AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute:
      AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute,
    AppCompaniesCompanyIdEditLayoutProductsRouteRoute:
      AppCompaniesCompanyIdEditLayoutProductsRouteRoute,
    AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute:
      AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute,
  }

const AppCompaniesCompanyIdEditLayoutRouteWithChildren =
  AppCompaniesCompanyIdEditLayoutRoute._addFileChildren(
    AppCompaniesCompanyIdEditLayoutRouteChildren,
  )

interface AppCompaniesCompanyIdEditRouteChildren {
  AppCompaniesCompanyIdEditLayoutRoute: typeof AppCompaniesCompanyIdEditLayoutRouteWithChildren
  AppCompaniesCompanyIdEditIndexRoute: typeof AppCompaniesCompanyIdEditIndexRoute
}

const AppCompaniesCompanyIdEditRouteChildren: AppCompaniesCompanyIdEditRouteChildren =
  {
    AppCompaniesCompanyIdEditLayoutRoute:
      AppCompaniesCompanyIdEditLayoutRouteWithChildren,
    AppCompaniesCompanyIdEditIndexRoute: AppCompaniesCompanyIdEditIndexRoute,
  }

const AppCompaniesCompanyIdEditRouteWithChildren =
  AppCompaniesCompanyIdEditRoute._addFileChildren(
    AppCompaniesCompanyIdEditRouteChildren,
  )

interface AppProductProductIdEditLayoutCostsLayoutRouteChildren {
  AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute: typeof AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute
  AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute: typeof AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute
}

const AppProductProductIdEditLayoutCostsLayoutRouteChildren: AppProductProductIdEditLayoutCostsLayoutRouteChildren =
  {
    AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute:
      AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute,
    AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute:
      AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute,
  }

const AppProductProductIdEditLayoutCostsLayoutRouteWithChildren =
  AppProductProductIdEditLayoutCostsLayoutRoute._addFileChildren(
    AppProductProductIdEditLayoutCostsLayoutRouteChildren,
  )

interface AppProductProductIdEditLayoutCostsRouteChildren {
  AppProductProductIdEditLayoutCostsLayoutRoute: typeof AppProductProductIdEditLayoutCostsLayoutRouteWithChildren
  AppProductProductIdEditLayoutCostsIndexRoute: typeof AppProductProductIdEditLayoutCostsIndexRoute
}

const AppProductProductIdEditLayoutCostsRouteChildren: AppProductProductIdEditLayoutCostsRouteChildren =
  {
    AppProductProductIdEditLayoutCostsLayoutRoute:
      AppProductProductIdEditLayoutCostsLayoutRouteWithChildren,
    AppProductProductIdEditLayoutCostsIndexRoute:
      AppProductProductIdEditLayoutCostsIndexRoute,
  }

const AppProductProductIdEditLayoutCostsRouteWithChildren =
  AppProductProductIdEditLayoutCostsRoute._addFileChildren(
    AppProductProductIdEditLayoutCostsRouteChildren,
  )

interface AppProductProductIdEditLayoutQualityLayoutRouteChildren {
  AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute: typeof AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute
  AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute: typeof AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute
}

const AppProductProductIdEditLayoutQualityLayoutRouteChildren: AppProductProductIdEditLayoutQualityLayoutRouteChildren =
  {
    AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute:
      AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute,
    AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute:
      AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute,
  }

const AppProductProductIdEditLayoutQualityLayoutRouteWithChildren =
  AppProductProductIdEditLayoutQualityLayoutRoute._addFileChildren(
    AppProductProductIdEditLayoutQualityLayoutRouteChildren,
  )

interface AppProductProductIdEditLayoutQualityRouteChildren {
  AppProductProductIdEditLayoutQualityLayoutRoute: typeof AppProductProductIdEditLayoutQualityLayoutRouteWithChildren
  AppProductProductIdEditLayoutQualityIndexRoute: typeof AppProductProductIdEditLayoutQualityIndexRoute
}

const AppProductProductIdEditLayoutQualityRouteChildren: AppProductProductIdEditLayoutQualityRouteChildren =
  {
    AppProductProductIdEditLayoutQualityLayoutRoute:
      AppProductProductIdEditLayoutQualityLayoutRouteWithChildren,
    AppProductProductIdEditLayoutQualityIndexRoute:
      AppProductProductIdEditLayoutQualityIndexRoute,
  }

const AppProductProductIdEditLayoutQualityRouteWithChildren =
  AppProductProductIdEditLayoutQualityRoute._addFileChildren(
    AppProductProductIdEditLayoutQualityRouteChildren,
  )

interface AppProductProductIdEditLayoutRouteChildren {
  AppProductProductIdEditLayoutInformationRouteRoute: typeof AppProductProductIdEditLayoutInformationRouteRoute
  AppProductProductIdEditLayoutInstructionsRouteRoute: typeof AppProductProductIdEditLayoutInstructionsRouteRoute
  AppProductProductIdEditLayoutRegulatoryRouteRoute: typeof AppProductProductIdEditLayoutRegulatoryRouteRoute
  AppProductProductIdEditLayoutStorageRouteRoute: typeof AppProductProductIdEditLayoutStorageRouteRoute
  AppProductProductIdEditLayoutCostsRoute: typeof AppProductProductIdEditLayoutCostsRouteWithChildren
  AppProductProductIdEditLayoutQualityRoute: typeof AppProductProductIdEditLayoutQualityRouteWithChildren
}

const AppProductProductIdEditLayoutRouteChildren: AppProductProductIdEditLayoutRouteChildren =
  {
    AppProductProductIdEditLayoutInformationRouteRoute:
      AppProductProductIdEditLayoutInformationRouteRoute,
    AppProductProductIdEditLayoutInstructionsRouteRoute:
      AppProductProductIdEditLayoutInstructionsRouteRoute,
    AppProductProductIdEditLayoutRegulatoryRouteRoute:
      AppProductProductIdEditLayoutRegulatoryRouteRoute,
    AppProductProductIdEditLayoutStorageRouteRoute:
      AppProductProductIdEditLayoutStorageRouteRoute,
    AppProductProductIdEditLayoutCostsRoute:
      AppProductProductIdEditLayoutCostsRouteWithChildren,
    AppProductProductIdEditLayoutQualityRoute:
      AppProductProductIdEditLayoutQualityRouteWithChildren,
  }

const AppProductProductIdEditLayoutRouteWithChildren =
  AppProductProductIdEditLayoutRoute._addFileChildren(
    AppProductProductIdEditLayoutRouteChildren,
  )

interface AppProductProductIdEditRouteChildren {
  AppProductProductIdEditLayoutRoute: typeof AppProductProductIdEditLayoutRouteWithChildren
  AppProductProductIdEditIndexRoute: typeof AppProductProductIdEditIndexRoute
}

const AppProductProductIdEditRouteChildren: AppProductProductIdEditRouteChildren =
  {
    AppProductProductIdEditLayoutRoute:
      AppProductProductIdEditLayoutRouteWithChildren,
    AppProductProductIdEditIndexRoute: AppProductProductIdEditIndexRoute,
  }

const AppProductProductIdEditRouteWithChildren =
  AppProductProductIdEditRoute._addFileChildren(
    AppProductProductIdEditRouteChildren,
  )

interface AppRouteRouteChildren {
  AppCompanyRouteRoute: typeof AppCompanyRouteRoute
  AppOrdersRouteRoute: typeof AppOrdersRouteRouteWithChildren
  AppRegulatoryRouteRoute: typeof AppRegulatoryRouteRoute
  AppTabletRoute: typeof AppTabletRouteWithChildren
  AppIndexRouteRoute: typeof AppIndexRouteRoute
  AppSalesCustomersRouteRoute: typeof AppSalesCustomersRouteRoute
  AppSalesSalesOrdersRouteRoute: typeof AppSalesSalesOrdersRouteRoute
  AppAccountingRoute: typeof AppAccountingRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRouteWithChildren
  AppInventoryRoute: typeof AppInventoryRouteWithChildren
  AppPricingRoute: typeof AppPricingRouteWithChildren
  AppProcurementRoute: typeof AppProcurementRouteWithChildren
  AppWarehouseReceivingRoute: typeof AppWarehouseReceivingRouteWithChildren
  AppSalesIndexRouteRoute: typeof AppSalesIndexRouteRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppAdminAccountingRoute: typeof AppAdminAccountingRouteWithChildren
  AppAdminManageProductsRoute: typeof AppAdminManageProductsRouteWithChildren
  AppAdminSystemAdminRoute: typeof AppAdminSystemAdminRouteWithChildren
  AppAdminChangeLogIndexRoute: typeof AppAdminChangeLogIndexRoute
  AppAdminWarehousesIndexRoute: typeof AppAdminWarehousesIndexRoute
  AppContactContactIdIndexLazyRoute: typeof AppContactContactIdIndexLazyRoute
  AppAdminWarehousesWarehouseIdRoute: typeof AppAdminWarehousesWarehouseIdRouteWithChildren
  AppCompaniesCompanyIdEditRoute: typeof AppCompaniesCompanyIdEditRouteWithChildren
  AppProductProductIdEditRoute: typeof AppProductProductIdEditRouteWithChildren
  AppProductProductIdPreferenceIndexRoute: typeof AppProductProductIdPreferenceIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppCompanyRouteRoute: AppCompanyRouteRoute,
  AppOrdersRouteRoute: AppOrdersRouteRouteWithChildren,
  AppRegulatoryRouteRoute: AppRegulatoryRouteRoute,
  AppTabletRoute: AppTabletRouteWithChildren,
  AppIndexRouteRoute: AppIndexRouteRoute,
  AppSalesCustomersRouteRoute: AppSalesCustomersRouteRoute,
  AppSalesSalesOrdersRouteRoute: AppSalesSalesOrdersRouteRoute,
  AppAccountingRoute: AppAccountingRouteWithChildren,
  AppDashboardRoute: AppDashboardRouteWithChildren,
  AppInventoryRoute: AppInventoryRouteWithChildren,
  AppPricingRoute: AppPricingRouteWithChildren,
  AppProcurementRoute: AppProcurementRouteWithChildren,
  AppWarehouseReceivingRoute: AppWarehouseReceivingRouteWithChildren,
  AppSalesIndexRouteRoute: AppSalesIndexRouteRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppAdminAccountingRoute: AppAdminAccountingRouteWithChildren,
  AppAdminManageProductsRoute: AppAdminManageProductsRouteWithChildren,
  AppAdminSystemAdminRoute: AppAdminSystemAdminRouteWithChildren,
  AppAdminChangeLogIndexRoute: AppAdminChangeLogIndexRoute,
  AppAdminWarehousesIndexRoute: AppAdminWarehousesIndexRoute,
  AppContactContactIdIndexLazyRoute: AppContactContactIdIndexLazyRoute,
  AppAdminWarehousesWarehouseIdRoute:
    AppAdminWarehousesWarehouseIdRouteWithChildren,
  AppCompaniesCompanyIdEditRoute: AppCompaniesCompanyIdEditRouteWithChildren,
  AppProductProductIdEditRoute: AppProductProductIdEditRouteWithChildren,
  AppProductProductIdPreferenceIndexRoute:
    AppProductProductIdPreferenceIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/app': typeof AppRouteRouteWithChildren
  '/deactivated': typeof DeactivatedRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/app/company': typeof AppCompanyRouteRoute
  '/app/orders': typeof AppOrdersRouteRouteWithChildren
  '/app/regulatory': typeof AppRegulatoryRouteRoute
  '/app/tablet': typeof AppTabletRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/app/': typeof AppIndexRouteRoute
  '/app/sales/customers': typeof AppSalesCustomersRouteRoute
  '/app/sales/sales-orders': typeof AppSalesSalesOrdersRouteRoute
  '/app/accounting': typeof AppAccountingLayoutRouteWithChildren
  '/app/dashboard': typeof AppDashboardLayoutRouteWithChildren
  '/app/inventory': typeof AppInventoryLayoutRouteWithChildren
  '/app/pricing': typeof AppPricingLayoutRouteWithChildren
  '/app/procurement': typeof AppProcurementLayoutRouteWithChildren
  '/app/warehouse-receiving': typeof AppWarehouseReceivingLayoutRouteWithChildren
  '/app/orders/': typeof AppOrdersIndexRouteRoute
  '/app/sales': typeof AppSalesIndexRouteRoute
  '/app/tablet/': typeof AppTabletIndexRouteRoute
  '/app/accounting/': typeof AppAccountingIndexRoute
  '/app/admin': typeof AppAdminIndexRoute
  '/app/companies': typeof AppCompaniesIndexRoute
  '/app/dashboard/': typeof AppDashboardIndexRoute
  '/app/inventory/': typeof AppInventoryIndexRoute
  '/app/pricing/': typeof AppPricingIndexRoute
  '/app/procurement/': typeof AppProcurementIndexRoute
  '/app/products': typeof AppProductsIndexRoute
  '/app/warehouse-receiving/': typeof AppWarehouseReceivingIndexRoute
  '/app/accounting/accounts-payable': typeof AppAccountingLayoutAccountsPayableRoute
  '/app/accounting/gl-transactions': typeof AppAccountingLayoutGlTransactionsRoute
  '/app/accounting/huntington-pay-files': typeof AppAccountingLayoutHuntingtonPayFilesRoute
  '/app/accounting/payable-approvals': typeof AppAccountingLayoutPayableApprovalsRoute
  '/app/admin/accounting': typeof AppAdminAccountingLayoutRouteWithChildren
  '/app/admin/accounting/create-payment-term': typeof AppAdminAccountingCreatePaymentTermRoute
  '/app/admin/manage-products': typeof AppAdminManageProductsLayoutRouteWithChildren
  '/app/admin/system-admin': typeof AppAdminSystemAdminLayoutRouteWithChildren
  '/app/dashboard/my-requests': typeof AppDashboardLayoutMyRequestsRoute
  '/app/inventory/adjustment-history': typeof AppInventoryLayoutAdjustmentHistoryRoute
  '/app/inventory/products': typeof AppInventoryLayoutProductsRoute
  '/app/inventory/transfers': typeof AppInventoryLayoutTransfersRoute
  '/app/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/app/pricing/$priceChangeId/review': typeof AppPricingPriceChangeIdReviewRoute
  '/app/pricing/price-change': typeof AppPricingLayoutPriceChangeRoute
  '/app/procurement/cost-breakdown': typeof AppProcurementLayoutCostBreakdownRoute
  '/app/procurement/purchase-orders': typeof AppProcurementLayoutPurchaseOrdersRoute
  '/app/procurement/supplier-report': typeof AppProcurementLayoutSupplierReportRouteWithChildren
  '/app/tablet/warehouse-receiving': typeof AppTabletWarehouseReceivingLayoutRouteWithChildren
  '/app/warehouse-receiving/checked-in': typeof AppWarehouseReceivingLayoutCheckedInRoute
  '/app/warehouse-receiving/incoming': typeof AppWarehouseReceivingLayoutIncomingRoute
  '/app/warehouse-receiving/soft-received': typeof AppWarehouseReceivingLayoutSoftReceivedRoute
  '/app/warehouse-receiving/stored': typeof AppWarehouseReceivingLayoutStoredRoute
  '/app/tablet/sales': typeof AppTabletSalesIndexRouteRoute
  '/app/admin/accounting/': typeof AppAdminAccountingIndexRoute
  '/app/admin/change-log': typeof AppAdminChangeLogIndexRoute
  '/app/admin/manage-products/': typeof AppAdminManageProductsIndexRoute
  '/app/admin/system-admin/': typeof AppAdminSystemAdminIndexRoute
  '/app/admin/warehouses': typeof AppAdminWarehousesIndexRoute
  '/app/tablet/warehouse-receiving/': typeof AppTabletWarehouseReceivingIndexRoute
  '/app/contact/$contactId': typeof AppContactContactIdIndexLazyRoute
  '/app/admin/accounting/accounts-chart': typeof AppAdminAccountingLayoutAccountsChartRoute
  '/app/admin/accounting/payment-terms': typeof AppAdminAccountingLayoutPaymentTermsRoute
  '/app/admin/accounting/settings': typeof AppAdminAccountingLayoutSettingsRoute
  '/app/admin/accounting/payment-term/$paymentTermId': typeof AppAdminAccountingPaymentTermPaymentTermIdRoute
  '/app/admin/manage-products/categories': typeof AppAdminManageProductsLayoutCategoriesRoute
  '/app/admin/manage-products/classes': typeof AppAdminManageProductsLayoutClassesRoute
  '/app/admin/manage-products/competitor-products': typeof AppAdminManageProductsLayoutCompetitorProductsRoute
  '/app/admin/manage-products/equivalents': typeof AppAdminManageProductsLayoutEquivalentsRoute
  '/app/admin/manage-products/instructions': typeof AppAdminManageProductsLayoutInstructionsRoute
  '/app/admin/manage-products/test-templates': typeof AppAdminManageProductsLayoutTestTemplatesRoute
  '/app/admin/system-admin/roles': typeof AppAdminSystemAdminLayoutRolesRoute
  '/app/admin/system-admin/users': typeof AppAdminSystemAdminLayoutUsersRoute
  '/app/admin/system-admin/users/$userId': typeof AppAdminSystemAdminUsersUserIdRoute
  '/app/admin/warehouses/$warehouseId': typeof AppAdminWarehousesWarehouseIdLayoutRouteWithChildren
  '/app/companies/$companyId/edit': typeof AppCompaniesCompanyIdEditLayoutRouteWithChildren
  '/app/dashboard/pending-approvals': typeof AppDashboardLayoutPendingApprovalsLayoutRouteWithChildren
  '/app/inventory/products/$productId': typeof AppInventoryProductsProductIdLayoutRouteWithChildren
  '/app/inventory/transfers/$transferId/edit': typeof AppInventoryTransfersTransferIdEditRoute
  '/app/orders/$companyId/$shipToLocationId': typeof AppOrdersCompanyIdShipToLocationIdLayoutRouteWithChildren
  '/app/pricing/history/price-change': typeof AppPricingLayoutHistoryPriceChangeRoute
  '/app/pricing/history/purchase-cost': typeof AppPricingLayoutHistoryPurchaseCostRoute
  '/app/procurement/purchase-orders/$purchaseOrderId': typeof AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute
  '/app/product/$productId/edit': typeof AppProductProductIdEditLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/checked-in': typeof AppTabletWarehouseReceivingLayoutCheckedInRoute
  '/app/tablet/warehouse-receiving/incoming': typeof AppTabletWarehouseReceivingLayoutIncomingRoute
  '/app/tablet/warehouse-receiving/soft-received': typeof AppTabletWarehouseReceivingLayoutSoftReceivedRoute
  '/app/tablet/warehouse-receiving/stored': typeof AppTabletWarehouseReceivingLayoutStoredRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/incoming/$goodsReceiptId': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteWithChildren
  '/app/procurement/supplier-report/new-supplier': typeof AppProcurementLayoutSupplierReportNewSupplierLazyRoute
  '/app/admin/warehouses/$warehouseId/': typeof AppAdminWarehousesWarehouseIdIndexRoute
  '/app/companies/$companyId/edit/': typeof AppCompaniesCompanyIdEditIndexRoute
  '/app/dashboard/pending-approvals/': typeof AppDashboardLayoutPendingApprovalsIndexRoute
  '/app/product/$productId/edit/': typeof AppProductProductIdEditIndexRoute
  '/app/product/$productId/preference': typeof AppProductProductIdPreferenceIndexRoute
  '/app/companies/$companyId/edit/accounting': typeof AppCompaniesCompanyIdEditLayoutAccountingRouteRoute
  '/app/companies/$companyId/edit/certification': typeof AppCompaniesCompanyIdEditLayoutCertificationRouteRoute
  '/app/companies/$companyId/edit/contacts': typeof AppCompaniesCompanyIdEditLayoutContactsRouteRoute
  '/app/companies/$companyId/edit/evaluation': typeof AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute
  '/app/companies/$companyId/edit/info': typeof AppCompaniesCompanyIdEditLayoutInfoRouteRoute
  '/app/companies/$companyId/edit/locations': typeof AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren
  '/app/companies/$companyId/edit/preferences': typeof AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute
  '/app/companies/$companyId/edit/products': typeof AppCompaniesCompanyIdEditLayoutProductsRouteRoute
  '/app/companies/$companyId/edit/registration': typeof AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute
  '/app/orders/$companyId/$shipToLocationId/closed-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/customer-purchase-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/open-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute
  '/app/product/$productId/edit/information': typeof AppProductProductIdEditLayoutInformationRouteRoute
  '/app/product/$productId/edit/instructions': typeof AppProductProductIdEditLayoutInstructionsRouteRoute
  '/app/product/$productId/edit/regulatory': typeof AppProductProductIdEditLayoutRegulatoryRouteRoute
  '/app/product/$productId/edit/storage': typeof AppProductProductIdEditLayoutStorageRouteRoute
  '/app/admin/warehouses/$warehouseId/info': typeof AppAdminWarehousesWarehouseIdLayoutInfoRoute
  '/app/admin/warehouses/$warehouseId/shelving': typeof AppAdminWarehousesWarehouseIdLayoutShelvingRoute
  '/app/dashboard/pending-approvals/price': typeof AppDashboardLayoutPendingApprovalsLayoutPriceRoute
  '/app/dashboard/pending-approvals/quality': typeof AppDashboardLayoutPendingApprovalsLayoutQualityRoute
  '/app/dashboard/pending-approvals/sample': typeof AppDashboardLayoutPendingApprovalsLayoutSampleRoute
  '/app/dashboard/pending-approvals/source-change': typeof AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute
  '/app/inventory/products/$productId/lots': typeof AppInventoryProductsProductIdLayoutLotsRoute
  '/app/inventory/products/$productId/pallets': typeof AppInventoryProductsProductIdLayoutPalletsRoute
  '/app/inventory/products/$productId/transactions': typeof AppInventoryProductsProductIdLayoutTransactionsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/comments': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/uploads': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/comments': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/uploads': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/comments': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/uploads': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/comments': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/uploads': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute
  '/app/orders/$companyId/$shipToLocationId/': typeof AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute
  '/app/inventory/products/$productId/': typeof AppInventoryProductsProductIdLayoutIndexRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute
  '/app/companies/$companyId/edit/locations/$locationId': typeof AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute
  '/app/product/$productId/edit/costs': typeof AppProductProductIdEditLayoutCostsLayoutRouteWithChildren
  '/app/product/$productId/edit/quality': typeof AppProductProductIdEditLayoutQualityLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/product/$productId/edit/costs/': typeof AppProductProductIdEditLayoutCostsIndexRoute
  '/app/product/$productId/edit/quality/': typeof AppProductProductIdEditLayoutQualityIndexRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/product/$productId/edit/costs/laid-down': typeof AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute
  '/app/product/$productId/edit/costs/purchase-costs': typeof AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute
  '/app/product/$productId/edit/quality/results': typeof AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute
  '/app/product/$productId/edit/quality/templates': typeof AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/deactivated': typeof DeactivatedRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/app/company': typeof AppCompanyRouteRoute
  '/app/regulatory': typeof AppRegulatoryRouteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/app': typeof AppIndexRouteRoute
  '/app/sales/customers': typeof AppSalesCustomersRouteRoute
  '/app/sales/sales-orders': typeof AppSalesSalesOrdersRouteRoute
  '/app/accounting': typeof AppAccountingIndexRoute
  '/app/dashboard': typeof AppDashboardIndexRoute
  '/app/inventory': typeof AppInventoryIndexRoute
  '/app/pricing': typeof AppPricingIndexRoute
  '/app/procurement': typeof AppProcurementIndexRoute
  '/app/warehouse-receiving': typeof AppWarehouseReceivingIndexRoute
  '/app/orders': typeof AppOrdersIndexRouteRoute
  '/app/sales': typeof AppSalesIndexRouteRoute
  '/app/tablet': typeof AppTabletIndexRouteRoute
  '/app/admin': typeof AppAdminIndexRoute
  '/app/companies': typeof AppCompaniesIndexRoute
  '/app/products': typeof AppProductsIndexRoute
  '/app/accounting/accounts-payable': typeof AppAccountingLayoutAccountsPayableRoute
  '/app/accounting/gl-transactions': typeof AppAccountingLayoutGlTransactionsRoute
  '/app/accounting/huntington-pay-files': typeof AppAccountingLayoutHuntingtonPayFilesRoute
  '/app/accounting/payable-approvals': typeof AppAccountingLayoutPayableApprovalsRoute
  '/app/admin/accounting': typeof AppAdminAccountingIndexRoute
  '/app/admin/accounting/create-payment-term': typeof AppAdminAccountingCreatePaymentTermRoute
  '/app/admin/manage-products': typeof AppAdminManageProductsIndexRoute
  '/app/admin/system-admin': typeof AppAdminSystemAdminIndexRoute
  '/app/dashboard/my-requests': typeof AppDashboardLayoutMyRequestsRoute
  '/app/inventory/adjustment-history': typeof AppInventoryLayoutAdjustmentHistoryRoute
  '/app/inventory/products': typeof AppInventoryLayoutProductsRoute
  '/app/inventory/transfers': typeof AppInventoryLayoutTransfersRoute
  '/app/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/app/pricing/$priceChangeId/review': typeof AppPricingPriceChangeIdReviewRoute
  '/app/pricing/price-change': typeof AppPricingLayoutPriceChangeRoute
  '/app/procurement/cost-breakdown': typeof AppProcurementLayoutCostBreakdownRoute
  '/app/procurement/purchase-orders': typeof AppProcurementLayoutPurchaseOrdersRoute
  '/app/procurement/supplier-report': typeof AppProcurementLayoutSupplierReportRouteWithChildren
  '/app/tablet/warehouse-receiving': typeof AppTabletWarehouseReceivingIndexRoute
  '/app/warehouse-receiving/checked-in': typeof AppWarehouseReceivingLayoutCheckedInRoute
  '/app/warehouse-receiving/incoming': typeof AppWarehouseReceivingLayoutIncomingRoute
  '/app/warehouse-receiving/soft-received': typeof AppWarehouseReceivingLayoutSoftReceivedRoute
  '/app/warehouse-receiving/stored': typeof AppWarehouseReceivingLayoutStoredRoute
  '/app/tablet/sales': typeof AppTabletSalesIndexRouteRoute
  '/app/admin/change-log': typeof AppAdminChangeLogIndexRoute
  '/app/admin/warehouses': typeof AppAdminWarehousesIndexRoute
  '/app/contact/$contactId': typeof AppContactContactIdIndexLazyRoute
  '/app/admin/accounting/accounts-chart': typeof AppAdminAccountingLayoutAccountsChartRoute
  '/app/admin/accounting/payment-terms': typeof AppAdminAccountingLayoutPaymentTermsRoute
  '/app/admin/accounting/settings': typeof AppAdminAccountingLayoutSettingsRoute
  '/app/admin/accounting/payment-term/$paymentTermId': typeof AppAdminAccountingPaymentTermPaymentTermIdRoute
  '/app/admin/manage-products/categories': typeof AppAdminManageProductsLayoutCategoriesRoute
  '/app/admin/manage-products/classes': typeof AppAdminManageProductsLayoutClassesRoute
  '/app/admin/manage-products/competitor-products': typeof AppAdminManageProductsLayoutCompetitorProductsRoute
  '/app/admin/manage-products/equivalents': typeof AppAdminManageProductsLayoutEquivalentsRoute
  '/app/admin/manage-products/instructions': typeof AppAdminManageProductsLayoutInstructionsRoute
  '/app/admin/manage-products/test-templates': typeof AppAdminManageProductsLayoutTestTemplatesRoute
  '/app/admin/system-admin/roles': typeof AppAdminSystemAdminLayoutRolesRoute
  '/app/admin/system-admin/users': typeof AppAdminSystemAdminLayoutUsersRoute
  '/app/admin/system-admin/users/$userId': typeof AppAdminSystemAdminUsersUserIdRoute
  '/app/admin/warehouses/$warehouseId': typeof AppAdminWarehousesWarehouseIdIndexRoute
  '/app/companies/$companyId/edit': typeof AppCompaniesCompanyIdEditIndexRoute
  '/app/dashboard/pending-approvals': typeof AppDashboardLayoutPendingApprovalsIndexRoute
  '/app/inventory/products/$productId': typeof AppInventoryProductsProductIdLayoutIndexRoute
  '/app/inventory/transfers/$transferId/edit': typeof AppInventoryTransfersTransferIdEditRoute
  '/app/orders/$companyId/$shipToLocationId': typeof AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute
  '/app/pricing/history/price-change': typeof AppPricingLayoutHistoryPriceChangeRoute
  '/app/pricing/history/purchase-cost': typeof AppPricingLayoutHistoryPurchaseCostRoute
  '/app/procurement/purchase-orders/$purchaseOrderId': typeof AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute
  '/app/product/$productId/edit': typeof AppProductProductIdEditIndexRoute
  '/app/tablet/warehouse-receiving/checked-in': typeof AppTabletWarehouseReceivingLayoutCheckedInRoute
  '/app/tablet/warehouse-receiving/incoming': typeof AppTabletWarehouseReceivingLayoutIncomingRoute
  '/app/tablet/warehouse-receiving/soft-received': typeof AppTabletWarehouseReceivingLayoutSoftReceivedRoute
  '/app/tablet/warehouse-receiving/stored': typeof AppTabletWarehouseReceivingLayoutStoredRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute
  '/app/procurement/supplier-report/new-supplier': typeof AppProcurementLayoutSupplierReportNewSupplierLazyRoute
  '/app/product/$productId/preference': typeof AppProductProductIdPreferenceIndexRoute
  '/app/companies/$companyId/edit/accounting': typeof AppCompaniesCompanyIdEditLayoutAccountingRouteRoute
  '/app/companies/$companyId/edit/certification': typeof AppCompaniesCompanyIdEditLayoutCertificationRouteRoute
  '/app/companies/$companyId/edit/contacts': typeof AppCompaniesCompanyIdEditLayoutContactsRouteRoute
  '/app/companies/$companyId/edit/evaluation': typeof AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute
  '/app/companies/$companyId/edit/info': typeof AppCompaniesCompanyIdEditLayoutInfoRouteRoute
  '/app/companies/$companyId/edit/locations': typeof AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren
  '/app/companies/$companyId/edit/preferences': typeof AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute
  '/app/companies/$companyId/edit/products': typeof AppCompaniesCompanyIdEditLayoutProductsRouteRoute
  '/app/companies/$companyId/edit/registration': typeof AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute
  '/app/orders/$companyId/$shipToLocationId/closed-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/customer-purchase-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/open-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute
  '/app/product/$productId/edit/information': typeof AppProductProductIdEditLayoutInformationRouteRoute
  '/app/product/$productId/edit/instructions': typeof AppProductProductIdEditLayoutInstructionsRouteRoute
  '/app/product/$productId/edit/regulatory': typeof AppProductProductIdEditLayoutRegulatoryRouteRoute
  '/app/product/$productId/edit/storage': typeof AppProductProductIdEditLayoutStorageRouteRoute
  '/app/admin/warehouses/$warehouseId/info': typeof AppAdminWarehousesWarehouseIdLayoutInfoRoute
  '/app/admin/warehouses/$warehouseId/shelving': typeof AppAdminWarehousesWarehouseIdLayoutShelvingRoute
  '/app/dashboard/pending-approvals/price': typeof AppDashboardLayoutPendingApprovalsLayoutPriceRoute
  '/app/dashboard/pending-approvals/quality': typeof AppDashboardLayoutPendingApprovalsLayoutQualityRoute
  '/app/dashboard/pending-approvals/sample': typeof AppDashboardLayoutPendingApprovalsLayoutSampleRoute
  '/app/dashboard/pending-approvals/source-change': typeof AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute
  '/app/inventory/products/$productId/lots': typeof AppInventoryProductsProductIdLayoutLotsRoute
  '/app/inventory/products/$productId/pallets': typeof AppInventoryProductsProductIdLayoutPalletsRoute
  '/app/inventory/products/$productId/transactions': typeof AppInventoryProductsProductIdLayoutTransactionsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/comments': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/uploads': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/comments': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/uploads': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/comments': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/uploads': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/comments': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/purchase-orders': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/uploads': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute
  '/app/companies/$companyId/edit/locations/$locationId': typeof AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute
  '/app/product/$productId/edit/costs': typeof AppProductProductIdEditLayoutCostsIndexRoute
  '/app/product/$productId/edit/quality': typeof AppProductProductIdEditLayoutQualityIndexRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/comments': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/product/$productId/edit/costs/laid-down': typeof AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute
  '/app/product/$productId/edit/costs/purchase-costs': typeof AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute
  '/app/product/$productId/edit/quality/results': typeof AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute
  '/app/product/$productId/edit/quality/templates': typeof AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRouteRoute
  '/app': typeof AppRouteRouteWithChildren
  '/deactivated': typeof DeactivatedRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/app/company': typeof AppCompanyRouteRoute
  '/app/orders': typeof AppOrdersRouteRouteWithChildren
  '/app/regulatory': typeof AppRegulatoryRouteRoute
  '/app/tablet': typeof AppTabletRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/app/': typeof AppIndexRouteRoute
  '/app/sales/customers': typeof AppSalesCustomersRouteRoute
  '/app/sales/sales-orders': typeof AppSalesSalesOrdersRouteRoute
  '/app/accounting': typeof AppAccountingRouteWithChildren
  '/app/accounting/_layout': typeof AppAccountingLayoutRouteWithChildren
  '/app/dashboard': typeof AppDashboardRouteWithChildren
  '/app/dashboard/_layout': typeof AppDashboardLayoutRouteWithChildren
  '/app/inventory': typeof AppInventoryRouteWithChildren
  '/app/inventory/_layout': typeof AppInventoryLayoutRouteWithChildren
  '/app/pricing': typeof AppPricingRouteWithChildren
  '/app/pricing/_layout': typeof AppPricingLayoutRouteWithChildren
  '/app/procurement': typeof AppProcurementRouteWithChildren
  '/app/procurement/_layout': typeof AppProcurementLayoutRouteWithChildren
  '/app/warehouse-receiving': typeof AppWarehouseReceivingRouteWithChildren
  '/app/warehouse-receiving/_layout': typeof AppWarehouseReceivingLayoutRouteWithChildren
  '/app/orders/': typeof AppOrdersIndexRouteRoute
  '/app/sales/': typeof AppSalesIndexRouteRoute
  '/app/tablet/': typeof AppTabletIndexRouteRoute
  '/app/accounting/': typeof AppAccountingIndexRoute
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/companies/': typeof AppCompaniesIndexRoute
  '/app/dashboard/': typeof AppDashboardIndexRoute
  '/app/inventory/': typeof AppInventoryIndexRoute
  '/app/pricing/': typeof AppPricingIndexRoute
  '/app/procurement/': typeof AppProcurementIndexRoute
  '/app/products/': typeof AppProductsIndexRoute
  '/app/warehouse-receiving/': typeof AppWarehouseReceivingIndexRoute
  '/app/accounting/_layout/accounts-payable': typeof AppAccountingLayoutAccountsPayableRoute
  '/app/accounting/_layout/gl-transactions': typeof AppAccountingLayoutGlTransactionsRoute
  '/app/accounting/_layout/huntington-pay-files': typeof AppAccountingLayoutHuntingtonPayFilesRoute
  '/app/accounting/_layout/payable-approvals': typeof AppAccountingLayoutPayableApprovalsRoute
  '/app/admin/accounting': typeof AppAdminAccountingRouteWithChildren
  '/app/admin/accounting/_layout': typeof AppAdminAccountingLayoutRouteWithChildren
  '/app/admin/accounting/create-payment-term': typeof AppAdminAccountingCreatePaymentTermRoute
  '/app/admin/manage-products': typeof AppAdminManageProductsRouteWithChildren
  '/app/admin/manage-products/_layout': typeof AppAdminManageProductsLayoutRouteWithChildren
  '/app/admin/system-admin': typeof AppAdminSystemAdminRouteWithChildren
  '/app/admin/system-admin/_layout': typeof AppAdminSystemAdminLayoutRouteWithChildren
  '/app/dashboard/_layout/my-requests': typeof AppDashboardLayoutMyRequestsRoute
  '/app/inventory/_layout/adjustment-history': typeof AppInventoryLayoutAdjustmentHistoryRoute
  '/app/inventory/_layout/products': typeof AppInventoryLayoutProductsRoute
  '/app/inventory/_layout/transfers': typeof AppInventoryLayoutTransfersRoute
  '/app/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/app/pricing/$priceChangeId/review': typeof AppPricingPriceChangeIdReviewRoute
  '/app/pricing/_layout/price-change': typeof AppPricingLayoutPriceChangeRoute
  '/app/procurement/_layout/cost-breakdown': typeof AppProcurementLayoutCostBreakdownRoute
  '/app/procurement/_layout/purchase-orders': typeof AppProcurementLayoutPurchaseOrdersRoute
  '/app/procurement/_layout/supplier-report': typeof AppProcurementLayoutSupplierReportRouteWithChildren
  '/app/tablet/warehouse-receiving': typeof AppTabletWarehouseReceivingRouteWithChildren
  '/app/tablet/warehouse-receiving/_layout': typeof AppTabletWarehouseReceivingLayoutRouteWithChildren
  '/app/warehouse-receiving/_layout/checked-in': typeof AppWarehouseReceivingLayoutCheckedInRoute
  '/app/warehouse-receiving/_layout/incoming': typeof AppWarehouseReceivingLayoutIncomingRoute
  '/app/warehouse-receiving/_layout/soft-received': typeof AppWarehouseReceivingLayoutSoftReceivedRoute
  '/app/warehouse-receiving/_layout/stored': typeof AppWarehouseReceivingLayoutStoredRoute
  '/app/tablet/sales/': typeof AppTabletSalesIndexRouteRoute
  '/app/admin/accounting/': typeof AppAdminAccountingIndexRoute
  '/app/admin/change-log/': typeof AppAdminChangeLogIndexRoute
  '/app/admin/manage-products/': typeof AppAdminManageProductsIndexRoute
  '/app/admin/system-admin/': typeof AppAdminSystemAdminIndexRoute
  '/app/admin/warehouses/': typeof AppAdminWarehousesIndexRoute
  '/app/tablet/warehouse-receiving/': typeof AppTabletWarehouseReceivingIndexRoute
  '/app/contact/$contactId/': typeof AppContactContactIdIndexLazyRoute
  '/app/admin/accounting/_layout/accounts-chart': typeof AppAdminAccountingLayoutAccountsChartRoute
  '/app/admin/accounting/_layout/payment-terms': typeof AppAdminAccountingLayoutPaymentTermsRoute
  '/app/admin/accounting/_layout/settings': typeof AppAdminAccountingLayoutSettingsRoute
  '/app/admin/accounting/payment-term/$paymentTermId': typeof AppAdminAccountingPaymentTermPaymentTermIdRoute
  '/app/admin/manage-products/_layout/categories': typeof AppAdminManageProductsLayoutCategoriesRoute
  '/app/admin/manage-products/_layout/classes': typeof AppAdminManageProductsLayoutClassesRoute
  '/app/admin/manage-products/_layout/competitor-products': typeof AppAdminManageProductsLayoutCompetitorProductsRoute
  '/app/admin/manage-products/_layout/equivalents': typeof AppAdminManageProductsLayoutEquivalentsRoute
  '/app/admin/manage-products/_layout/instructions': typeof AppAdminManageProductsLayoutInstructionsRoute
  '/app/admin/manage-products/_layout/test-templates': typeof AppAdminManageProductsLayoutTestTemplatesRoute
  '/app/admin/system-admin/_layout/roles': typeof AppAdminSystemAdminLayoutRolesRoute
  '/app/admin/system-admin/_layout/users': typeof AppAdminSystemAdminLayoutUsersRoute
  '/app/admin/system-admin/users/$userId': typeof AppAdminSystemAdminUsersUserIdRoute
  '/app/admin/warehouses/$warehouseId': typeof AppAdminWarehousesWarehouseIdRouteWithChildren
  '/app/admin/warehouses/$warehouseId/_layout': typeof AppAdminWarehousesWarehouseIdLayoutRouteWithChildren
  '/app/companies/$companyId/edit': typeof AppCompaniesCompanyIdEditRouteWithChildren
  '/app/companies/$companyId/edit/_layout': typeof AppCompaniesCompanyIdEditLayoutRouteWithChildren
  '/app/dashboard/_layout/pending-approvals': typeof AppDashboardLayoutPendingApprovalsRouteWithChildren
  '/app/dashboard/_layout/pending-approvals/_layout': typeof AppDashboardLayoutPendingApprovalsLayoutRouteWithChildren
  '/app/inventory/products/$productId': typeof AppInventoryProductsProductIdRouteWithChildren
  '/app/inventory/products/$productId/_layout': typeof AppInventoryProductsProductIdLayoutRouteWithChildren
  '/app/inventory/transfers/$transferId/edit': typeof AppInventoryTransfersTransferIdEditRoute
  '/app/orders/$companyId/$shipToLocationId': typeof AppOrdersCompanyIdShipToLocationIdRouteWithChildren
  '/app/orders/$companyId/$shipToLocationId/_layout': typeof AppOrdersCompanyIdShipToLocationIdLayoutRouteWithChildren
  '/app/pricing/_layout/history/price-change': typeof AppPricingLayoutHistoryPriceChangeRoute
  '/app/pricing/_layout/history/purchase-cost': typeof AppPricingLayoutHistoryPurchaseCostRoute
  '/app/procurement/_layout_/purchase-orders/$purchaseOrderId': typeof AppProcurementLayoutPurchaseOrdersPurchaseOrderIdRoute
  '/app/product/$productId/edit': typeof AppProductProductIdEditRouteWithChildren
  '/app/product/$productId/edit/_layout': typeof AppProductProductIdEditLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/_layout/checked-in': typeof AppTabletWarehouseReceivingLayoutCheckedInRoute
  '/app/tablet/warehouse-receiving/_layout/incoming': typeof AppTabletWarehouseReceivingLayoutIncomingRoute
  '/app/tablet/warehouse-receiving/_layout/soft-received': typeof AppTabletWarehouseReceivingLayoutSoftReceivedRoute
  '/app/tablet/warehouse-receiving/_layout/stored': typeof AppTabletWarehouseReceivingLayoutStoredRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/incoming/$goodsReceiptId': typeof AppWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren
  '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId': typeof AppWarehouseReceivingStoredGoodsReceiptIdRouteWithChildren
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutRouteWithChildren
  '/app/procurement/_layout/supplier-report/new-supplier': typeof AppProcurementLayoutSupplierReportNewSupplierLazyRoute
  '/app/admin/warehouses/$warehouseId/': typeof AppAdminWarehousesWarehouseIdIndexRoute
  '/app/companies/$companyId/edit/': typeof AppCompaniesCompanyIdEditIndexRoute
  '/app/dashboard/_layout/pending-approvals/': typeof AppDashboardLayoutPendingApprovalsIndexRoute
  '/app/product/$productId/edit/': typeof AppProductProductIdEditIndexRoute
  '/app/product/$productId/preference/': typeof AppProductProductIdPreferenceIndexRoute
  '/app/companies/$companyId/edit/_layout/accounting': typeof AppCompaniesCompanyIdEditLayoutAccountingRouteRoute
  '/app/companies/$companyId/edit/_layout/certification': typeof AppCompaniesCompanyIdEditLayoutCertificationRouteRoute
  '/app/companies/$companyId/edit/_layout/contacts': typeof AppCompaniesCompanyIdEditLayoutContactsRouteRoute
  '/app/companies/$companyId/edit/_layout/evaluation': typeof AppCompaniesCompanyIdEditLayoutEvaluationRouteRoute
  '/app/companies/$companyId/edit/_layout/info': typeof AppCompaniesCompanyIdEditLayoutInfoRouteRoute
  '/app/companies/$companyId/edit/_layout/locations': typeof AppCompaniesCompanyIdEditLayoutLocationsRouteRouteWithChildren
  '/app/companies/$companyId/edit/_layout/preferences': typeof AppCompaniesCompanyIdEditLayoutPreferencesRouteRoute
  '/app/companies/$companyId/edit/_layout/products': typeof AppCompaniesCompanyIdEditLayoutProductsRouteRoute
  '/app/companies/$companyId/edit/_layout/registration': typeof AppCompaniesCompanyIdEditLayoutRegistrationRouteRoute
  '/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutClosedSalesOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutCustomerPurchaseOrdersRouteRoute
  '/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders': typeof AppOrdersCompanyIdShipToLocationIdLayoutOpenSalesOrdersRouteRoute
  '/app/product/$productId/edit/_layout/information': typeof AppProductProductIdEditLayoutInformationRouteRoute
  '/app/product/$productId/edit/_layout/instructions': typeof AppProductProductIdEditLayoutInstructionsRouteRoute
  '/app/product/$productId/edit/_layout/regulatory': typeof AppProductProductIdEditLayoutRegulatoryRouteRoute
  '/app/product/$productId/edit/_layout/storage': typeof AppProductProductIdEditLayoutStorageRouteRoute
  '/app/admin/warehouses/$warehouseId/_layout/info': typeof AppAdminWarehousesWarehouseIdLayoutInfoRoute
  '/app/admin/warehouses/$warehouseId/_layout/shelving': typeof AppAdminWarehousesWarehouseIdLayoutShelvingRoute
  '/app/dashboard/_layout/pending-approvals/_layout/price': typeof AppDashboardLayoutPendingApprovalsLayoutPriceRoute
  '/app/dashboard/_layout/pending-approvals/_layout/quality': typeof AppDashboardLayoutPendingApprovalsLayoutQualityRoute
  '/app/dashboard/_layout/pending-approvals/_layout/sample': typeof AppDashboardLayoutPendingApprovalsLayoutSampleRoute
  '/app/dashboard/_layout/pending-approvals/_layout/source-change': typeof AppDashboardLayoutPendingApprovalsLayoutSourceChangeRoute
  '/app/inventory/products/$productId/_layout/lots': typeof AppInventoryProductsProductIdLayoutLotsRoute
  '/app/inventory/products/$productId/_layout/pallets': typeof AppInventoryProductsProductIdLayoutPalletsRoute
  '/app/inventory/products/$productId/_layout/transactions': typeof AppInventoryProductsProductIdLayoutTransactionsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdRouteWithChildren
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdRouteWithChildren
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdRouteWithChildren
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdFinalizeCheckInRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutUploadsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutCommentsRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutUploadsRoute
  '/app/orders/$companyId/$shipToLocationId/_layout/': typeof AppOrdersCompanyIdShipToLocationIdLayoutIndexRouteRoute
  '/app/inventory/products/$productId/_layout/': typeof AppInventoryProductsProductIdLayoutIndexRoute
  '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/': typeof AppWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/': typeof AppWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/': typeof AppWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/': typeof AppWarehouseReceivingStoredGoodsReceiptIdLayoutIndexRoute
  '/app/companies/$companyId/edit/_layout/locations/$locationId': typeof AppCompaniesCompanyIdEditLayoutLocationsLocationIdRouteRoute
  '/app/product/$productId/edit/_layout/costs': typeof AppProductProductIdEditLayoutCostsRouteWithChildren
  '/app/product/$productId/edit/_layout/costs/_layout': typeof AppProductProductIdEditLayoutCostsLayoutRouteWithChildren
  '/app/product/$productId/edit/_layout/quality': typeof AppProductProductIdEditLayoutQualityRouteWithChildren
  '/app/product/$productId/edit/_layout/quality/_layout': typeof AppProductProductIdEditLayoutQualityLayoutRouteWithChildren
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutBuiltPalletsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutCommentsRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutPurchaseOrdersRoute
  '/app/product/$productId/edit/_layout/costs/': typeof AppProductProductIdEditLayoutCostsIndexRoute
  '/app/product/$productId/edit/_layout/quality/': typeof AppProductProductIdEditLayoutQualityIndexRoute
  '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/': typeof AppTabletWarehouseReceivingCheckedInGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/': typeof AppTabletWarehouseReceivingIncomingGoodsReceiptIdLayoutIndexRoute
  '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/': typeof AppTabletWarehouseReceivingSoftReceivedGoodsReceiptIdLayoutIndexRoute
  '/app/product/$productId/edit/_layout/costs/_layout/laid-down': typeof AppProductProductIdEditLayoutCostsLayoutLaidDownRouteRoute
  '/app/product/$productId/edit/_layout/costs/_layout/purchase-costs': typeof AppProductProductIdEditLayoutCostsLayoutPurchaseCostsRouteRoute
  '/app/product/$productId/edit/_layout/quality/_layout/results': typeof AppProductProductIdEditLayoutQualityLayoutResultsRouteRoute
  '/app/product/$productId/edit/_layout/quality/_layout/templates': typeof AppProductProductIdEditLayoutQualityLayoutTemplatesRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/deactivated'
    | '/logout'
    | '/app/company'
    | '/app/orders'
    | '/app/regulatory'
    | '/app/tablet'
    | '/auth/callback'
    | '/app/'
    | '/app/sales/customers'
    | '/app/sales/sales-orders'
    | '/app/accounting'
    | '/app/dashboard'
    | '/app/inventory'
    | '/app/pricing'
    | '/app/procurement'
    | '/app/warehouse-receiving'
    | '/app/orders/'
    | '/app/sales'
    | '/app/tablet/'
    | '/app/accounting/'
    | '/app/admin'
    | '/app/companies'
    | '/app/dashboard/'
    | '/app/inventory/'
    | '/app/pricing/'
    | '/app/procurement/'
    | '/app/products'
    | '/app/warehouse-receiving/'
    | '/app/accounting/accounts-payable'
    | '/app/accounting/gl-transactions'
    | '/app/accounting/huntington-pay-files'
    | '/app/accounting/payable-approvals'
    | '/app/admin/accounting'
    | '/app/admin/accounting/create-payment-term'
    | '/app/admin/manage-products'
    | '/app/admin/system-admin'
    | '/app/dashboard/my-requests'
    | '/app/inventory/adjustment-history'
    | '/app/inventory/products'
    | '/app/inventory/transfers'
    | '/app/inventory/transfers/new'
    | '/app/pricing/$priceChangeId/review'
    | '/app/pricing/price-change'
    | '/app/procurement/cost-breakdown'
    | '/app/procurement/purchase-orders'
    | '/app/procurement/supplier-report'
    | '/app/tablet/warehouse-receiving'
    | '/app/warehouse-receiving/checked-in'
    | '/app/warehouse-receiving/incoming'
    | '/app/warehouse-receiving/soft-received'
    | '/app/warehouse-receiving/stored'
    | '/app/tablet/sales'
    | '/app/admin/accounting/'
    | '/app/admin/change-log'
    | '/app/admin/manage-products/'
    | '/app/admin/system-admin/'
    | '/app/admin/warehouses'
    | '/app/tablet/warehouse-receiving/'
    | '/app/contact/$contactId'
    | '/app/admin/accounting/accounts-chart'
    | '/app/admin/accounting/payment-terms'
    | '/app/admin/accounting/settings'
    | '/app/admin/accounting/payment-term/$paymentTermId'
    | '/app/admin/manage-products/categories'
    | '/app/admin/manage-products/classes'
    | '/app/admin/manage-products/competitor-products'
    | '/app/admin/manage-products/equivalents'
    | '/app/admin/manage-products/instructions'
    | '/app/admin/manage-products/test-templates'
    | '/app/admin/system-admin/roles'
    | '/app/admin/system-admin/users'
    | '/app/admin/system-admin/users/$userId'
    | '/app/admin/warehouses/$warehouseId'
    | '/app/companies/$companyId/edit'
    | '/app/dashboard/pending-approvals'
    | '/app/inventory/products/$productId'
    | '/app/inventory/transfers/$transferId/edit'
    | '/app/orders/$companyId/$shipToLocationId'
    | '/app/pricing/history/price-change'
    | '/app/pricing/history/purchase-cost'
    | '/app/procurement/purchase-orders/$purchaseOrderId'
    | '/app/product/$productId/edit'
    | '/app/tablet/warehouse-receiving/checked-in'
    | '/app/tablet/warehouse-receiving/incoming'
    | '/app/tablet/warehouse-receiving/soft-received'
    | '/app/tablet/warehouse-receiving/stored'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/stored/$goodsReceiptId'
    | '/app/procurement/supplier-report/new-supplier'
    | '/app/admin/warehouses/$warehouseId/'
    | '/app/companies/$companyId/edit/'
    | '/app/dashboard/pending-approvals/'
    | '/app/product/$productId/edit/'
    | '/app/product/$productId/preference'
    | '/app/companies/$companyId/edit/accounting'
    | '/app/companies/$companyId/edit/certification'
    | '/app/companies/$companyId/edit/contacts'
    | '/app/companies/$companyId/edit/evaluation'
    | '/app/companies/$companyId/edit/info'
    | '/app/companies/$companyId/edit/locations'
    | '/app/companies/$companyId/edit/preferences'
    | '/app/companies/$companyId/edit/products'
    | '/app/companies/$companyId/edit/registration'
    | '/app/orders/$companyId/$shipToLocationId/closed-sales-orders'
    | '/app/orders/$companyId/$shipToLocationId/customer-purchase-orders'
    | '/app/orders/$companyId/$shipToLocationId/open-sales-orders'
    | '/app/product/$productId/edit/information'
    | '/app/product/$productId/edit/instructions'
    | '/app/product/$productId/edit/regulatory'
    | '/app/product/$productId/edit/storage'
    | '/app/admin/warehouses/$warehouseId/info'
    | '/app/admin/warehouses/$warehouseId/shelving'
    | '/app/dashboard/pending-approvals/price'
    | '/app/dashboard/pending-approvals/quality'
    | '/app/dashboard/pending-approvals/sample'
    | '/app/dashboard/pending-approvals/source-change'
    | '/app/inventory/products/$productId/lots'
    | '/app/inventory/products/$productId/pallets'
    | '/app/inventory/products/$productId/transactions'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/uploads'
    | '/app/orders/$companyId/$shipToLocationId/'
    | '/app/inventory/products/$productId/'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/'
    | '/app/companies/$companyId/edit/locations/$locationId'
    | '/app/product/$productId/edit/costs'
    | '/app/product/$productId/edit/quality'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
    | '/app/product/$productId/edit/costs/'
    | '/app/product/$productId/edit/quality/'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/'
    | '/app/product/$productId/edit/costs/laid-down'
    | '/app/product/$productId/edit/costs/purchase-costs'
    | '/app/product/$productId/edit/quality/results'
    | '/app/product/$productId/edit/quality/templates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deactivated'
    | '/logout'
    | '/app/company'
    | '/app/regulatory'
    | '/auth/callback'
    | '/app'
    | '/app/sales/customers'
    | '/app/sales/sales-orders'
    | '/app/accounting'
    | '/app/dashboard'
    | '/app/inventory'
    | '/app/pricing'
    | '/app/procurement'
    | '/app/warehouse-receiving'
    | '/app/orders'
    | '/app/sales'
    | '/app/tablet'
    | '/app/admin'
    | '/app/companies'
    | '/app/products'
    | '/app/accounting/accounts-payable'
    | '/app/accounting/gl-transactions'
    | '/app/accounting/huntington-pay-files'
    | '/app/accounting/payable-approvals'
    | '/app/admin/accounting'
    | '/app/admin/accounting/create-payment-term'
    | '/app/admin/manage-products'
    | '/app/admin/system-admin'
    | '/app/dashboard/my-requests'
    | '/app/inventory/adjustment-history'
    | '/app/inventory/products'
    | '/app/inventory/transfers'
    | '/app/inventory/transfers/new'
    | '/app/pricing/$priceChangeId/review'
    | '/app/pricing/price-change'
    | '/app/procurement/cost-breakdown'
    | '/app/procurement/purchase-orders'
    | '/app/procurement/supplier-report'
    | '/app/tablet/warehouse-receiving'
    | '/app/warehouse-receiving/checked-in'
    | '/app/warehouse-receiving/incoming'
    | '/app/warehouse-receiving/soft-received'
    | '/app/warehouse-receiving/stored'
    | '/app/tablet/sales'
    | '/app/admin/change-log'
    | '/app/admin/warehouses'
    | '/app/contact/$contactId'
    | '/app/admin/accounting/accounts-chart'
    | '/app/admin/accounting/payment-terms'
    | '/app/admin/accounting/settings'
    | '/app/admin/accounting/payment-term/$paymentTermId'
    | '/app/admin/manage-products/categories'
    | '/app/admin/manage-products/classes'
    | '/app/admin/manage-products/competitor-products'
    | '/app/admin/manage-products/equivalents'
    | '/app/admin/manage-products/instructions'
    | '/app/admin/manage-products/test-templates'
    | '/app/admin/system-admin/roles'
    | '/app/admin/system-admin/users'
    | '/app/admin/system-admin/users/$userId'
    | '/app/admin/warehouses/$warehouseId'
    | '/app/companies/$companyId/edit'
    | '/app/dashboard/pending-approvals'
    | '/app/inventory/products/$productId'
    | '/app/inventory/transfers/$transferId/edit'
    | '/app/orders/$companyId/$shipToLocationId'
    | '/app/pricing/history/price-change'
    | '/app/pricing/history/purchase-cost'
    | '/app/procurement/purchase-orders/$purchaseOrderId'
    | '/app/product/$productId/edit'
    | '/app/tablet/warehouse-receiving/checked-in'
    | '/app/tablet/warehouse-receiving/incoming'
    | '/app/tablet/warehouse-receiving/soft-received'
    | '/app/tablet/warehouse-receiving/stored'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/stored/$goodsReceiptId'
    | '/app/procurement/supplier-report/new-supplier'
    | '/app/product/$productId/preference'
    | '/app/companies/$companyId/edit/accounting'
    | '/app/companies/$companyId/edit/certification'
    | '/app/companies/$companyId/edit/contacts'
    | '/app/companies/$companyId/edit/evaluation'
    | '/app/companies/$companyId/edit/info'
    | '/app/companies/$companyId/edit/locations'
    | '/app/companies/$companyId/edit/preferences'
    | '/app/companies/$companyId/edit/products'
    | '/app/companies/$companyId/edit/registration'
    | '/app/orders/$companyId/$shipToLocationId/closed-sales-orders'
    | '/app/orders/$companyId/$shipToLocationId/customer-purchase-orders'
    | '/app/orders/$companyId/$shipToLocationId/open-sales-orders'
    | '/app/product/$productId/edit/information'
    | '/app/product/$productId/edit/instructions'
    | '/app/product/$productId/edit/regulatory'
    | '/app/product/$productId/edit/storage'
    | '/app/admin/warehouses/$warehouseId/info'
    | '/app/admin/warehouses/$warehouseId/shelving'
    | '/app/dashboard/pending-approvals/price'
    | '/app/dashboard/pending-approvals/quality'
    | '/app/dashboard/pending-approvals/sample'
    | '/app/dashboard/pending-approvals/source-change'
    | '/app/inventory/products/$productId/lots'
    | '/app/inventory/products/$productId/pallets'
    | '/app/inventory/products/$productId/transactions'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/uploads'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/comments'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/purchase-orders'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/uploads'
    | '/app/companies/$companyId/edit/locations/$locationId'
    | '/app/product/$productId/edit/costs'
    | '/app/product/$productId/edit/quality'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/built-pallets'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/purchase-orders'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/comments'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/purchase-orders'
    | '/app/product/$productId/edit/costs/laid-down'
    | '/app/product/$productId/edit/costs/purchase-costs'
    | '/app/product/$productId/edit/quality/results'
    | '/app/product/$productId/edit/quality/templates'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/deactivated'
    | '/logout'
    | '/app/company'
    | '/app/orders'
    | '/app/regulatory'
    | '/app/tablet'
    | '/auth/callback'
    | '/app/'
    | '/app/sales/customers'
    | '/app/sales/sales-orders'
    | '/app/accounting'
    | '/app/accounting/_layout'
    | '/app/dashboard'
    | '/app/dashboard/_layout'
    | '/app/inventory'
    | '/app/inventory/_layout'
    | '/app/pricing'
    | '/app/pricing/_layout'
    | '/app/procurement'
    | '/app/procurement/_layout'
    | '/app/warehouse-receiving'
    | '/app/warehouse-receiving/_layout'
    | '/app/orders/'
    | '/app/sales/'
    | '/app/tablet/'
    | '/app/accounting/'
    | '/app/admin/'
    | '/app/companies/'
    | '/app/dashboard/'
    | '/app/inventory/'
    | '/app/pricing/'
    | '/app/procurement/'
    | '/app/products/'
    | '/app/warehouse-receiving/'
    | '/app/accounting/_layout/accounts-payable'
    | '/app/accounting/_layout/gl-transactions'
    | '/app/accounting/_layout/huntington-pay-files'
    | '/app/accounting/_layout/payable-approvals'
    | '/app/admin/accounting'
    | '/app/admin/accounting/_layout'
    | '/app/admin/accounting/create-payment-term'
    | '/app/admin/manage-products'
    | '/app/admin/manage-products/_layout'
    | '/app/admin/system-admin'
    | '/app/admin/system-admin/_layout'
    | '/app/dashboard/_layout/my-requests'
    | '/app/inventory/_layout/adjustment-history'
    | '/app/inventory/_layout/products'
    | '/app/inventory/_layout/transfers'
    | '/app/inventory/transfers/new'
    | '/app/pricing/$priceChangeId/review'
    | '/app/pricing/_layout/price-change'
    | '/app/procurement/_layout/cost-breakdown'
    | '/app/procurement/_layout/purchase-orders'
    | '/app/procurement/_layout/supplier-report'
    | '/app/tablet/warehouse-receiving'
    | '/app/tablet/warehouse-receiving/_layout'
    | '/app/warehouse-receiving/_layout/checked-in'
    | '/app/warehouse-receiving/_layout/incoming'
    | '/app/warehouse-receiving/_layout/soft-received'
    | '/app/warehouse-receiving/_layout/stored'
    | '/app/tablet/sales/'
    | '/app/admin/accounting/'
    | '/app/admin/change-log/'
    | '/app/admin/manage-products/'
    | '/app/admin/system-admin/'
    | '/app/admin/warehouses/'
    | '/app/tablet/warehouse-receiving/'
    | '/app/contact/$contactId/'
    | '/app/admin/accounting/_layout/accounts-chart'
    | '/app/admin/accounting/_layout/payment-terms'
    | '/app/admin/accounting/_layout/settings'
    | '/app/admin/accounting/payment-term/$paymentTermId'
    | '/app/admin/manage-products/_layout/categories'
    | '/app/admin/manage-products/_layout/classes'
    | '/app/admin/manage-products/_layout/competitor-products'
    | '/app/admin/manage-products/_layout/equivalents'
    | '/app/admin/manage-products/_layout/instructions'
    | '/app/admin/manage-products/_layout/test-templates'
    | '/app/admin/system-admin/_layout/roles'
    | '/app/admin/system-admin/_layout/users'
    | '/app/admin/system-admin/users/$userId'
    | '/app/admin/warehouses/$warehouseId'
    | '/app/admin/warehouses/$warehouseId/_layout'
    | '/app/companies/$companyId/edit'
    | '/app/companies/$companyId/edit/_layout'
    | '/app/dashboard/_layout/pending-approvals'
    | '/app/dashboard/_layout/pending-approvals/_layout'
    | '/app/inventory/products/$productId'
    | '/app/inventory/products/$productId/_layout'
    | '/app/inventory/transfers/$transferId/edit'
    | '/app/orders/$companyId/$shipToLocationId'
    | '/app/orders/$companyId/$shipToLocationId/_layout'
    | '/app/pricing/_layout/history/price-change'
    | '/app/pricing/_layout/history/purchase-cost'
    | '/app/procurement/_layout_/purchase-orders/$purchaseOrderId'
    | '/app/product/$productId/edit'
    | '/app/product/$productId/edit/_layout'
    | '/app/tablet/warehouse-receiving/_layout/checked-in'
    | '/app/tablet/warehouse-receiving/_layout/incoming'
    | '/app/tablet/warehouse-receiving/_layout/soft-received'
    | '/app/tablet/warehouse-receiving/_layout/stored'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/stored/$goodsReceiptId'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout'
    | '/app/procurement/_layout/supplier-report/new-supplier'
    | '/app/admin/warehouses/$warehouseId/'
    | '/app/companies/$companyId/edit/'
    | '/app/dashboard/_layout/pending-approvals/'
    | '/app/product/$productId/edit/'
    | '/app/product/$productId/preference/'
    | '/app/companies/$companyId/edit/_layout/accounting'
    | '/app/companies/$companyId/edit/_layout/certification'
    | '/app/companies/$companyId/edit/_layout/contacts'
    | '/app/companies/$companyId/edit/_layout/evaluation'
    | '/app/companies/$companyId/edit/_layout/info'
    | '/app/companies/$companyId/edit/_layout/locations'
    | '/app/companies/$companyId/edit/_layout/preferences'
    | '/app/companies/$companyId/edit/_layout/products'
    | '/app/companies/$companyId/edit/_layout/registration'
    | '/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders'
    | '/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders'
    | '/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders'
    | '/app/product/$productId/edit/_layout/information'
    | '/app/product/$productId/edit/_layout/instructions'
    | '/app/product/$productId/edit/_layout/regulatory'
    | '/app/product/$productId/edit/_layout/storage'
    | '/app/admin/warehouses/$warehouseId/_layout/info'
    | '/app/admin/warehouses/$warehouseId/_layout/shelving'
    | '/app/dashboard/_layout/pending-approvals/_layout/price'
    | '/app/dashboard/_layout/pending-approvals/_layout/quality'
    | '/app/dashboard/_layout/pending-approvals/_layout/sample'
    | '/app/dashboard/_layout/pending-approvals/_layout/source-change'
    | '/app/inventory/products/$productId/_layout/lots'
    | '/app/inventory/products/$productId/_layout/pallets'
    | '/app/inventory/products/$productId/_layout/transactions'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads'
    | '/app/orders/$companyId/$shipToLocationId/_layout/'
    | '/app/inventory/products/$productId/_layout/'
    | '/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/'
    | '/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/'
    | '/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/'
    | '/app/warehouse-receiving/stored/$goodsReceiptId/_layout/'
    | '/app/companies/$companyId/edit/_layout/locations/$locationId'
    | '/app/product/$productId/edit/_layout/costs'
    | '/app/product/$productId/edit/_layout/costs/_layout'
    | '/app/product/$productId/edit/_layout/quality'
    | '/app/product/$productId/edit/_layout/quality/_layout'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders'
    | '/app/product/$productId/edit/_layout/costs/'
    | '/app/product/$productId/edit/_layout/quality/'
    | '/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/'
    | '/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/'
    | '/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/'
    | '/app/product/$productId/edit/_layout/costs/_layout/laid-down'
    | '/app/product/$productId/edit/_layout/costs/_layout/purchase-costs'
    | '/app/product/$productId/edit/_layout/quality/_layout/results'
    | '/app/product/$productId/edit/_layout/quality/_layout/templates'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  DeactivatedRouteRoute: typeof DeactivatedRouteRoute
  LogoutRouteRoute: typeof LogoutRouteRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  DeactivatedRouteRoute: DeactivatedRouteRoute,
  LogoutRouteRoute: LogoutRouteRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/deactivated",
        "/logout",
        "/auth/callback"
      ]
    },
    "/": {
      "filePath": "index.route.tsx"
    },
    "/app": {
      "filePath": "app.route.tsx",
      "children": [
        "/app/company",
        "/app/orders",
        "/app/regulatory",
        "/app/tablet",
        "/app/",
        "/app/sales/customers",
        "/app/sales/sales-orders",
        "/app/accounting",
        "/app/dashboard",
        "/app/inventory",
        "/app/pricing",
        "/app/procurement",
        "/app/warehouse-receiving",
        "/app/sales/",
        "/app/admin/",
        "/app/companies/",
        "/app/products/",
        "/app/admin/accounting",
        "/app/admin/manage-products",
        "/app/admin/system-admin",
        "/app/admin/change-log/",
        "/app/admin/warehouses/",
        "/app/contact/$contactId/",
        "/app/admin/warehouses/$warehouseId",
        "/app/companies/$companyId/edit",
        "/app/product/$productId/edit",
        "/app/product/$productId/preference/"
      ]
    },
    "/deactivated": {
      "filePath": "deactivated.route.tsx"
    },
    "/logout": {
      "filePath": "logout.route.tsx"
    },
    "/app/company": {
      "filePath": "app/company.route.tsx",
      "parent": "/app"
    },
    "/app/orders": {
      "filePath": "app/orders.route.tsx",
      "parent": "/app",
      "children": [
        "/app/orders/",
        "/app/orders/$companyId/$shipToLocationId"
      ]
    },
    "/app/regulatory": {
      "filePath": "app/regulatory.route.tsx",
      "parent": "/app"
    },
    "/app/tablet": {
      "filePath": "app/tablet.tsx",
      "parent": "/app",
      "children": [
        "/app/tablet/",
        "/app/tablet/warehouse-receiving",
        "/app/tablet/sales/"
      ]
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    },
    "/app/": {
      "filePath": "app/index.route.tsx",
      "parent": "/app"
    },
    "/app/sales/customers": {
      "filePath": "app/sales/customers.route.tsx",
      "parent": "/app"
    },
    "/app/sales/sales-orders": {
      "filePath": "app/sales/sales-orders.route.tsx",
      "parent": "/app"
    },
    "/app/accounting": {
      "filePath": "app/accounting",
      "parent": "/app",
      "children": [
        "/app/accounting/_layout",
        "/app/accounting/"
      ]
    },
    "/app/accounting/_layout": {
      "filePath": "app/accounting/_layout.tsx",
      "parent": "/app/accounting",
      "children": [
        "/app/accounting/_layout/accounts-payable",
        "/app/accounting/_layout/gl-transactions",
        "/app/accounting/_layout/huntington-pay-files",
        "/app/accounting/_layout/payable-approvals"
      ]
    },
    "/app/dashboard": {
      "filePath": "app/dashboard",
      "parent": "/app",
      "children": [
        "/app/dashboard/_layout",
        "/app/dashboard/"
      ]
    },
    "/app/dashboard/_layout": {
      "filePath": "app/dashboard/_layout.tsx",
      "parent": "/app/dashboard",
      "children": [
        "/app/dashboard/_layout/my-requests",
        "/app/dashboard/_layout/pending-approvals"
      ]
    },
    "/app/inventory": {
      "filePath": "app/inventory",
      "parent": "/app",
      "children": [
        "/app/inventory/_layout",
        "/app/inventory/",
        "/app/inventory/transfers/new",
        "/app/inventory/products/$productId",
        "/app/inventory/transfers/$transferId/edit"
      ]
    },
    "/app/inventory/_layout": {
      "filePath": "app/inventory/_layout.tsx",
      "parent": "/app/inventory",
      "children": [
        "/app/inventory/_layout/adjustment-history",
        "/app/inventory/_layout/products",
        "/app/inventory/_layout/transfers"
      ]
    },
    "/app/pricing": {
      "filePath": "app/pricing",
      "parent": "/app",
      "children": [
        "/app/pricing/_layout",
        "/app/pricing/",
        "/app/pricing/$priceChangeId/review"
      ]
    },
    "/app/pricing/_layout": {
      "filePath": "app/pricing/_layout.tsx",
      "parent": "/app/pricing",
      "children": [
        "/app/pricing/_layout/price-change",
        "/app/pricing/_layout/history/price-change",
        "/app/pricing/_layout/history/purchase-cost"
      ]
    },
    "/app/procurement": {
      "filePath": "app/procurement",
      "parent": "/app",
      "children": [
        "/app/procurement/_layout",
        "/app/procurement/",
        "/app/procurement/_layout_/purchase-orders/$purchaseOrderId"
      ]
    },
    "/app/procurement/_layout": {
      "filePath": "app/procurement/_layout.tsx",
      "parent": "/app/procurement",
      "children": [
        "/app/procurement/_layout/cost-breakdown",
        "/app/procurement/_layout/purchase-orders",
        "/app/procurement/_layout/supplier-report"
      ]
    },
    "/app/warehouse-receiving": {
      "filePath": "app/warehouse-receiving",
      "parent": "/app",
      "children": [
        "/app/warehouse-receiving/_layout",
        "/app/warehouse-receiving/",
        "/app/warehouse-receiving/checked-in/$goodsReceiptId",
        "/app/warehouse-receiving/incoming/$goodsReceiptId",
        "/app/warehouse-receiving/soft-received/$goodsReceiptId",
        "/app/warehouse-receiving/stored/$goodsReceiptId"
      ]
    },
    "/app/warehouse-receiving/_layout": {
      "filePath": "app/warehouse-receiving/_layout.tsx",
      "parent": "/app/warehouse-receiving",
      "children": [
        "/app/warehouse-receiving/_layout/checked-in",
        "/app/warehouse-receiving/_layout/incoming",
        "/app/warehouse-receiving/_layout/soft-received",
        "/app/warehouse-receiving/_layout/stored"
      ]
    },
    "/app/orders/": {
      "filePath": "app/orders/index.route.tsx",
      "parent": "/app/orders"
    },
    "/app/sales/": {
      "filePath": "app/sales/index.route.tsx",
      "parent": "/app"
    },
    "/app/tablet/": {
      "filePath": "app/tablet/index.route.tsx",
      "parent": "/app/tablet"
    },
    "/app/accounting/": {
      "filePath": "app/accounting/index.tsx",
      "parent": "/app/accounting"
    },
    "/app/admin/": {
      "filePath": "app/admin/index.tsx",
      "parent": "/app"
    },
    "/app/companies/": {
      "filePath": "app/companies/index.tsx",
      "parent": "/app"
    },
    "/app/dashboard/": {
      "filePath": "app/dashboard/index.tsx",
      "parent": "/app/dashboard"
    },
    "/app/inventory/": {
      "filePath": "app/inventory/index.tsx",
      "parent": "/app/inventory"
    },
    "/app/pricing/": {
      "filePath": "app/pricing/index.tsx",
      "parent": "/app/pricing"
    },
    "/app/procurement/": {
      "filePath": "app/procurement/index.tsx",
      "parent": "/app/procurement"
    },
    "/app/products/": {
      "filePath": "app/products/index.tsx",
      "parent": "/app"
    },
    "/app/warehouse-receiving/": {
      "filePath": "app/warehouse-receiving/index.tsx",
      "parent": "/app/warehouse-receiving"
    },
    "/app/accounting/_layout/accounts-payable": {
      "filePath": "app/accounting/_layout.accounts-payable.tsx",
      "parent": "/app/accounting/_layout"
    },
    "/app/accounting/_layout/gl-transactions": {
      "filePath": "app/accounting/_layout.gl-transactions.tsx",
      "parent": "/app/accounting/_layout"
    },
    "/app/accounting/_layout/huntington-pay-files": {
      "filePath": "app/accounting/_layout.huntington-pay-files.tsx",
      "parent": "/app/accounting/_layout"
    },
    "/app/accounting/_layout/payable-approvals": {
      "filePath": "app/accounting/_layout.payable-approvals.tsx",
      "parent": "/app/accounting/_layout"
    },
    "/app/admin/accounting": {
      "filePath": "app/admin/accounting",
      "parent": "/app",
      "children": [
        "/app/admin/accounting/_layout",
        "/app/admin/accounting/create-payment-term",
        "/app/admin/accounting/",
        "/app/admin/accounting/payment-term/$paymentTermId"
      ]
    },
    "/app/admin/accounting/_layout": {
      "filePath": "app/admin/accounting/_layout.tsx",
      "parent": "/app/admin/accounting",
      "children": [
        "/app/admin/accounting/_layout/accounts-chart",
        "/app/admin/accounting/_layout/payment-terms",
        "/app/admin/accounting/_layout/settings"
      ]
    },
    "/app/admin/accounting/create-payment-term": {
      "filePath": "app/admin/accounting/create-payment-term.tsx",
      "parent": "/app/admin/accounting"
    },
    "/app/admin/manage-products": {
      "filePath": "app/admin/manage-products",
      "parent": "/app",
      "children": [
        "/app/admin/manage-products/_layout",
        "/app/admin/manage-products/"
      ]
    },
    "/app/admin/manage-products/_layout": {
      "filePath": "app/admin/manage-products/_layout.tsx",
      "parent": "/app/admin/manage-products",
      "children": [
        "/app/admin/manage-products/_layout/categories",
        "/app/admin/manage-products/_layout/classes",
        "/app/admin/manage-products/_layout/competitor-products",
        "/app/admin/manage-products/_layout/equivalents",
        "/app/admin/manage-products/_layout/instructions",
        "/app/admin/manage-products/_layout/test-templates"
      ]
    },
    "/app/admin/system-admin": {
      "filePath": "app/admin/system-admin",
      "parent": "/app",
      "children": [
        "/app/admin/system-admin/_layout",
        "/app/admin/system-admin/",
        "/app/admin/system-admin/users/$userId"
      ]
    },
    "/app/admin/system-admin/_layout": {
      "filePath": "app/admin/system-admin/_layout.tsx",
      "parent": "/app/admin/system-admin",
      "children": [
        "/app/admin/system-admin/_layout/roles",
        "/app/admin/system-admin/_layout/users"
      ]
    },
    "/app/dashboard/_layout/my-requests": {
      "filePath": "app/dashboard/_layout/my-requests.tsx",
      "parent": "/app/dashboard/_layout"
    },
    "/app/inventory/_layout/adjustment-history": {
      "filePath": "app/inventory/_layout/adjustment-history.tsx",
      "parent": "/app/inventory/_layout"
    },
    "/app/inventory/_layout/products": {
      "filePath": "app/inventory/_layout/products.tsx",
      "parent": "/app/inventory/_layout"
    },
    "/app/inventory/_layout/transfers": {
      "filePath": "app/inventory/_layout/transfers.tsx",
      "parent": "/app/inventory/_layout"
    },
    "/app/inventory/transfers/new": {
      "filePath": "app/inventory/transfers/new.tsx",
      "parent": "/app/inventory"
    },
    "/app/pricing/$priceChangeId/review": {
      "filePath": "app/pricing/$priceChangeId/review.tsx",
      "parent": "/app/pricing"
    },
    "/app/pricing/_layout/price-change": {
      "filePath": "app/pricing/_layout/price-change.tsx",
      "parent": "/app/pricing/_layout"
    },
    "/app/procurement/_layout/cost-breakdown": {
      "filePath": "app/procurement/_layout.cost-breakdown.tsx",
      "parent": "/app/procurement/_layout"
    },
    "/app/procurement/_layout/purchase-orders": {
      "filePath": "app/procurement/_layout.purchase-orders.tsx",
      "parent": "/app/procurement/_layout"
    },
    "/app/procurement/_layout/supplier-report": {
      "filePath": "app/procurement/_layout.supplier-report.tsx",
      "parent": "/app/procurement/_layout",
      "children": [
        "/app/procurement/_layout/supplier-report/new-supplier"
      ]
    },
    "/app/tablet/warehouse-receiving": {
      "filePath": "app/tablet/warehouse-receiving",
      "parent": "/app/tablet",
      "children": [
        "/app/tablet/warehouse-receiving/_layout",
        "/app/tablet/warehouse-receiving/",
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId",
        "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId",
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId"
      ]
    },
    "/app/tablet/warehouse-receiving/_layout": {
      "filePath": "app/tablet/warehouse-receiving/_layout.tsx",
      "parent": "/app/tablet/warehouse-receiving",
      "children": [
        "/app/tablet/warehouse-receiving/_layout/checked-in",
        "/app/tablet/warehouse-receiving/_layout/incoming",
        "/app/tablet/warehouse-receiving/_layout/soft-received",
        "/app/tablet/warehouse-receiving/_layout/stored"
      ]
    },
    "/app/warehouse-receiving/_layout/checked-in": {
      "filePath": "app/warehouse-receiving/_layout/checked-in.tsx",
      "parent": "/app/warehouse-receiving/_layout"
    },
    "/app/warehouse-receiving/_layout/incoming": {
      "filePath": "app/warehouse-receiving/_layout/incoming.tsx",
      "parent": "/app/warehouse-receiving/_layout"
    },
    "/app/warehouse-receiving/_layout/soft-received": {
      "filePath": "app/warehouse-receiving/_layout/soft-received.tsx",
      "parent": "/app/warehouse-receiving/_layout"
    },
    "/app/warehouse-receiving/_layout/stored": {
      "filePath": "app/warehouse-receiving/_layout/stored.tsx",
      "parent": "/app/warehouse-receiving/_layout"
    },
    "/app/tablet/sales/": {
      "filePath": "app/tablet/sales/index.route.tsx",
      "parent": "/app/tablet"
    },
    "/app/admin/accounting/": {
      "filePath": "app/admin/accounting/index.tsx",
      "parent": "/app/admin/accounting"
    },
    "/app/admin/change-log/": {
      "filePath": "app/admin/change-log/index.tsx",
      "parent": "/app"
    },
    "/app/admin/manage-products/": {
      "filePath": "app/admin/manage-products/index.tsx",
      "parent": "/app/admin/manage-products"
    },
    "/app/admin/system-admin/": {
      "filePath": "app/admin/system-admin/index.tsx",
      "parent": "/app/admin/system-admin"
    },
    "/app/admin/warehouses/": {
      "filePath": "app/admin/warehouses/index.tsx",
      "parent": "/app"
    },
    "/app/tablet/warehouse-receiving/": {
      "filePath": "app/tablet/warehouse-receiving/index.tsx",
      "parent": "/app/tablet/warehouse-receiving"
    },
    "/app/contact/$contactId/": {
      "filePath": "app/contact/$contactId/index.lazy.tsx",
      "parent": "/app"
    },
    "/app/admin/accounting/_layout/accounts-chart": {
      "filePath": "app/admin/accounting/_layout.accounts-chart.tsx",
      "parent": "/app/admin/accounting/_layout"
    },
    "/app/admin/accounting/_layout/payment-terms": {
      "filePath": "app/admin/accounting/_layout.payment-terms.tsx",
      "parent": "/app/admin/accounting/_layout"
    },
    "/app/admin/accounting/_layout/settings": {
      "filePath": "app/admin/accounting/_layout.settings.tsx",
      "parent": "/app/admin/accounting/_layout"
    },
    "/app/admin/accounting/payment-term/$paymentTermId": {
      "filePath": "app/admin/accounting/payment-term/$paymentTermId.tsx",
      "parent": "/app/admin/accounting"
    },
    "/app/admin/manage-products/_layout/categories": {
      "filePath": "app/admin/manage-products/_layout.categories.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/manage-products/_layout/classes": {
      "filePath": "app/admin/manage-products/_layout.classes.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/manage-products/_layout/competitor-products": {
      "filePath": "app/admin/manage-products/_layout.competitor-products.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/manage-products/_layout/equivalents": {
      "filePath": "app/admin/manage-products/_layout.equivalents.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/manage-products/_layout/instructions": {
      "filePath": "app/admin/manage-products/_layout.instructions.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/manage-products/_layout/test-templates": {
      "filePath": "app/admin/manage-products/_layout.test-templates.tsx",
      "parent": "/app/admin/manage-products/_layout"
    },
    "/app/admin/system-admin/_layout/roles": {
      "filePath": "app/admin/system-admin/_layout.roles.tsx",
      "parent": "/app/admin/system-admin/_layout"
    },
    "/app/admin/system-admin/_layout/users": {
      "filePath": "app/admin/system-admin/_layout.users.tsx",
      "parent": "/app/admin/system-admin/_layout"
    },
    "/app/admin/system-admin/users/$userId": {
      "filePath": "app/admin/system-admin/users/$userId.tsx",
      "parent": "/app/admin/system-admin"
    },
    "/app/admin/warehouses/$warehouseId": {
      "filePath": "app/admin/warehouses/$warehouseId",
      "parent": "/app",
      "children": [
        "/app/admin/warehouses/$warehouseId/_layout",
        "/app/admin/warehouses/$warehouseId/"
      ]
    },
    "/app/admin/warehouses/$warehouseId/_layout": {
      "filePath": "app/admin/warehouses/$warehouseId/_layout.tsx",
      "parent": "/app/admin/warehouses/$warehouseId",
      "children": [
        "/app/admin/warehouses/$warehouseId/_layout/info",
        "/app/admin/warehouses/$warehouseId/_layout/shelving"
      ]
    },
    "/app/companies/$companyId/edit": {
      "filePath": "app/companies/$companyId/edit",
      "parent": "/app",
      "children": [
        "/app/companies/$companyId/edit/_layout",
        "/app/companies/$companyId/edit/"
      ]
    },
    "/app/companies/$companyId/edit/_layout": {
      "filePath": "app/companies/$companyId/edit/_layout.tsx",
      "parent": "/app/companies/$companyId/edit",
      "children": [
        "/app/companies/$companyId/edit/_layout/accounting",
        "/app/companies/$companyId/edit/_layout/certification",
        "/app/companies/$companyId/edit/_layout/contacts",
        "/app/companies/$companyId/edit/_layout/evaluation",
        "/app/companies/$companyId/edit/_layout/info",
        "/app/companies/$companyId/edit/_layout/locations",
        "/app/companies/$companyId/edit/_layout/preferences",
        "/app/companies/$companyId/edit/_layout/products",
        "/app/companies/$companyId/edit/_layout/registration"
      ]
    },
    "/app/dashboard/_layout/pending-approvals": {
      "filePath": "app/dashboard/_layout/pending-approvals",
      "parent": "/app/dashboard/_layout",
      "children": [
        "/app/dashboard/_layout/pending-approvals/_layout",
        "/app/dashboard/_layout/pending-approvals/"
      ]
    },
    "/app/dashboard/_layout/pending-approvals/_layout": {
      "filePath": "app/dashboard/_layout/pending-approvals/_layout.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals",
      "children": [
        "/app/dashboard/_layout/pending-approvals/_layout/price",
        "/app/dashboard/_layout/pending-approvals/_layout/quality",
        "/app/dashboard/_layout/pending-approvals/_layout/sample",
        "/app/dashboard/_layout/pending-approvals/_layout/source-change"
      ]
    },
    "/app/inventory/products/$productId": {
      "filePath": "app/inventory/products/$productId",
      "parent": "/app/inventory",
      "children": [
        "/app/inventory/products/$productId/_layout"
      ]
    },
    "/app/inventory/products/$productId/_layout": {
      "filePath": "app/inventory/products/$productId/_layout.tsx",
      "parent": "/app/inventory/products/$productId",
      "children": [
        "/app/inventory/products/$productId/_layout/lots",
        "/app/inventory/products/$productId/_layout/pallets",
        "/app/inventory/products/$productId/_layout/transactions",
        "/app/inventory/products/$productId/_layout/"
      ]
    },
    "/app/inventory/transfers/$transferId/edit": {
      "filePath": "app/inventory/transfers/$transferId/edit.tsx",
      "parent": "/app/inventory"
    },
    "/app/orders/$companyId/$shipToLocationId": {
      "filePath": "app/orders/$companyId/$shipToLocationId",
      "parent": "/app/orders",
      "children": [
        "/app/orders/$companyId/$shipToLocationId/_layout"
      ]
    },
    "/app/orders/$companyId/$shipToLocationId/_layout": {
      "filePath": "app/orders/$companyId/$shipToLocationId/_layout.tsx",
      "parent": "/app/orders/$companyId/$shipToLocationId",
      "children": [
        "/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders",
        "/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders",
        "/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders",
        "/app/orders/$companyId/$shipToLocationId/_layout/"
      ]
    },
    "/app/pricing/_layout/history/price-change": {
      "filePath": "app/pricing/_layout/history/price-change.tsx",
      "parent": "/app/pricing/_layout"
    },
    "/app/pricing/_layout/history/purchase-cost": {
      "filePath": "app/pricing/_layout/history/purchase-cost.tsx",
      "parent": "/app/pricing/_layout"
    },
    "/app/procurement/_layout_/purchase-orders/$purchaseOrderId": {
      "filePath": "app/procurement/_layout_.purchase-orders.$purchaseOrderId.tsx",
      "parent": "/app/procurement"
    },
    "/app/product/$productId/edit": {
      "filePath": "app/product/$productId/edit",
      "parent": "/app",
      "children": [
        "/app/product/$productId/edit/_layout",
        "/app/product/$productId/edit/"
      ]
    },
    "/app/product/$productId/edit/_layout": {
      "filePath": "app/product/$productId/edit/_layout.tsx",
      "parent": "/app/product/$productId/edit",
      "children": [
        "/app/product/$productId/edit/_layout/information",
        "/app/product/$productId/edit/_layout/instructions",
        "/app/product/$productId/edit/_layout/regulatory",
        "/app/product/$productId/edit/_layout/storage",
        "/app/product/$productId/edit/_layout/costs",
        "/app/product/$productId/edit/_layout/quality"
      ]
    },
    "/app/tablet/warehouse-receiving/_layout/checked-in": {
      "filePath": "app/tablet/warehouse-receiving/_layout/checked-in.tsx",
      "parent": "/app/tablet/warehouse-receiving/_layout"
    },
    "/app/tablet/warehouse-receiving/_layout/incoming": {
      "filePath": "app/tablet/warehouse-receiving/_layout/incoming.tsx",
      "parent": "/app/tablet/warehouse-receiving/_layout"
    },
    "/app/tablet/warehouse-receiving/_layout/soft-received": {
      "filePath": "app/tablet/warehouse-receiving/_layout/soft-received.tsx",
      "parent": "/app/tablet/warehouse-receiving/_layout"
    },
    "/app/tablet/warehouse-receiving/_layout/stored": {
      "filePath": "app/tablet/warehouse-receiving/_layout/stored.tsx",
      "parent": "/app/tablet/warehouse-receiving/_layout"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId",
      "parent": "/app/warehouse-receiving",
      "children": [
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
      ]
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId",
      "children": [
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets",
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments",
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders",
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads",
        "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/"
      ]
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId",
      "parent": "/app/warehouse-receiving",
      "children": [
        "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout"
      ]
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId/_layout.tsx",
      "parent": "/app/warehouse-receiving/incoming/$goodsReceiptId",
      "children": [
        "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments",
        "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders",
        "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads",
        "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/"
      ]
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId",
      "parent": "/app/warehouse-receiving",
      "children": [
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout",
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in"
      ]
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/_layout.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId",
      "children": [
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments",
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders",
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads",
        "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/"
      ]
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId",
      "parent": "/app/warehouse-receiving",
      "children": [
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
      ]
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId",
      "children": [
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets",
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments",
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders",
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads",
        "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/"
      ]
    },
    "/app/procurement/_layout/supplier-report/new-supplier": {
      "filePath": "app/procurement/_layout.supplier-report.new-supplier.lazy.tsx",
      "parent": "/app/procurement/_layout/supplier-report"
    },
    "/app/admin/warehouses/$warehouseId/": {
      "filePath": "app/admin/warehouses/$warehouseId/index.ts",
      "parent": "/app/admin/warehouses/$warehouseId"
    },
    "/app/companies/$companyId/edit/": {
      "filePath": "app/companies/$companyId/edit/index.tsx",
      "parent": "/app/companies/$companyId/edit"
    },
    "/app/dashboard/_layout/pending-approvals/": {
      "filePath": "app/dashboard/_layout/pending-approvals/index.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals"
    },
    "/app/product/$productId/edit/": {
      "filePath": "app/product/$productId/edit/index.tsx",
      "parent": "/app/product/$productId/edit"
    },
    "/app/product/$productId/preference/": {
      "filePath": "app/product/$productId/preference/index.tsx",
      "parent": "/app"
    },
    "/app/companies/$companyId/edit/_layout/accounting": {
      "filePath": "app/companies/$companyId/edit/_layout.accounting.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/certification": {
      "filePath": "app/companies/$companyId/edit/_layout.certification.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/contacts": {
      "filePath": "app/companies/$companyId/edit/_layout.contacts.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/evaluation": {
      "filePath": "app/companies/$companyId/edit/_layout.evaluation.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/info": {
      "filePath": "app/companies/$companyId/edit/_layout.info.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/locations": {
      "filePath": "app/companies/$companyId/edit/_layout.locations.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout",
      "children": [
        "/app/companies/$companyId/edit/_layout/locations/$locationId"
      ]
    },
    "/app/companies/$companyId/edit/_layout/preferences": {
      "filePath": "app/companies/$companyId/edit/_layout.preferences.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/products": {
      "filePath": "app/companies/$companyId/edit/_layout.products.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/companies/$companyId/edit/_layout/registration": {
      "filePath": "app/companies/$companyId/edit/_layout.registration.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout"
    },
    "/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders": {
      "filePath": "app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders.route.tsx",
      "parent": "/app/orders/$companyId/$shipToLocationId/_layout"
    },
    "/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders": {
      "filePath": "app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders.route.tsx",
      "parent": "/app/orders/$companyId/$shipToLocationId/_layout"
    },
    "/app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders": {
      "filePath": "app/orders/$companyId/$shipToLocationId/_layout/open-sales-orders.route.tsx",
      "parent": "/app/orders/$companyId/$shipToLocationId/_layout"
    },
    "/app/product/$productId/edit/_layout/information": {
      "filePath": "app/product/$productId/edit/_layout/information.route.tsx",
      "parent": "/app/product/$productId/edit/_layout"
    },
    "/app/product/$productId/edit/_layout/instructions": {
      "filePath": "app/product/$productId/edit/_layout/instructions.route.tsx",
      "parent": "/app/product/$productId/edit/_layout"
    },
    "/app/product/$productId/edit/_layout/regulatory": {
      "filePath": "app/product/$productId/edit/_layout/regulatory.route.tsx",
      "parent": "/app/product/$productId/edit/_layout"
    },
    "/app/product/$productId/edit/_layout/storage": {
      "filePath": "app/product/$productId/edit/_layout/storage.route.tsx",
      "parent": "/app/product/$productId/edit/_layout"
    },
    "/app/admin/warehouses/$warehouseId/_layout/info": {
      "filePath": "app/admin/warehouses/$warehouseId/_layout.info.tsx",
      "parent": "/app/admin/warehouses/$warehouseId/_layout"
    },
    "/app/admin/warehouses/$warehouseId/_layout/shelving": {
      "filePath": "app/admin/warehouses/$warehouseId/_layout.shelving.tsx",
      "parent": "/app/admin/warehouses/$warehouseId/_layout"
    },
    "/app/dashboard/_layout/pending-approvals/_layout/price": {
      "filePath": "app/dashboard/_layout/pending-approvals/_layout/price.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals/_layout"
    },
    "/app/dashboard/_layout/pending-approvals/_layout/quality": {
      "filePath": "app/dashboard/_layout/pending-approvals/_layout/quality.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals/_layout"
    },
    "/app/dashboard/_layout/pending-approvals/_layout/sample": {
      "filePath": "app/dashboard/_layout/pending-approvals/_layout/sample.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals/_layout"
    },
    "/app/dashboard/_layout/pending-approvals/_layout/source-change": {
      "filePath": "app/dashboard/_layout/pending-approvals/_layout/source-change.tsx",
      "parent": "/app/dashboard/_layout/pending-approvals/_layout"
    },
    "/app/inventory/products/$productId/_layout/lots": {
      "filePath": "app/inventory/products/$productId/_layout/lots.tsx",
      "parent": "/app/inventory/products/$productId/_layout"
    },
    "/app/inventory/products/$productId/_layout/pallets": {
      "filePath": "app/inventory/products/$productId/_layout/pallets.tsx",
      "parent": "/app/inventory/products/$productId/_layout"
    },
    "/app/inventory/products/$productId/_layout/transactions": {
      "filePath": "app/inventory/products/$productId/_layout/transactions.tsx",
      "parent": "/app/inventory/products/$productId/_layout"
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId",
      "parent": "/app/tablet/warehouse-receiving",
      "children": [
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
      ]
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout.tsx",
      "parent": "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId",
      "children": [
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets",
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments",
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders",
        "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/"
      ]
    },
    "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId": {
      "filePath": "app/tablet/warehouse-receiving/incoming/$goodsReceiptId",
      "parent": "/app/tablet/warehouse-receiving",
      "children": [
        "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout"
      ]
    },
    "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout": {
      "filePath": "app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout.tsx",
      "parent": "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId",
      "children": [
        "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments",
        "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders",
        "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/"
      ]
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId",
      "parent": "/app/tablet/warehouse-receiving",
      "children": [
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout",
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in"
      ]
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout.tsx",
      "parent": "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId",
      "children": [
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments",
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders",
        "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/"
      ]
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in.tsx",
      "parent": "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/uploads.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId/_layout/uploads.tsx",
      "parent": "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout/uploads.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
    },
    "/app/orders/$companyId/$shipToLocationId/_layout/": {
      "filePath": "app/orders/$companyId/$shipToLocationId/_layout/index.route.tsx",
      "parent": "/app/orders/$companyId/$shipToLocationId/_layout"
    },
    "/app/inventory/products/$productId/_layout/": {
      "filePath": "app/inventory/products/$productId/_layout/index.tsx",
      "parent": "/app/inventory/products/$productId/_layout"
    },
    "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/": {
      "filePath": "app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/": {
      "filePath": "app/warehouse-receiving/incoming/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/": {
      "filePath": "app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/warehouse-receiving/stored/$goodsReceiptId/_layout/": {
      "filePath": "app/warehouse-receiving/stored/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/warehouse-receiving/stored/$goodsReceiptId/_layout"
    },
    "/app/companies/$companyId/edit/_layout/locations/$locationId": {
      "filePath": "app/companies/$companyId/edit/_layout.locations.$locationId.route.tsx",
      "parent": "/app/companies/$companyId/edit/_layout/locations"
    },
    "/app/product/$productId/edit/_layout/costs": {
      "filePath": "app/product/$productId/edit/_layout/costs",
      "parent": "/app/product/$productId/edit/_layout",
      "children": [
        "/app/product/$productId/edit/_layout/costs/_layout",
        "/app/product/$productId/edit/_layout/costs/"
      ]
    },
    "/app/product/$productId/edit/_layout/costs/_layout": {
      "filePath": "app/product/$productId/edit/_layout/costs/_layout.tsx",
      "parent": "/app/product/$productId/edit/_layout/costs",
      "children": [
        "/app/product/$productId/edit/_layout/costs/_layout/laid-down",
        "/app/product/$productId/edit/_layout/costs/_layout/purchase-costs"
      ]
    },
    "/app/product/$productId/edit/_layout/quality": {
      "filePath": "app/product/$productId/edit/_layout/quality",
      "parent": "/app/product/$productId/edit/_layout",
      "children": [
        "/app/product/$productId/edit/_layout/quality/_layout",
        "/app/product/$productId/edit/_layout/quality/"
      ]
    },
    "/app/product/$productId/edit/_layout/quality/_layout": {
      "filePath": "app/product/$productId/edit/_layout/quality/_layout.tsx",
      "parent": "/app/product/$productId/edit/_layout/quality",
      "children": [
        "/app/product/$productId/edit/_layout/quality/_layout/results",
        "/app/product/$productId/edit/_layout/quality/_layout/templates"
      ]
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets.tsx",
      "parent": "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments": {
      "filePath": "app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments.tsx",
      "parent": "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/purchase-orders.tsx",
      "parent": "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/product/$productId/edit/_layout/costs/": {
      "filePath": "app/product/$productId/edit/_layout/costs/index.tsx",
      "parent": "/app/product/$productId/edit/_layout/costs"
    },
    "/app/product/$productId/edit/_layout/quality/": {
      "filePath": "app/product/$productId/edit/_layout/quality/index.tsx",
      "parent": "/app/product/$productId/edit/_layout/quality"
    },
    "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/": {
      "filePath": "app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/": {
      "filePath": "app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout"
    },
    "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/": {
      "filePath": "app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout/index.tsx",
      "parent": "/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/_layout"
    },
    "/app/product/$productId/edit/_layout/costs/_layout/laid-down": {
      "filePath": "app/product/$productId/edit/_layout/costs/_layout/laid-down.route.tsx",
      "parent": "/app/product/$productId/edit/_layout/costs/_layout"
    },
    "/app/product/$productId/edit/_layout/costs/_layout/purchase-costs": {
      "filePath": "app/product/$productId/edit/_layout/costs/_layout/purchase-costs.route.tsx",
      "parent": "/app/product/$productId/edit/_layout/costs/_layout"
    },
    "/app/product/$productId/edit/_layout/quality/_layout/results": {
      "filePath": "app/product/$productId/edit/_layout/quality/_layout/results.route.tsx",
      "parent": "/app/product/$productId/edit/_layout/quality/_layout"
    },
    "/app/product/$productId/edit/_layout/quality/_layout/templates": {
      "filePath": "app/product/$productId/edit/_layout/quality/_layout/templates.route.tsx",
      "parent": "/app/product/$productId/edit/_layout/quality/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
